/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (options) {
  var mappedProps = options.mappedProps,
      name = options.name,
      ctr = options.ctr,
      ctrArgs = options.ctrArgs,
      events = options.events,
      beforeCreate = options.beforeCreate,
      afterCreate = options.afterCreate,
      props = options.props,
      rest = _objectWithoutProperties(options, ['mappedProps', 'name', 'ctr', 'ctrArgs', 'events', 'beforeCreate', 'afterCreate', 'props']);

  var promiseName = '$' + name + 'Promise';
  var instanceName = '$' + name + 'Object';

  assert(!(rest.props instanceof Array), '`props` should be an object, not Array');

  return _extends({}, typeof GENERATE_DOC !== 'undefined' ? { $vgmOptions: options } : {}, {
    mixins: [_mapElementMixin2.default],
    props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
    render: function render() {
      return '';
    },
    provide: function provide() {
      var _this = this;

      var promise = this.$mapPromise.then(function (map) {
        // Infowindow needs this to be immediately available
        _this.$map = map;

        // Initialize the maps with the given options
        var options = _extends({}, _this.options, {
          map: map
        }, (0, _bindProps.getPropsValues)(_this, mappedProps));
        delete options.options; // delete the extra options

        if (beforeCreate) {
          var result = beforeCreate.bind(_this)(options);

          if (result instanceof Promise) {
            return result.then(function () {
              return { options: options };
            });
          }
        }
        return { options: options };
      }).then(function (_ref) {
        var _Function$prototype$b;

        var options = _ref.options;

        var ConstructorObject = ctr();
        // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
        _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [ConstructorObject, null].concat(_toConsumableArray(ctrArgs(options, (0, _bindProps.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);

        (0, _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
        (0, _bindEvents2.default)(_this, _this[instanceName], events);

        if (afterCreate) {
          afterCreate.bind(_this)(_this[instanceName]);
        }
        return _this[instanceName];
      });
      this[promiseName] = promise;
      return _defineProperty({}, promiseName, promise);
    },
    destroyed: function destroyed() {
      // Note: not all Google Maps components support maps
      if (this[instanceName] && this[instanceName].setMap) {
        this[instanceName].setMap(null);
      }
    }
  }, rest);
};

exports.mappedPropsToVueProps = mappedPropsToVueProps;

var _bindEvents = __webpack_require__(6);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(4);

var _mapElementMixin = __webpack_require__(11);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */


function assert(v, message) {
  if (!v) throw new Error(message);
}

/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */
function mappedPropsToVueProps(mappedProps) {
  return Object.entries(mappedProps).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        prop = _ref4[1];

    var value = {};

    if ('type' in prop) value.type = prop.type;
    if ('default' in prop) value.default = prop.default;
    if ('required' in prop) value.required = prop.required;

    return [key, value];
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        val = _ref6[1];

    acc[key] = val;
    return acc;
  }, {});
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(49)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsValues = getPropsValues;
exports.bindProps = bindProps;

var _WatchPrimitiveProperties = __webpack_require__(7);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getPropsValues(vueInst, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (vueInst[prop] !== undefined) {
      acc[prop] = vueInst[prop];
    }
    return acc;
  }, {});
}

/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */
function bindProps(vueInst, googleMapsInst, props) {
  var _loop = function (attribute) {
    var _props$attribute = props[attribute],
        twoWay = _props$attribute.twoWay,
        type = _props$attribute.type,
        trackProperties = _props$attribute.trackProperties,
        noBind = _props$attribute.noBind;


    if (noBind) return 'continue';

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueInst[attribute];

    if (typeof googleMapsInst[setMethodName] === 'undefined') {
      throw new Error(setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueInst.$options._componentTag);
    }

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueInst.$watch(attribute, function () {
        var attributeValue = vueInst[attribute];

        googleMapsInst[setMethodName](attributeValue);
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else {
      (0, _WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function (prop) {
        return attribute + '.' + prop;
      }), function () {
        googleMapsInst[setMethodName](vueInst[attribute]);
      }, vueInst[attribute] !== undefined);
    }

    if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) {
      googleMapsInst.addListener(eventName, function () {
        // eslint-disable-line no-unused-vars
        vueInst.$emit(eventName, googleMapsInst[getMethodName]());
      });
    }
  };

  for (var attribute in props) {
    var _ret = _loop(attribute);

    if (_ret === 'continue') continue;
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (vueInst, googleMapsInst, events) {
  var _loop = function (eventName) {
    if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) {
      googleMapsInst.addListener(eventName, function (ev) {
        vueInst.$emit(eventName, ev);
      });
    }
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */
function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
  var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var isHandled = false;

  function requestHandle() {
    if (!isHandled) {
      isHandled = true;
      vueInst.$nextTick(function () {
        isHandled = false;
        handler();
      });
    }
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var prop = _step.value;

      vueInst.$watch(prop, requestHandle, { immediate: immediate });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["default"] = (EventBus);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5), __webpack_require__(30).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {
  inject: {
    '$mapPromise': { default: 'abcdef' }
  },

  provide: function provide() {
    var _this = this;

    // Note: although this mixin is not "providing" anything,
    // components' expect the `$map` property to be present on the component.
    // In order for that to happen, this mixin must intercept the $mapPromise
    // .then(() =>) first before its component does so.
    //
    // Since a provide() on a mixin is executed before a provide() on the
    // component, putting this code in provide() ensures that the $map is
    // already set by the time the
    // component's provide() is called.
    this.$mapPromise.then(function (map) {
      _this.$map = map;
    });

    return {};
  }
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(44)));

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(50)));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
function TwoWayBindingWrapper(fn) {
  var counter = 0;

  fn(function () {
    counter += 1;
  }, function () {
    counter = Math.max(0, counter - 1);
  }, function () {
    return counter === 0;
  });
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(55)));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bindProps = __webpack_require__(4);

var _simulateArrowDown = __webpack_require__(17);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    this.$gmapApiPromiseLazy().then(function () {
      var options = (0, _bindProps.getPropsValues)(_this, props);
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);

      var placeholder = props.placeholder,
          place = props.place,
          defaultPlace = props.defaultPlace,
          className = props.className,
          label = props.label,
          selectFirstOnEnter = props.selectFirstOnEnter,
          rest = _objectWithoutProperties(props, ['placeholder', 'place', 'defaultPlace', 'className', 'label', 'selectFirstOnEnter']); // eslint-disable-line


      (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); // eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type === 'keydown') {
      var origListener = listener;
      listener = function (event) {
        var suggestionSelected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which === 13 && !suggestionSelected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          origListener.apply(input, [simulatedEvent]);
        }
        origListener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(60)));

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_objectList_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_objectMap_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_objectFilter_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__check_consent__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_ccm__ = __webpack_require__(85);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Imports






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GeoWerft",
  components: {
    "object-list": __WEBPACK_IMPORTED_MODULE_0__components_objectList_vue__["a" /* default */],
    "object-map": __WEBPACK_IMPORTED_MODULE_1__components_objectMap_vue__["a" /* default */],
    "object-filter": __WEBPACK_IMPORTED_MODULE_2__components_objectFilter_vue__["a" /* default */]
  },
  data: function data() {
    return {
      geoWerftData: {
        objects: {
          all: [],
          filtered: [],
          visible: [],
          listed: []
        },
        cookie_bot: window.Cookiebot || false,
        map_enabled: Object(__WEBPACK_IMPORTED_MODULE_3__check_consent__["a" /* default */])() === true || false !== (window.Cookiebot || false) && true === window.Cookiebot.consent.marketing || true === Object(__WEBPACK_IMPORTED_MODULE_4__check_ccm__["a" /* default */])(),
        map: {
          bound: {
            northEast: {
              lat: null,
              lng: null
            },
            southWest: {
              lat: null,
              lng: null
            }
          },
          center: {
            lat: 50.87071,
            lng: 6.9750813
          },
          zoom: 10,
          maxZoom: 21,
          zoom_types: [],
          markers: [],
          no_cluster_markers: [],
          map_type_id: "roadmap",
          map_touch_mode: "cooperative",
          map_zoom_control: true
        },
        cluster_font_weight: 400,
        currentMarker: null,
        search: "",
        source_url: "",
        page_count: 50,
        media_url: "",
        filialien_url: "",
        source_api: "",
        estate_agent_email_filter: "",
        image_placeholder_secret: "",
        image_placeholder_empty: "",
        image_placeholder_house_prep: "",
        image_placeholder_flat_prep: "",
        image_placeholder_plot_prep: "",
        image_placeholder_invest_prep: "",
        image_placeholder_market_watch: "",
        image_placeholder_market_watch_house: "",
        image_placeholder_market_watch_flat: "",
        image_placeholder_market_watch_plot: "",
        custom_loading_icon: "",
        geowerft_immo_loading: true,
        geowerft_no_props_from_route: false,
        additional_content: {
          geowerft_additional_info_box: false,
          geowerft_additional_info_box_template: ""
        },
        checkboxes: {
          display_tour_icon: false,
          display_ges_flaeche: false,
          show_price_in_paginated_info_window: false,
          show_map_satellite_switch: false,
          picture_click_always_active: false,
          user_has_searchwish: false,
          prop_offline_include_overlay: false,
          prop_offline_single_overlay: false,
          display_google_search: false,
          display_custom_pin_in_list: false,
          format_prices_cb: false,
          show_price_prop_sold: false,
          show_in_prep_banner: false,
          show_price_prop_referenz: false,
          show_loading_icon: false,
          other_info_window: false,
          other_info_window_v2: false,
          show_geo_as_fallback: false,
          display_prep_price: false,
          display_extra_commision_info: false,
          display_sorce_in_market_watch: false,
          display_picture_max_width_or_height: true,
          enable_filialen_mode: false,
          list_map_switcher: false,
          display_marketing_method: false,
          select_cluster_active: false,
          secret_bar_active: false,
          show_ground_fl_for_house_in_list: false,
          custom_marketwatch_temp_active: false,
          next_pin_active: false,
          set_geolocation: false,
          enable_tutorial: false,
          advanced_list_view: false,
          logged_in_market_watch: false,
          picture_click_active: false,
          enable_market_watch_ajax: false,
          allow_prop_offline_detection: false,
          allow_prop_offline_detection_only_logged_in: false,
          exclude_in_closest_prop: false,
          hide_picture_shadow: false,
          show_more_info_in_list: false,
          show_warmmiete: false,
          fill_prop_types_to_invest: false,
          display_plz_in_object_place: false,
          display_kennung_in_object_place: false
        },
        texts: {
          currency_suffix: "€",
          autocomplete_placeholder: "",
          fill_prop_types_to_invest_list: "",
          auction_popup_picture: "",
          label_flaeche_list_view: "Fläche",
          label_bezug_ab_map_view: "Bezug ab: ",
          mietpreis_pro_qm_pre: "",
          info_window_obj_nr: "Objekt Nr.:",
          mietpreis_pro_qm_post: "",
          wp_nonce: "",
          prop_offline_tutorial_text: "",
          prop_offline_picture: "",
          prop_offline_success_text: "",
          prop_offline_explain_text: "",
          prop_offline_akt_kind: "",
          prop_offline_akt_type: "",
          prop_offline_hp_status: "",
          exclude_in_closest_prop_status: "",
          display_text_price_rent: "",
          display_text_price_purchase: "",
          display_text_no_buyer_comission: "",
          display_extra_banderole: "",
          no_immo_in_bounds_text: "",
          no_immo_in_bounds_text_list_view: "",
          prop_loading_text: "",
          market_watch_name: "",
          prop_own_source_text: "",
          select_cluster_hp_to_show: "",
          not_in_scope_text: "",
          map_h1: "",
          sc_plz: "",
          sc_geolage: "",
          label_details: "",
          secret_bar_register_link: "",
          secret_sale_headline: "",
          secret_sale_sub_text: "",
          secret_sale_button: "",
          blur_hp_status_name: "",
          text_next_pin_prop: "",
          text_button_next_pin_prop: "",
          text_filter_next_pin_prop: "",
          text_next_pin_ppl: "",
          text_button_next_pin_ppl: "",
          text_sc_info_text: "",
          consent_text_normal: "",
          consent_button_label: "",
          zoom_out_type: "",
          tutorial_text_one: "",
          tutorial_text_two: "",
          tutorial_text_three: "",
          market_watch_alt_link: "",
          ajax_url: "",
          market_watch_akt_kind: "",
          market_watch_akt_type: "",
          banner_picture_link_second: "",
          banner_picture_src_second: "",
          geo_banner_picture_link: "",
          geo_banner_picture_src: "",
          geo_banner_picture_src_list: "",
          geo_banner_custom_html: "",
          banner_mobile_first_link: "",
          banner_mobile_first_px: "768",
          banner_mobile_second_link: "",
          banner_mobile_second_px: "768",
          filter_label_price: "",
          filter_adults_label: "Erwachsene",
          filter_children_label: "Kinder",
          filter_label_price_buy: "",
          filter_label_price_rent: "",
          filter_label_space: "",
          filter_label_rooms: "",
          filter_space_label_house: "",
          filter_space_label_grundstueck: "",
          filter_space_label_gewerbe: "",
          filter_space_label_invest: "",
          filter_space_label_house_max_extension: "",
          filter_space_label_grundstueck_max_extension: "",
          filter_space_label_gewerbe_max_extension: "",
          filter_space_label_invest_max_extension: "",
          custom_pre_filter_label_von: "",
          custom_pre_filter_label_bis: "",
          use_buero_for_business_space: "false",
          reload_secret_sale_price_for_logged_in: "false",
          no_prop_in_route_text: "",
          diff_extern_link: "",
          list_visibility_json: ""
        },
        customimages: {
          tutorial_picture_one: "",
          tutorial_picture_two: "",
          tutorial_picture_three: "",
          tour_icon_src: ""
        },
        marker_image: {
          google_maps_marker_online: "",
          google_maps_marker_in_vorbereitung: "",
          google_maps_marker_marktbeobachtung: "",
          google_maps_marker_verkauft: "",
          google_maps_marker_referenz: "",
          google_maps_marker_secret_sale: "",
          google_maps_marker_neubauobjekt: "",
          google_maps_marker_neubaureferenz: "",
          google_maps_marker_exlusive_object: "",
          google_maps_marker_badge_new: "",
          google_maps_marker_auction: "",
          google_maps_marker_mietboerse: "",
          google_maps_marker_immobiliendepot: "",
          google_maps_marker_default: ""
        },
        map_settings: {
          google_search_zoom_level: 18
        },
        custom_map_style: "",
        current_map_mode: "map",
        list_item_limit: 200,
        list_item_limit_old: 0,
        hasError: false,
        show_cluster: false,
        show_cluster_no_pictures: true,
        cluster_break_zoom: 15,
        cluster_pin_near: "",
        cluster_pin_far: "",
        show_sold_banner: false,
        step_num_kauf: 100000,
        step_num_miete: 50,
        display_step: 50,
        steps_rooms: 1,
        steps_space: 50,
        steps_living_space: 50,
        steps_plot_space: 100,
        auction_list_label: "Bieterverfahren",
        geowerft_setting_watchlist_icon: false,
        geowerft_setting_watchlist_icon_custom: "",
        show_einheiten_in_list: false,
        geowerft_gtb_active: false,
        use_img_tag_in_list: false,
        geowerft_gtb_watchlist_active: false,
        geowerft_gtb_watchlist_active_detailed: false,
        geowerft_gtb_watchlist_rest: "",
        show_prov_free_banner: false,
        show_extern_link: false,
        secret_bar_max_count: 0,
        //is_loading: false,
        filter: [],
        user: {
          logged_in: false,
          has_dsn: false,
          current_user_id: 0,
          user_fully_logged_in: false,
          link_for_logged_in_only: false,
          link_for_logged_in_only_url: "/mein-konto",
          link_for_logged_in_only_label: "Bitte einloggen"
        },
        extra_class: "mw-geowerft-multiple-selects",
        extra_class_nums: "mw-geowerft-multiple-selects-nums",
        kennung_filter_caption: "Kennung",
        energie_filter_caption: "Energieeffizienz",
        kennung_filter_placeholder: "Kennung eingeben",
        energie_filter_placeholder: "Energieeffizienz wählen",
        prop_watchlist_active: false,
        prop_watchlist_offline_mode: false,
        user_watchlist: "",
        user_watchlist_detailed: "",
        user_blacklist: "",
        user_blacklist_icon: "",
        geo_display_objecttype: false,
        filialen_landingpage_label: "Zum Immobilien-Profi",
        filialen_success_story_label: "Zur Success-Story",
        geo_business_mode: false,
        geo_business_mode_bueroflaeche: false,
        watchlist_to_hide_hp: "",
        watchlist_to_hide_vermarktung: "",
        array_container: [],
        interactive_filter_active: false,
        show_dialog_filter: [],
        show_more_filter: [],
        enable_comfort_zoom: false,
        enable_blacklist: false,
        display_map_list_switch: false,
        price_on_request_cb: false,
        enable_class_for_diff_view: false,
        extra_map_css_class: "",
        marketwatch_extern_links_hp: [],
        reset_bounds: false,
        reset_bounds_label: "Auf Anfang",
        list_view_config: {},
        show_more_filter_close_btn_label: "Filter anwenden",
        enable_ai_quick_chat: false,
        enable_ai_quick_chat_custom: "",
        ai_quick_label: "",
        ai_quick_placeholder: "",
        ai_quick_svg: "",
        ai_load_img: "",
        ai_load_img_pre: "",
        ai_load_img_after: "",
        ai_load_text: ""
      }
    };
  },

  computed: {
    allObjects: function allObjects() {
      return this.geoWerftData.objects.all;
    },
    filteredObjects: function filteredObjects() {
      var _this = this;

      return this.allObjects.filter(function (object) {
        // Wenn der Filialien Modus an ist alles durch lassen.
        if (_this.geoWerftData.checkboxes.enable_filialen_mode) {
          return true;
        }

        // Set default - show object
        var result = true;
        var filter_invalid = false;

        for (var key in _this.geoWerftData.filter) {
          if (true === filter_invalid) {
            break;
          }

          // Skip filter if the property is from prototype
          if (!_this.geoWerftData.filter.hasOwnProperty(key)) {
            continue;
          }

          // The filter to check
          var filter = _this.geoWerftData.filter[key];

          // Neue Filter methode verwenden.
          if (true === _this.geoWerftData.interactive_filter_active) {
            var _ret = function () {
              // Wichtig, bevor die Filter wirken können, muss geprüft werden, ob bestimmte requirements getroffen sind.
              var arr_requirements = filter.requires || [];
              var tmp_require_check_value = void 0;
              var bool_skip_filter = false;
              var arr_requirements_size = Object.keys(arr_requirements).length;
              if (arr_requirements_size >= 1) {
                var _loop = function _loop(tmp_key, tmp_arr_values) {
                  tmp_require_check_value = _this.geoWerftData.filter[tmp_key] || [];
                  tmp_require_check_value = tmp_require_check_value.value || "";
                  if ("" === tmp_require_check_value || !Array.isArray(tmp_require_check_value) && !tmp_arr_values.includes(tmp_require_check_value) || Array.isArray(tmp_require_check_value) && !tmp_require_check_value.some(function (val) {
                    return tmp_arr_values.includes(val);
                  })) {
                    bool_skip_filter = true;
                    // Aktuellen Filter leeren, falls dieser verwendet wurde.
                    if (Array.isArray(filter.value)) {
                      filter.value = [];
                    } else {
                      filter.value = "";
                    }
                  }
                };

                // Hier nun prüfen, welche requirements gegeben sind.
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = Object.entries(arr_requirements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = _slicedToArray(_ref, 2);

                    var tmp_key = _ref2[0];
                    var tmp_arr_values = _ref2[1];

                    _loop(tmp_key, tmp_arr_values);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }

              if (bool_skip_filter) {
                // requirements sind nicht gegeben, also den Filter nicht berücksichtigen.
                return "continue";
              }

              var current_compare_mode = filter.compare || "=";
              var working_key = String(key).replace("_from", "").replace("_to", "");
              var current_prop_value = (object[working_key] || "").toLowerCase().replace("buy", "kauf").replace("rent", "miete");
              var filter_is_empty = 0 === filter.value.length;
              var tmp_value_for_check = filter.value || "";
              var alternative_compare_array = [];
              var possible_compare_main = filter.compare_array || [];
              // Anpassung für Array Werte
              if (Array.isArray(tmp_value_for_check) && tmp_value_for_check.length > 1) {
                alternative_compare_array = [];
                tmp_value_for_check.forEach(function (selected_value) {
                  if (Array.isArray(possible_compare_main[selected_value])) {
                    var _alternative_compare_;

                    (_alternative_compare_ = alternative_compare_array).push.apply(_alternative_compare_, _toConsumableArray(possible_compare_main[selected_value] || []));
                  }
                });
              } else {
                alternative_compare_array = possible_compare_main[tmp_value_for_check] || [];
              }

              switch (current_compare_mode) {
                case "contains":
                  if (false === filter_is_empty) {
                    if (Array.isArray(filter.value)) {
                      filter.value.forEach(function (single_value) {
                        var tmp_regex = new RegExp(single_value.toLowerCase());
                        if (false === tmp_regex.test(current_prop_value)) {
                          result = false;
                          filter_invalid = true;
                        }
                      });
                    } else {
                      var tmp_regex = new RegExp(filter.value.toLowerCase());
                      if (false === tmp_regex.test(current_prop_value)) {
                        result = false;
                        filter_invalid = true;
                      }
                    }
                  }
                  break;
                case "instr":
                  if (false === filter_is_empty && -1 === current_prop_value.indexOf(filter.value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "IN":
                  var tmp_compare_arr = filter.value;
                  if (alternative_compare_array.length > 1) {
                    tmp_compare_arr = alternative_compare_array;
                  }

                  // Sonderfall für Energieausweis hinzufügen.
                  if ("epass_wertklasse" === working_key && "" === current_prop_value) {
                    current_prop_value = "h";
                  }

                  if (false === filter_is_empty && false === tmp_compare_arr.includes(current_prop_value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "INCONTAINS":
                  var tmp_compare_arr_alt = filter.value;
                  if (alternative_compare_array.length > 1) {
                    tmp_compare_arr_alt = alternative_compare_array;
                  }
                  // Prop Values Arr
                  var curr_prop_values_arr = current_prop_value.split(",").map(function (item) {
                    return item.trim();
                  });
                  var found_one = false;
                  tmp_compare_arr_alt.forEach(function (single_value) {
                    curr_prop_values_arr.forEach(function (single_prop_value) {
                      if (single_value.toLowerCase() === single_prop_value.toLowerCase()) {
                        found_one = true;
                      }
                    });
                  });

                  if (false === filter_is_empty && false === found_one) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "=":
                  if (false === filter_is_empty && filter.value !== current_prop_value) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "buildyear_from":
                  if (false === filter_is_empty && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") > parseInt(current_prop_value) && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") !== parseInt(current_prop_value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "buildyear_to":
                  if (false === filter_is_empty && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") < parseInt(current_prop_value) && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") !== parseInt(current_prop_value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case "<=":
                  if (false === filter_is_empty && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") < parseFloat(current_prop_value) && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") !== parseFloat(current_prop_value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
                case ">=":
                  if (false === filter_is_empty && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") > parseFloat(current_prop_value) && _this.mw_interactive_remove_currency_and_not_working_chars(filter.value, filter.format || "") !== parseFloat(current_prop_value)) {
                    result = false;
                    filter_invalid = true;
                  }
                  break;
              }
            }();

            if (_ret === "continue") continue;
          } else {
            // Alte Filter variante.
            if (_typeof(filter.value) === "object") {
              // Filter with min and max

              // Get the min limit
              var min = parseFloat(filter.value.min);
              // Check if a automatic limit is needed
              if (isNaN(min)) {
                min = 0;
              }
              // Get the max limit
              var max = parseFloat(filter.value.max);
              // Check if a automatic limit is needed
              if (isNaN(max)) {
                max = Infinity;
              }

              // Go to right filter
              switch (String(key)) {
                case "adults":
                  _this.geoWerftData.display_step = _this.geoWerftData.step_num_kauf;
                  var current_count = 0;
                  if (object.count_adults) {
                    current_count = parseInt(object.count_adults);
                  }
                  if (current_count < min || current_count > max) {
                    result = false;
                  }
                  break;
                case "children":
                  _this.geoWerftData.display_step = _this.geoWerftData.step_num_kauf;
                  var current_count_childs = 0;
                  if (object.count_childs) {
                    current_count_childs = parseInt(object.count_childs);
                  }
                  if (current_count_childs < min || current_count_childs > max) {
                    result = false;
                  }
                  break;
                case "price":
                  // Set default price
                  var object_price = "";
                  // Try to find the sale price
                  if (_this.geoWerftData.filter["acquisition"].value == "miete" || _this.geoWerftData.filter["acquisition"].value == "rent") {
                    // Try to find the rental price
                    if (typeof object.nettokaltmiete !== "undefined" && 0 !== object.nettokaltmiete.length) {
                      object_price = parseInt(object.nettokaltmiete);
                    }
                    if ("" === object_price && typeof object.mietpreis_pro_qm !== "undefined" && 0 !== object.mietpreis_pro_qm.length) {
                      object_price = parseInt(object.mietpreis_pro_qm);
                    }
                  } else {
                    if (typeof object.kaufpreis !== "undefined" && 0 !== object.kaufpreis.length) {
                      object_price = parseInt(object.kaufpreis);
                    }
                  }

                  // Check if price is between min and max value
                  if ("" !== object_price && (object_price < min || object_price > max)) {
                    result = false;
                    break;
                  }
                  break;
                case "rooms":
                  var compare_rooms_field = void 0;
                  switch (_this.geoWerftData.filter["objecttype"].value) {
                    case "house":
                      compare_rooms_field = object.wohnflaeche;
                      break;
                    case "plot":
                      compare_rooms_field = object.grundstuecksflaeche;
                      break;
                    case "business":
                      compare_rooms_field = object.gesamtflaeche;
                      if (object.bueroflaeche && "true" === _this.geoWerftData.use_buero_for_business_space) {
                        compare_rooms_field = object.bueroflaeche;
                      }
                      break;
                    case "investment":
                      compare_rooms_field = object.vermietbare_flaeche;
                      break;
                    default:
                      compare_rooms_field = object.anzahl_zimmer;
                      break;
                  }

                  var tmp_rooms = 0;
                  if (compare_rooms_field) {
                    tmp_rooms = parseFloat(compare_rooms_field.replace(",", "."));
                  }
                  if (isNaN(tmp_rooms)) {
                    tmp_rooms = 0;
                  }

                  // Wenn der Gewerbe Modus aktiv ist und eine Teilbarkeit zum Objekt angegeben ist, dann wird die
                  // Teilbarkeit mit einberechnet.
                  if ("business" === _this.geoWerftData.filter["objecttype"].value) {
                    // Wenn keine Bürofläche im Objekt angegeben wurde dann diese auf 99999 setzten damit nach diesen
                    // immer noch gefiltert werden kann.
                    if (tmp_rooms === 0) {
                      tmp_rooms = 99999;
                    }
                    var tmp_teilbarkeit = Infinity;
                    if (object.teilbar_ab) {
                      tmp_teilbarkeit = parseFloat(object.teilbar_ab.replace(",", "."));
                    }
                    if (isNaN(tmp_teilbarkeit)) {
                      tmp_teilbarkeit = Infinity;
                    }
                    var bool_tmp_teil = tmp_teilbarkeit > max;
                    var bool_tmp_max = tmp_rooms > max;
                    var hide_current_prop = false;
                    if (bool_tmp_max === true) {
                      hide_current_prop = true;
                    }
                    if (bool_tmp_teil === false) {
                      hide_current_prop = false;
                    }
                    if (tmp_rooms < min || hide_current_prop === true) {
                      result = false;
                      break;
                    }
                    break;
                  }

                  if (tmp_rooms < min || tmp_rooms > max) {
                    result = false;
                    break;
                  }
                  break;
                default:
                  break;
              }
            } else {
              // Filter with drop-down
              switch (String(key)) {
                case "customfilter":
                  if (0 === filter.value.length) {
                    break;
                  }
                  // Prüfen, ob das Feld in der Immobilie existiert.
                  if (geowerftSettings.custom_compare_meta && object[geowerftSettings.custom_compare_meta] && object[geowerftSettings.custom_compare_meta] === "") {
                    result = false;
                    break;
                  }
                  if (filter.value !== object[geowerftSettings.custom_compare_meta]) {
                    result = false;
                    break;
                  }
                  break;
                case "acquisition":
                  // Check if a filter value was given
                  if (0 === filter.value.length) {
                    break;
                  }
                  // Check acquisitions
                  if (object.erwerbsart && "buy" === filter.value && object.erwerbsart.toLowerCase() !== "buy" && object.erwerbsart.toLowerCase() !== "kauf") {
                    _this.geoWerftData.display_step = _this.geoWerftData.step_num_kauf;
                    // Buying selected, but object is not fore sale
                    result = false;
                    break;
                  } else if (object.erwerbsart && "rent" === filter.value && object.erwerbsart.toLowerCase() !== "rent" && object.erwerbsart.toLowerCase() !== "miete") {
                    _this.geoWerftData.display_step = _this.geoWerftData.step_num_miete;
                    // Renting selected, but object is not for rent
                    result = false;
                    break;
                  }
                  break;
                case "objecttype":
                  // Check if the value can be worked with
                  if (!object.objektart_geowerft && !object.objektart_raw) {
                    result = false;
                    break;
                  }

                  var objektart_filter = object.objektart_geowerft || object.objektart_raw || "";
                  if (objektart_filter) {
                    objektart_filter = objektart_filter.toLowerCase();
                    objektart_filter = objektart_filter.replace("&#252;", "ü");
                    objektart_filter = objektart_filter.replace("&#228;", "ä");
                    objektart_filter = objektart_filter.replace("&#246;", "ö");
                  }

                  if ("buero_praxis" === filter.value || "einzelhandel" === filter.value || "lager_produktion" === filter.value) {
                    // Bei diesen übergaben, Objektart_raw bevorzugen.
                    objektart_filter = object.objektart_raw || object.objektart_geowerft || "";
                    objektart_filter = objektart_filter.toLowerCase();
                  }

                  var general_include = false;
                  for (var option_key in geowerftSettings.filter["objecttype"].options) {
                    if ("" === option_key.toString()) {
                      continue;
                    }
                    if (object.objekttyp && (option_key.toString() === "villa" || option_key.toString() === "rest")) {
                      objektart_filter = object.objekttyp.toLowerCase();
                    }

                    var _object_type_values = __webpack_require__(28)("./" + option_key.toString() + ".js");

                    // Hier noch in speziellen fällen weitere Objekttypen zumischen.
                    if (geowerftSettings.arr_additional_prop_type && geowerftSettings.arr_additional_prop_type[0] && geowerftSettings.arr_additional_prop_type[1]) {
                      if (geowerftSettings.arr_additional_prop_type[0] === option_key && !_object_type_values.includes(geowerftSettings.arr_additional_prop_type[1])) {
                        _object_type_values.push(geowerftSettings.arr_additional_prop_type[1]);
                      }
                    }

                    var _object_type_values_small = _object_type_values.map(function (x) {
                      return x.toLowerCase();
                    });
                    // Set the result var to false if no match found
                    if (true === _object_type_values_small.includes(objektart_filter)) {
                      general_include = true;
                      break;
                    }
                  }

                  if (false === general_include) {
                    result = false;
                    break;
                  }

                  // Check if a filter value was given
                  if (0 === filter.value.length) {
                    break;
                  }

                  // Get array of possible values
                  var object_type_values = __webpack_require__(28)("./" + filter.value + ".js");
                  var object_type_values_small = object_type_values.map(function (x) {
                    return x.toLowerCase();
                  });

                  // Wenn der Customizer an ist und das result auf false steht noch einmal mit dem Objekttypen versuchen.
                  if (object.objekttyp && "investment" === filter.value && true === _this.geoWerftData.checkboxes.fill_prop_types_to_invest && _this.geoWerftData.texts.fill_prop_types_to_invest_list.includes(object.objekttyp)) {
                    objektart_filter = "investment";
                  }

                  // Set the result var to false if no match found
                  if (false === object_type_values_small.includes(objektart_filter)) {
                    result = false;
                    break;
                  }
                  break;
                case "status":
                  // Check if the value can be worked with
                  if (!object.homepage_status) {
                    result = false;
                    break;
                  }

                  // Check if a status is given
                  if (0 !== filter.value.length && filter.value.toLowerCase() !== object.homepage_status.toLowerCase()) {
                    result = false;
                    break;
                  }
                  break;
                case "energie":
                  // Energieeffizienz aus dem Objekt lesen.
                  var current_value = object.epass_wertklasse || "";

                  switch (filter.value) {
                    case "A+":
                      if (!["A+"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "A":
                      if (!["A+", "A"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "B":
                      if (!["A+", "A", "B"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "C":
                      if (!["A+", "A", "B", "C"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "D":
                      if (!["A+", "A", "B", "C", "D"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "E":
                      if (!["A+", "A", "B", "C", "D", "E"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "F":
                      if (!["A+", "A", "B", "C", "D", "E", "F"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "G":
                      if (!["A+", "A", "B", "C", "D", "E", "F", "G"].includes(current_value)) {
                        result = false;
                      }
                      break;
                    case "H":
                      if (!["A+", "A", "B", "C", "D", "E", "F", "G", "H"].includes(current_value)) {
                        result = false;
                      }
                      break;
                  }

                  break;
                case "marketing":
                  // Check if the value can be worked with
                  if (!object.vermarktungsart) {
                    result = false;
                    break;
                  }

                  // Check if a status is given
                  if (0 !== filter.value.length && filter.value.toLowerCase() !== object.vermarktungsart.toLowerCase()) {
                    result = false;
                    break;
                  }
                  break;
                case "regio":
                  // Check if the value can be worked with
                  if (_this.geoWerftData.checkboxes.list_map_switcher) {
                    if (!object.geolage) {
                      result = false;
                      break;
                    }

                    // Check if a status is given
                    if (0 !== filter.value.length && filter.value.toLowerCase() !== object.geolage.toLowerCase()) {
                      result = false;
                      break;
                    }
                  }
                  break;
                case "kennung":
                  if (!object.kennung) {
                    result = false;
                    break;
                  }
                  if (0 !== filter.value.length && -1 === object.kennung.trim().indexOf(filter.value.trim())) {
                    result = false;
                    break;
                  }
                  break;
                case "checkbox_barriere":
                  if (filter.value && !(true === filter.value && object.barrierefrei === "1")) {
                    result = false;
                  }
                  break;
                case "checkbox_haustiere":
                  if (filter.value && !(true === filter.value && object.haustiere === "1")) {
                    result = false;
                  }
                  break;
                default:
                  break;
              }
            }
          }
        }

        // Return the filter result
        return result;
      });
    },
    visible0bjects: function visible0bjects() {
      var _this2 = this;

      if (false === this.geoWerftData.map_enabled) {
        return this.geoWerftData.objects.filtered;
      }
      return this.geoWerftData.objects.filtered.filter(function (object) {
        var minLat = Math.min.apply(Math, [_this2.geoWerftData.map.bound.northEast.lat, _this2.geoWerftData.map.bound.southWest.lat]),
            maxLat = Math.max.apply(Math, [_this2.geoWerftData.map.bound.northEast.lat, _this2.geoWerftData.map.bound.southWest.lat]),
            minLng = Math.min.apply(Math, [_this2.geoWerftData.map.bound.northEast.lng, _this2.geoWerftData.map.bound.southWest.lng]),
            maxLng = Math.max.apply(Math, [_this2.geoWerftData.map.bound.northEast.lng, _this2.geoWerftData.map.bound.southWest.lng]);

        return object.geo_latitude > minLat && object.geo_latitude < maxLat && object.geo_longitude > minLng && object.geo_longitude < maxLng;
      });
    }
  },
  watch: {
    allObjects: function allObjects(array) {
      // Call method to load images after the list objects got updated
    },
    filteredObjects: function filteredObjects(array) {
      this.geoWerftData.objects.filtered = array;
    },
    visible0bjects: function visible0bjects(array) {
      this.geoWerftData.objects.visible = array;
      if (false === this.geoWerftData.map_enabled || "list" === this.geoWerftData.current_map_mode) {
        this.geoWerftData.list_item_limit = 9999;
      } else {
        // Wert wieder auf den Anfangswert zurücksetzen.
        this.geoWerftData.list_item_limit = this.geoWerftData.list_item_limit_old;
      }
      // Limit the amount of items in the list
      this.geoWerftData.objects.listed = this.geoWerftData.objects.visible.slice(0, this.geoWerftData.list_item_limit);
    }
  },
  filters: {
    sanitize_title: function sanitize_title(value) {
      if (!value) {
        return "";
      }
      return value.replace(/\s+/g, "-").toLowerCase();
    }
  },
  methods: {
    applyExternalObjectsChange: function applyExternalObjectsChange(payload) {
      var type = payload && payload.type;
      var items = Array.isArray(payload.items) ? payload.items : [];
      var key = payload && payload.key;
      var values = Array.isArray(payload.values) ? payload.values : [];

      var current = this.geoWerftData.objects.all || [];

      switch (type) {
        case "replace":
          // komplette Ersetzung
          this.$set(this.geoWerftData.objects, "all", items.slice());
          break;
        case "append":
          // anhängen
          this.$set(this.geoWerftData.objects, "all", current.concat(items));
          break;
        case "prepend":
          // voranstellen
          this.$set(this.geoWerftData.objects, "all", items.concat(current));
          break;
        case "clear":
          // leeren
          this.$set(this.geoWerftData.objects, "all", []);
          break;
        case "removeBy":
          // Elemente entfernen, wenn der Wert von key in values enthalten ist
          if (key) {
            var next = current.filter(function (it) {
              return !values.includes(it[key]);
            });
            this.$set(this.geoWerftData.objects, "all", next);
          }
          break;
        case "updateBy":
          // Elemente anhand key mergen/aktualisieren (id-basiert o.ä.)
          if (key) {
            var map = new Map(current.map(function (it) {
              return [it[key], it];
            }));
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var incoming = _step2.value;

                var k = incoming && incoming[key];
                if (typeof k !== "undefined") {
                  var prev = map.get(k) || {};
                  map.set(k, _extends({}, prev, incoming));
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            this.$set(this.geoWerftData.objects, "all", Array.from(map.values()));
          }
          break;
        case "uniqueAppendBy":
          // nur neue (nicht vorhandene) anhand key anhängen
          if (key) {
            var existing = new Set(current.map(function (it) {
              return it[key];
            }));
            var toAdd = items.filter(function (it) {
              return !existing.has(it[key]);
            });
            this.$set(this.geoWerftData.objects, "all", current.concat(toAdd));
          }
          break;
        default:
          // Fallback: nichts tun
          break;
      }
    },
    get_props: function get_props(offset) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(_this3.geoWerftData.array_container.slice(offset, offset + parseInt(geowerftSettings.new_prop_data_per_load)));
                  }, parseInt(geowerftSettings.new_prop_data_load_time));
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    load_props: function load_props(offset) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(offset > parseInt(geowerftSettings.new_prop_data_max_count))) {
                  _context2.next = 3;
                  break;
                }

                _this4.geoWerftData.geowerft_immo_loading = false;
                return _context2.abrupt("return");

              case 3:
                that = _this4;

                _this4.get_props(offset).then(function (data) {
                  that.geoWerftData.objects.all = that.geoWerftData.objects.all.concat(data);
                  that.load_props(offset + parseInt(geowerftSettings.new_prop_data_per_load));
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    do_cookie_consent: function do_cookie_consent() {
      var cookie_bot = window.Cookiebot || "";
      if ("" !== cookie_bot) {
        cookie_bot.show();
      }
      if (window.CCM) {
        window.CCM.openWidget();
      }
    },
    get_consent_reset_class: function get_consent_reset_class() {
      var cookie_bot = window.Cookiebot || "";
      var consent_reset_class = "mw-consent-management-reset-button avia-cookie-info-btn";
      if ("" !== cookie_bot || window.CCM) {
        consent_reset_class = "mw-consent-management-reset-button ";
      }
      return consent_reset_class;
    },
    loadPoperties: function loadPoperties(url, current_page, max_pages, fetch_header) {
      if (current_page > max_pages) {
        this.geoWerftData.geowerft_immo_loading = false;
        return;
      }

      // Change the url parameter
      url.searchParams.set("page", current_page.toString());
      // Fire of the requests
      this.$http.get(url.href, fetch_header).then(function (data) {
        // Success handling - more pages
        // Add received objects to the objects array
        data.body = this.reload_secret_sale_price(data.body);
        this.geoWerftData.objects.all = this.geoWerftData.objects.all.concat(data.body);
        current_page += 1;
        this.loadPoperties(url, current_page, max_pages, fetch_header);
      }, function (data) {
        // Error handling - more pages
      });
    },
    wordwrap: function wordwrap(str, width, brk, cut) {
      brk = brk || "n";
      width = width || 75;
      cut = cut || false;

      if (!str) {
        return str;
      }

      var regex = ".{1," + width + "}(\s|$)" + (cut ? "|.{" + width + "}|.+$" : "|\S+?(\s|$)");

      return str.match(RegExp(regex, "g")).join(brk);
    },

    setSingleImage: function setSingleImage(imageObject) {
      var this_object = imageObject;
      // Check if an image has been set or is worked on
      if (typeof this_object.object_image_url === "undefined" && typeof this_object.image_search_running === "undefined") {
        // No image found or worked on
        // Set the loading status to prevent double requests
        this.$set(this_object, "image_search_running", true);

        this.$set(this_object, "currency_suffix", this.geoWerftData.texts.currency_suffix);
        this.$set(this_object, "display_text_price_rent", this.geoWerftData.texts.display_text_price_rent);
        this.$set(this_object, "display_text_price_purchase", this.geoWerftData.texts.display_text_price_purchase);
        this.$set(this_object, "display_text_no_buyer_comission", this.geoWerftData.texts.display_text_no_buyer_comission);
        this.$set(this_object, "display_extra_banderole", this.geoWerftData.texts.display_extra_banderole);
        this.$set(this_object, "prop_loading_text", this.geoWerftData.texts.prop_loading_text);
        this.$set(this_object, "not_in_scope_text", this.geoWerftData.texts.not_in_scope_text);
        // Google Suche anzeigen.
        this.$set(this_object, "display_google_search", this.geoWerftData.checkboxes.display_google_search);
        this.$set(this_object, "display_custom_pin_in_list", this.geoWerftData.checkboxes.display_custom_pin_in_list);
        // Marker Icons
        this.$set(this_object, "google_maps_marker_online", this.geoWerftData.marker_image.google_maps_marker_online);
        this.$set(this_object, "google_maps_marker_in_vorbereitung", this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung);
        this.$set(this_object, "google_maps_marker_marktbeobachtung", this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung);
        this.$set(this_object, "google_maps_marker_verkauft", this.geoWerftData.marker_image.google_maps_marker_verkauft);
        this.$set(this_object, "google_maps_marker_referenz", this.geoWerftData.marker_image.google_maps_marker_referenz);
        this.$set(this_object, "google_maps_marker_secret_sale", this.geoWerftData.marker_image.google_maps_marker_secret_sale);
        this.$set(this_object, "google_maps_marker_neubauobjekt", this.geoWerftData.marker_image.google_maps_marker_neubauobjekt);
        this.$set(this_object, "google_maps_marker_neubaureferenz", this.geoWerftData.marker_image.google_maps_marker_neubaureferenz);
        this.$set(this_object, "google_maps_marker_exlusive_object", this.geoWerftData.marker_image.google_maps_marker_exlusive_object);
        this.$set(this_object, "google_maps_marker_badge_new", this.geoWerftData.marker_image.google_maps_marker_badge_new);
        this.$set(this_object, "google_maps_marker_auction", this.geoWerftData.marker_image.google_maps_marker_auction);
        this.$set(this_object, "google_maps_marker_mietboerse", this.geoWerftData.marker_image.google_maps_marker_mietboerse);
        this.$set(this_object, "google_maps_marker_immobiliendepot", this.geoWerftData.marker_image.google_maps_marker_immobiliendepot);
        this.$set(this_object, "google_maps_marker_default", this.geoWerftData.marker_image.google_maps_marker_default);
        this.$set(this_object, "google_search_zoom_level", this.geoWerftData.marker_image.google_search_zoom_level);
        this.$set(this_object, "no_immo_in_bounds_text", this.geoWerftData.marker_image.no_immo_in_bounds_text);
        this.$set(this_object, "no_immo_in_bounds_text_list_view", this.geoWerftData.marker_image.no_immo_in_bounds_text_list_view);
        this.$set(this_object, "format_prices_cb", this.geoWerftData.checkboxes.format_prices_cb);

        // Check if the object in on secret sale and user is not logged in
        if (typeof this_object.homepage_status !== "undefined" && 0 !== this_object.homepage_status.length && "secret-sale" === this.$options.filters.sanitize_title(this_object.homepage_status) && !this.geoWerftData.user.logged_in) {
          // Set a generic image, because the user is not allowed to see a real image
          this.$set(this_object, "object_image_url", this.geoWerftData.image_placeholder_secret);
        } else if ("aktive-marktbeobachtung" === this.$options.filters.sanitize_title(this_object.homepage_status)) {
          this.$set(this_object, "object_image_url", this.geoWerftData.image_placeholder_market_watch);
        } else if (this.geoWerftData.show_cluster && this.geoWerftData.show_cluster_no_pictures) {
          var that = this;
          that.$set(this_object, "object_image_url", "");
        } else {
          if (this.geoWerftData.checkboxes.enable_filialen_mode) {
            var img = new Image();
            var _that = this;
            img.onload = function () {
              // Pre-loading done, set the image value to store
              _that.$set(this_object, "object_image_url", this_object.object_image_url);
            };
            // Add image url to pre-loading
            img.src = this_object.object_image_url;
          } else {
            var image_url = this_object.map_picture;
            // Prepare a pre-loading
            var _img = new Image();
            var _that2 = this;
            _img.onload = function () {
              // Pre-loading done, set the image value to store
              _that2.$set(this_object, "object_image_url", image_url);
            };
            // Add image url to pre-loading
            _img.src = image_url;
          }
        }
        // Set searching flag to false to prevent infinity loops
        this.$set(this_object, "image_search_running", false);
      }
    },
    mw_set_main_geo_class: function mw_set_main_geo_class() {
      var class_name = "geowerft-instant";
      if (true === this.geoWerftData.checkboxes.enable_filialen_mode) {
        class_name = class_name + " filialenwerft";
      }
      if (true === this.geoWerftData.enable_class_for_diff_view) {
        class_name = class_name + " erwerbsart-seperate";
      }
      if ("" !== this.geoWerftData.extra_map_css_class) {
        class_name = class_name + " " + this.geoWerftData.extra_map_css_class;
      }
      return class_name;
    },
    mw_interactive_remove_currency_and_not_working_chars: function mw_interactive_remove_currency_and_not_working_chars(curreny_string) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "currency";

      var numeric_string = "0";
      if ("number" === type) {
        numeric_string = curreny_string.replaceAll(",", ".");
      }
      if ("buildyear_from" === type || "buildyear_to" === type) {
        return parseInt(curreny_string);
      }
      if ("currency" === type || "area" === type) {
        numeric_string = curreny_string.replaceAll(",00", "").replaceAll(".", "");
      }
      return parseFloat(numeric_string);
    },

    reload_secret_sale_price: function reload_secret_sale_price(current_body) {
      // Hier wird geprüft welche Objekte Secret Sale sind und ob der Benutzer eingeloggt ist.
      // Dann mit der Ergebnisliste die Preise nachladen.
      if (true === this.geoWerftData.user.logged_in && true === this.geoWerftData.reload_secret_sale_price_for_logged_in) {
        var arr_index = [];
        for (var array_index in current_body) {
          if ("secret sale" === current_body[array_index]["homepage_status"].toLowerCase()) {
            arr_index.push({
              index: array_index,
              id: current_body[array_index]["id"]
            });
          }
        }
        if (arr_index) {
          // Hier einen Ajax starten um die Preise für eingeloggte Benutzer zu erhalten.
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "return_secret_sale_price",
              index_and_id: arr_index
            },
            success: function success(response) {
              var arr_result = JSON.parse(response);
              for (var _array_index in arr_result) {
                if ("rent" === current_body[_array_index]["erwerbsart"]) {
                  current_body[_array_index]["nettokaltmiete"] = arr_result[_array_index]["price"];
                } else {
                  current_body[_array_index]["kaufpreis"] = arr_result[_array_index]["price"];
                }
              }
            }
          });
        }
      }
      return current_body;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    // Globalen Listener registrieren
    this._onGWAllObjects = function (e) {
      try {
        var detail = e && e.detail || {};
        _this5.applyExternalObjectsChange(detail);
      } catch (err) {}
    };
    window.addEventListener("mw_geowerft_change_list", this._onGWAllObjects, false);
  },
  beforeDestroy: function beforeDestroy() {
    // Listener wieder entfernen, um Leaks zu vermeiden
    if (this._onGWAllObjects) {
      window.removeEventListener("mw_geowerft_change_list", this._onGWAllObjects, false);
    }
  },
  created: function created() {
    var _this6 = this;

    // Override geowerftSettings.center/zoom from URL params when a geo search is active.
    // URL params take precedence over PHP-set values and also fix the PHP lat/lng swap bug.
    {
      var urlParams = new URLSearchParams(window.location.search);
      var geoLat = urlParams.get("geo_values_lat");
      var geoLng = urlParams.get("geo_values_long");
      var qsSender = urlParams.get("quick_search_sender");
      var googleSearch = urlParams.get("google_search");

      if ((qsSender === "quick_search_send_post_data" || googleSearch !== null && googleSearch !== "") && geoLat !== null && geoLat !== "" && geoLng !== null && geoLng !== "") {
        // Correct assignment (PHP has lat/lng swapped — geo_values_lat → lat, geo_values_long → lng).
        geowerftSettings.center = {
          lat: parseFloat(geoLat),
          lng: parseFloat(geoLng)
        };
        // Apply the geo-search zoom level (already user-aware from PHP theme mod).
        if (geowerftSettings.google_search_zoom_level) {
          geowerftSettings.zoom = parseInt(geowerftSettings.google_search_zoom_level);
        }
        // Ensure qs_used is set in the source URL.
        geowerftSettings.quicksearch_used = true;
      }
    }

    this.$set(this.geoWerftData, "show_more_filter_close_btn_label", geowerftSettings.show_more_filter_close_btn_label);
    this.$set(this.geoWerftData, "enable_ai_quick_chat", geowerftSettings.enable_ai_quick_chat);
    this.$set(this.geoWerftData, "enable_ai_quick_chat_custom", geowerftSettings.enable_ai_quick_chat_custom);
    this.$set(this.geoWerftData, "ai_quick_label", geowerftSettings.ai_quick_label);
    this.$set(this.geoWerftData, "ai_quick_placeholder", geowerftSettings.ai_quick_placeholder);
    this.$set(this.geoWerftData, "ai_load_text", geowerftSettings.ai_load_text);
    this.$set(this.geoWerftData, "ai_load_img", geowerftSettings.ai_load_img);
    this.$set(this.geoWerftData, "ai_load_img_pre", geowerftSettings.ai_load_img_pre);
    this.$set(this.geoWerftData, "ai_load_img_after", geowerftSettings.ai_load_img_after);
    this.$set(this.geoWerftData, "ai_quick_svg", geowerftSettings.ai_quick_svg);
    this.$set(this.geoWerftData, "list_view_config", geowerftSettings.list_view_config);
    this.$set(this.geoWerftData, "marketwatch_extern_links_hp", geowerftSettings.marketwatch_extern_links_hp);
    this.$set(this.geoWerftData, "interactive_filter_active", geowerftSettings.interactive_filter_active);
    this.$set(this.geoWerftData, "enable_comfort_zoom", geowerftSettings.enable_comfort_zoom);
    this.$set(this.geoWerftData, "enable_blacklist", geowerftSettings.enable_blacklist);
    this.$set(this.geoWerftData, "display_map_list_switch", geowerftSettings.display_map_list_switch);
    this.$set(this.geoWerftData, "reset_bounds", geowerftSettings.reset_bounds);
    this.$set(this.geoWerftData, "reset_bounds_label", geowerftSettings.reset_bounds_label);
    this.$set(this.geoWerftData, "price_on_request_cb", geowerftSettings.price_on_request_cb);
    this.$set(this.geoWerftData, "enable_class_for_diff_view", geowerftSettings.enable_class_for_diff_view);
    this.$set(this.geoWerftData, "extra_map_css_class", geowerftSettings.extra_map_css_class);
    this.$set(this.geoWerftData, "show_more_filter", geowerftSettings.show_more_filter);
    this.$set(this.geoWerftData, "show_dialog_filter", geowerftSettings.show_dialog_filter);
    this.$set(this.geoWerftData, "kennung_filter_caption", geowerftSettings.kennung_filter_caption);
    this.$set(this.geoWerftData, "energie_filter_caption", geowerftSettings.energie_filter_caption);
    this.$set(this.geoWerftData, "geo_business_mode", geowerftSettings.geo_business_mode);
    this.$set(this.geoWerftData, "watchlist_to_hide_hp", geowerftSettings.watchlist_to_hide_hp);
    this.$set(this.geoWerftData, "geo_business_mode_bueroflaeche", geowerftSettings.geo_business_mode_bueroflaeche);
    this.$set(this.geoWerftData, "watchlist_to_hide_vermarktung", geowerftSettings.watchlist_to_hide_vermarktung);
    this.$set(this.geoWerftData, "filialen_success_story_label", geowerftSettings.filialen_success_story_label);
    this.$set(this.geoWerftData, "filialen_landingpage_label", geowerftSettings.filialen_landingpage_label);
    this.$set(this.geoWerftData, "kennung_filter_placeholder", geowerftSettings.kennung_filter_placeholder);
    this.$set(this.geoWerftData, "energie_filter_placeholder", geowerftSettings.energie_filter_placeholder);
    this.$set(this.geoWerftData, "prop_watchlist_active", geowerftSettings.prop_watchlist_active);
    this.$set(this.geoWerftData, "prop_watchlist_offline_mode", geowerftSettings.prop_watchlist_offline_mode);
    this.$set(this.geoWerftData, "user_watchlist", geowerftSettings.user_watchlist);
    this.$set(this.geoWerftData, "user_watchlist_detailed", geowerftSettings.user_watchlist_detailed);
    this.$set(this.geoWerftData, "user_blacklist", geowerftSettings.user_blacklist);
    this.$set(this.geoWerftData, "user_blacklist_icon", geowerftSettings.user_blacklist_icon);
    this.$set(this.geoWerftData, "geo_display_objecttype", geowerftSettings.geo_display_objecttype);
    this.$set(this.geoWerftData, "use_buero_for_business_space", geowerftSettings.use_buero_for_business_space);
    this.$set(this.geoWerftData, "reload_secret_sale_price_for_logged_in", geowerftSettings.reload_secret_sale_price_for_logged_in);
    this.$set(this.geoWerftData, "no_prop_in_route_text", geowerftSettings.no_prop_in_route_text);
    this.$set(this.geoWerftData.texts, "diff_extern_link", geowerftSettings.diff_extern_link);
    this.$set(this.geoWerftData.texts, "label_details", geowerftSettings.label_details);
    this.$set(this.geoWerftData.texts, "filter_label_price", geowerftSettings.filter_label_price);
    this.$set(this.geoWerftData.texts, "filter_adults_label", geowerftSettings.filter_adults_label);
    this.$set(this.geoWerftData.texts, "filter_children_label", geowerftSettings.filter_children_label);
    this.$set(this.geoWerftData.texts, "filter_label_price_buy", geowerftSettings.filter_label_price_buy);
    this.$set(this.geoWerftData.texts, "filter_label_price_rent", geowerftSettings.filter_label_price_rent);
    this.$set(this.geoWerftData.texts, "filter_label_space", geowerftSettings.filter_label_space);
    this.$set(this.geoWerftData.texts, "filter_label_rooms", geowerftSettings.filter_label_rooms);
    this.$set(this.geoWerftData.texts, "filter_space_label_house", geowerftSettings.filter_space_label_house);
    this.$set(this.geoWerftData.texts, "filter_space_label_grundstueck", geowerftSettings.filter_space_label_grundstueck);
    this.$set(this.geoWerftData.texts, "filter_space_label_gewerbe", geowerftSettings.filter_space_label_gewerbe);
    this.$set(this.geoWerftData.texts, "filter_space_label_invest", geowerftSettings.filter_space_label_invest);
    this.$set(this.geoWerftData.texts, "filter_space_label_house_max_extension", geowerftSettings.filter_space_label_house_max_extension);
    this.$set(this.geoWerftData.texts, "filter_space_label_grundstueck_max_extension", geowerftSettings.filter_space_label_grundstueck_max_extension);
    this.$set(this.geoWerftData.texts, "filter_space_label_gewerbe_max_extension", geowerftSettings.filter_space_label_gewerbe_max_extension);
    this.$set(this.geoWerftData.texts, "filter_space_label_invest_max_extension", geowerftSettings.filter_space_label_invest_max_extension);
    this.$set(this.geoWerftData.texts, "custom_pre_filter_label_von", geowerftSettings.custom_pre_filter_label_von);
    this.$set(this.geoWerftData.texts, "custom_pre_filter_label_bis", geowerftSettings.custom_pre_filter_label_bis);
    this.$set(this.geoWerftData.texts, "consent_text_normal", geowerftSettings.consent_text_normal);
    this.$set(this.geoWerftData.texts, "consent_button_label", geowerftSettings.consent_button_label);
    this.$set(this.geoWerftData.texts, "prop_offline_picture", geowerftSettings.prop_offline_picture);
    this.$set(this.geoWerftData.texts, "prop_offline_success_text", geowerftSettings.prop_offline_success_text);
    this.$set(this.geoWerftData.texts, "prop_offline_explain_text", geowerftSettings.prop_offline_explain_text);
    this.$set(this.geoWerftData.texts, "prop_offline_akt_kind", geowerftSettings.prop_offline_akt_kind);
    this.$set(this.geoWerftData.texts, "prop_offline_akt_type", geowerftSettings.prop_offline_akt_type);
    this.$set(this.geoWerftData.texts, "prop_offline_hp_status", geowerftSettings.prop_offline_hp_status);
    this.$set(this.geoWerftData.texts, "exclude_in_closest_prop_status", geowerftSettings.exclude_in_closest_prop_status);
    this.$set(this.geoWerftData.texts, "prop_offline_tutorial_text", geowerftSettings.prop_offline_tutorial_text);
    this.$set(this.geoWerftData.texts, "mietpreis_pro_qm_pre", geowerftSettings.mietpreis_pro_qm_pre);
    this.$set(this.geoWerftData.texts, "info_window_obj_nr", geowerftSettings.info_window_obj_nr);
    this.$set(this.geoWerftData.texts, "mietpreis_pro_qm_post", geowerftSettings.mietpreis_pro_qm_post);
    this.$set(this.geoWerftData.texts, "wp_nonce", geowerftSettings.wp_nonce);
    this.$set(this.geoWerftData.checkboxes, "prop_offline_include_overlay", geowerftSettings.prop_offline_include_overlay);
    this.$set(this.geoWerftData.checkboxes, "user_has_searchwish", geowerftSettings.user_has_searchwish);
    this.$set(this.geoWerftData.checkboxes, "picture_click_always_active", geowerftSettings.picture_click_always_active);
    this.$set(this.geoWerftData.checkboxes, "show_map_satellite_switch", geowerftSettings.show_map_satellite_switch);
    this.$set(this.geoWerftData.checkboxes, "show_price_in_paginated_info_window", geowerftSettings.show_price_in_paginated_info_window);
    this.$set(this.geoWerftData.checkboxes, "display_ges_flaeche", geowerftSettings.display_ges_flaeche);
    this.$set(this.geoWerftData.checkboxes, "display_tour_icon", geowerftSettings.display_tour_icon);
    this.$set(this.geoWerftData.customimages, "tour_icon_src", geowerftSettings.tour_icon_src);
    this.$set(this.geoWerftData.checkboxes, "user_has_searchwish", geowerftSettings.user_has_searchwish);
    this.$set(this.geoWerftData.checkboxes, "prop_offline_single_overlay", geowerftSettings.prop_offline_single_overlay);
    this.$set(this.geoWerftData.checkboxes, "enable_filialen_mode", geowerftSettings.enable_filialen_mode);
    this.$set(this.geoWerftData.checkboxes, "exclude_in_closest_prop", geowerftSettings.exclude_in_closest_prop);
    this.$set(this.geoWerftData.checkboxes, "hide_picture_shadow", geowerftSettings.hide_picture_shadow);
    this.$set(this.geoWerftData.checkboxes, "show_more_info_in_list", geowerftSettings.show_more_info_in_list);
    this.$set(this.geoWerftData, "filialien_url", geowerftSettings.filialien_url);
    this.$set(this.geoWerftData, "source_api", geowerftSettings.source_api);
    this.$set(this.geoWerftData, "estate_agent_email_filter", geowerftSettings.estate_agent_email_filter);
    this.$set(this.geoWerftData, "custom_map_style", geowerftSettings.custom_map_style);
    this.$set(this.geoWerftData.checkboxes, "list_map_switcher", geowerftSettings.list_map_switcher);
    this.$set(this.geoWerftData.checkboxes, "secret_bar_active", geowerftSettings.secret_bar_active);
    this.$set(this.geoWerftData.checkboxes, "show_ground_fl_for_house_in_list", geowerftSettings.show_ground_fl_for_house_in_list);
    this.$set(this.geoWerftData.checkboxes, "allow_prop_offline_detection", geowerftSettings.allow_prop_offline_detection);
    this.$set(this.geoWerftData.checkboxes, "allow_prop_offline_detection_only_logged_in", geowerftSettings.allow_prop_offline_detection_only_logged_in);
    this.$set(this.geoWerftData.texts, "currency_suffix", geowerftSettings.currency_suffix);
    this.$set(this.geoWerftData.texts, "secret_bar_register_link", geowerftSettings.secret_bar_register_link);
    this.$set(this.geoWerftData.texts, "secret_sale_headline", geowerftSettings.secret_sale_headline);
    this.$set(this.geoWerftData.texts, "secret_sale_sub_text", geowerftSettings.secret_sale_sub_text);
    this.$set(this.geoWerftData.texts, "list_visibility_json", geowerftSettings.list_visibility_json);
    this.$set(this.geoWerftData.texts, "secret_sale_button", geowerftSettings.secret_sale_button);
    this.$set(this.geoWerftData, "secret_bar_max_count", geowerftSettings.secret_bar_max_count);
    this.$set(this.geoWerftData, "cluster_font_weight", geowerftSettings.cluster_font_weight);
    this.$set(this.geoWerftData.checkboxes, "other_info_window", geowerftSettings.other_info_window);
    this.$set(this.geoWerftData.checkboxes, "other_info_window_v2", geowerftSettings.other_info_window_v2);
    this.$set(this.geoWerftData.checkboxes, "show_geo_as_fallback", geowerftSettings.show_geo_as_fallback);
    this.$set(this.geoWerftData.checkboxes, "display_prep_price", geowerftSettings.display_prep_price);
    this.$set(this.geoWerftData.checkboxes, "display_extra_commision_info", geowerftSettings.display_extra_commision_info);
    this.$set(this.geoWerftData.checkboxes, "display_sorce_in_market_watch", geowerftSettings.display_sorce_in_market_watch);
    this.$set(this.geoWerftData.checkboxes, "custom_marketwatch_temp_active", geowerftSettings.custom_marketwatch_temp_active);
    this.$set(this.geoWerftData.checkboxes, "next_pin_active", geowerftSettings.next_pin_active);
    this.$set(this.geoWerftData.checkboxes, "set_geolocation", geowerftSettings.set_geolocation);
    this.$set(this.geoWerftData.checkboxes, "enable_tutorial", geowerftSettings.enable_tutorial);
    this.$set(this.geoWerftData.checkboxes, "advanced_list_view", geowerftSettings.advanced_list_view);
    this.$set(this.geoWerftData.checkboxes, "logged_in_market_watch", geowerftSettings.logged_in_market_watch);
    this.$set(this.geoWerftData.checkboxes, "picture_click_active", geowerftSettings.picture_click_active);
    this.$set(this.geoWerftData.checkboxes, "enable_market_watch_ajax", geowerftSettings.enable_market_watch_ajax);
    this.$set(this.geoWerftData.checkboxes, "show_warmmiete", geowerftSettings.show_warmmiete);
    this.$set(this.geoWerftData.texts, "label_flaeche_list_view", geowerftSettings.label_flaeche_list_view);
    this.$set(this.geoWerftData.texts, "label_bezug_ab_map_view", geowerftSettings.label_bezug_ab_map_view);
    this.$set(this.geoWerftData.texts, "tutorial_text_one", geowerftSettings.tutorial_text_one);
    this.$set(this.geoWerftData.texts, "market_watch_alt_link", geowerftSettings.market_watch_alt_link);
    this.$set(this.geoWerftData.texts, "tutorial_text_two", geowerftSettings.tutorial_text_two);
    this.$set(this.geoWerftData.texts, "tutorial_text_three", geowerftSettings.tutorial_text_three);
    this.$set(this.geoWerftData.checkboxes, "fill_prop_types_to_invest", geowerftSettings.fill_prop_types_to_invest);
    this.$set(this.geoWerftData.checkboxes, "display_plz_in_object_place", geowerftSettings.display_plz_in_object_place);
    this.$set(this.geoWerftData.checkboxes, "display_kennung_in_object_place", geowerftSettings.display_kennung_in_object_place);
    this.$set(this.geoWerftData.texts, "fill_prop_types_to_invest_list", geowerftSettings.fill_prop_types_to_invest_list);
    this.$set(this.geoWerftData.texts, "auction_popup_picture", geowerftSettings.auction_popup_picture);
    this.$set(this.geoWerftData.texts, "ajax_url", geowerftSettings.ajax_url);
    this.$set(this.geoWerftData.texts, "geo_banner_picture_src", geowerftSettings.geo_banner_picture_src);
    this.$set(this.geoWerftData.texts, "geo_banner_picture_src_list", geowerftSettings.geo_banner_picture_src_list);
    this.$set(this.geoWerftData.texts, "geo_banner_picture_link", geowerftSettings.geo_banner_picture_link);
    this.$set(this.geoWerftData.texts, "banner_picture_link_second", geowerftSettings.banner_picture_link_second);
    this.$set(this.geoWerftData.texts, "banner_picture_src_second", geowerftSettings.banner_picture_src_second);
    this.$set(this.geoWerftData.texts, "geo_banner_custom_html", geowerftSettings.geo_banner_custom_html);
    this.$set(this.geoWerftData.texts, "banner_mobile_first_link", geowerftSettings.banner_mobile_first_link);
    this.$set(this.geoWerftData.texts, "banner_mobile_first_px", geowerftSettings.banner_mobile_first_px);
    this.$set(this.geoWerftData.texts, "banner_mobile_second_link", geowerftSettings.banner_mobile_second_link);
    this.$set(this.geoWerftData.texts, "banner_mobile_second_px", geowerftSettings.banner_mobile_second_px);
    this.$set(this.geoWerftData.texts, "market_watch_akt_kind", geowerftSettings.market_watch_akt_kind);
    this.$set(this.geoWerftData.texts, "market_watch_akt_type", geowerftSettings.market_watch_akt_type);
    this.$set(this.geoWerftData.customimages, "tutorial_picture_one", geowerftSettings.tutorial_picture_one);
    this.$set(this.geoWerftData.customimages, "tutorial_picture_two", geowerftSettings.tutorial_picture_two);
    this.$set(this.geoWerftData.customimages, "tutorial_picture_three", geowerftSettings.tutorial_picture_three);
    this.$set(this.geoWerftData.texts, "blur_hp_status_name", geowerftSettings.blur_hp_status_name);
    this.$set(this.geoWerftData.texts, "text_next_pin_prop", geowerftSettings.text_next_pin_prop);
    this.$set(this.geoWerftData.texts, "text_button_next_pin_prop", geowerftSettings.text_button_next_pin_prop);
    this.$set(this.geoWerftData.texts, "text_filter_next_pin_prop", geowerftSettings.text_filter_next_pin_prop);
    this.$set(this.geoWerftData.texts, "text_next_pin_ppl", geowerftSettings.text_next_pin_ppl);
    this.$set(this.geoWerftData.texts, "text_button_next_pin_ppl", geowerftSettings.text_button_next_pin_ppl);
    this.$set(this.geoWerftData.texts, "text_sc_info_text", geowerftSettings.text_sc_info_text);
    this.$set(this.geoWerftData.texts, "autocomplete_placeholder", geowerftSettings.autocomplete_placeholder);
    this.$set(this.geoWerftData.texts, "market_watch_name", geowerftSettings.market_watch_name);
    this.$set(this.geoWerftData.texts, "prop_own_source_text", geowerftSettings.prop_own_source_text);
    this.$set(this.geoWerftData.texts, "map_h1", geowerftSettings.map_h1);
    this.$set(this.geoWerftData.texts, "sc_plz", geowerftSettings.sc_plz);
    this.$set(this.geoWerftData.texts, "sc_geolage", geowerftSettings.sc_geolage);
    this.$set(this.geoWerftData.texts, "zoom_out_type", geowerftSettings.zoom_out_type);

    this.$set(this.geoWerftData.user, "current_user_id", geowerftSettings.current_user_id);

    this.$set(this.geoWerftData.user, "user_fully_logged_in", geowerftSettings.user_fully_logged_in);

    this.$set(this.geoWerftData.user, "link_for_logged_in_only", geowerftSettings.link_for_logged_in_only);

    this.$set(this.geoWerftData.user, "link_for_logged_in_only_url", geowerftSettings.link_for_logged_in_only_url);

    this.$set(this.geoWerftData.user, "link_for_logged_in_only_label", geowerftSettings.link_for_logged_in_only_label);

    if (undefined !== this.geoWerftData.texts.zoom_out_type && "" !== this.geoWerftData.texts.zoom_out_type) {
      var zoom_types = this.geoWerftData.texts.zoom_out_type.split("#");
      for (var i = 0; i < zoom_types.length; i++) {
        var zoom_type = zoom_types[i].split("|");
        this.geoWerftData.map.zoom_types.push({
          type: zoom_type[0],
          zoom: zoom_type[1],
          lat: zoom_type[2],
          lng: zoom_type[3]
        });
      }
    }
    // Check if settings object was found
    if (!geowerftSettings) {
      // Set error for user
      this.geoWerftData.hasError = "Missing settings";
      // Stop here
      return;
    }
    // Check if settings object contains source url
    if (!geowerftSettings.source_url) {
      // Set error for user
      this.geoWerftData.hasError = "Missing source url";
    } else if (false === this.geoWerftData.interactive_filter_active) {
      // Wenn der Filialien Modus an ist andere Rute verwenden
      if (this.geoWerftData.checkboxes.enable_filialen_mode) {
        this.geoWerftData.source_url = this.geoWerftData.filialien_url + "?per_page=" + geowerftSettings.page_count + "&_fields=id,list_position,geo_longitude,geo_latitude,objekt_titel,ort,strasse,plz,email,fax,telefon,telefon_zwei,link,object_image_url,info_head,info_ort,success_story&filter[orderby]=title&order=asc";
      } else {
        // Prepare vars
        var option_counter = 0,
            option_counter_query = 0,
            homepageStatusFilterInRequestString = "",
            vermarktungsartFilterInRequestString = "",
            plzFilterInRequestString = "",
            geolageFilterInRequestString = "",
            apiFilterInRequestString = "",
            agentEmailFilterInRequestString = "";

        var addTag = "";
        addTag = "query][" + option_counter_query + "][";
        // Loop all filter options for homepage_status
        for (var option_key in geowerftSettings.filter.status.options) {
          // Add the value to the query
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + "&filter[meta_" + addTag + "value][" + option_counter + "]=" + option_key; // Hier die Value verwenden und nicht das label aus der Option.
          // Increase counter to build an array inside the query
          option_counter++;
        }

        // Always set the filter to prevents loading posts with empty homepage_status and as key for homepage_status values
        homepageStatusFilterInRequestString = "&filter[meta_" + addTag + "key]=homepage_status" + homepageStatusFilterInRequestString;

        if (undefined !== geowerftSettings.show_only_with_ogulo_tour && "1" === geowerftSettings.show_only_with_ogulo_tour) {
          option_counter_query = option_counter_query + 1;
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + "&filter[meta_query][" + option_counter_query + "][key]=ogulo_tour&filter[meta_query][" + option_counter_query + "][value]=ja";
        }

        var m_options = 0;
        if (undefined !== geowerftSettings.filter.marketing) {
          for (var _option_key in geowerftSettings.filter.marketing.options) {
            m_options++;
          }
        }

        if (0 < m_options) {
          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (var _option_key2 in geowerftSettings.filter.marketing.options) {
            // Add the value to the query
            vermarktungsartFilterInRequestString = vermarktungsartFilterInRequestString + "&filter[meta_" + addTag + "value][" + option_counter + "]=" + geowerftSettings.filter.marketing.options[_option_key2];
            // Increase counter to build an array inside the query
            option_counter++;
          }
          vermarktungsartFilterInRequestString = "&filter[meta_" + addTag + "key]=vermarktungsart" + vermarktungsartFilterInRequestString;

          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + vermarktungsartFilterInRequestString;
        }
        // if source API is set, add the request
        if ("" !== this.geoWerftData.source_api) {
          var sourceApis = this.geoWerftData.source_api.split("xxxx");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (var _i = 0; _i < sourceApis.length; _i++) {
            // Add the value to the query
            apiFilterInRequestString = apiFilterInRequestString + "&filter[meta_" + addTag + "value][" + option_counter + "]=" + sourceApis[_i];
            // Increase counter to build an array inside the query
            option_counter++;
          }

          homepageStatusFilterInRequestString = "&filter[meta_query][relation]=AND" + homepageStatusFilterInRequestString + "&filter[meta_query][" + option_counter_query + "][key]=_source_api" + apiFilterInRequestString;
        }

        //If estate_agent_email_filter is set add it to the request
        if ("" !== this.geoWerftData.estate_agent_email_filter) {
          var sourceEmails = this.geoWerftData.estate_agent_email_filter.split("xxxx");
          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";
          for (var _i2 = 0; _i2 < sourceEmails.length; _i2++) {
            // Add the value to the query
            agentEmailFilterInRequestString = agentEmailFilterInRequestString + "&filter[meta_" + addTag + "value][" + option_counter + "]=" + sourceEmails[_i2];
            // Increase counter to build an array inside the query
            option_counter++;
          }

          homepageStatusFilterInRequestString =
          // "&filter[meta_query][relation]=AND" +
          homepageStatusFilterInRequestString + "&filter[meta_query][" + option_counter_query + "][key]=kontaktperson_email_direkt" + agentEmailFilterInRequestString;
        }

        // if sc_plz is set, add the request
        if ("" !== this.geoWerftData.texts.sc_plz) {
          var arr_plz = this.geoWerftData.texts.sc_plz.split("|");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (var _i3 = 0; _i3 < arr_plz.length; _i3++) {
            // Add the value to the query
            plzFilterInRequestString = plzFilterInRequestString + "&filter[meta_" + addTag + option_counter + "][compare]=REGEXP&filter[meta_" + addTag + option_counter + "][key]=plz&filter[meta_" + addTag + option_counter + "][value]=^[[" + this.wordwrap(arr_plz[_i3], 1, "][", true) + "]]*";
            // Increase counter to build an array inside the query
            option_counter++;
          }
          plzFilterInRequestString = "&filter[meta_" + addTag + "relation]=OR" + plzFilterInRequestString;
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + plzFilterInRequestString;
        }

        // if sc_geolage is set, add the request
        if ("" !== this.geoWerftData.texts.sc_geolage) {
          var arr_geolage = this.geoWerftData.texts.sc_geolage.split("|");

          option_counter = 0;
          option_counter_query = option_counter_query + 1;
          addTag = "query][" + option_counter_query + "][";

          // Loop all filter options for vermarktungsart
          for (var _i4 = 0; _i4 < arr_geolage.length; _i4++) {
            // Add the value to the query
            geolageFilterInRequestString = geolageFilterInRequestString + "&filter[meta_" + addTag + option_counter + "][compare]=REGEXP&filter[meta_" + addTag + option_counter + "][key]=geolage_wert&filter[meta_" + addTag + option_counter + "][value]=^" + arr_geolage[_i4].replaceAll("+", ".") + ".*";
            // Increase counter to build an array inside the query
            option_counter++;
          }
          geolageFilterInRequestString = "&filter[meta_" + addTag + "relation]=OR" + geolageFilterInRequestString;

          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + geolageFilterInRequestString;
        }

        // Min Request
        homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + "&_fields=homepage_status,erwerbsart,anzahl_zimmer,kaufpreis,nettokaltmiete,vermarktungsart,objektart_raw,objektart_geowerft,objekttyp,id,geo_latitude,geo_longitude,link_extern,object_image_url,objekttitel,plz,ort,kennung,wohnflaeche,vermietbare_flaeche,grundstuecksflaeche,gesamtflaeche,link,reservierung_ende,reservierung_begin,map_pin,map_picture,geolage,display_badge_new,mw_auction_current_price,aussencourtage_ja,count_adults,count_childs,barrierefrei,haustiere,ogulo_tour,epass_wertklasse,mw_map_star_rating";

        // Wenn das Custom Meta Feld gefüllt wurde.
        if ("" !== (geowerftSettings.custom_compare_meta || "")) {
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + "," + geowerftSettings.custom_compare_meta;
        }

        // Wenn Bussiness Felder noch hinzugefügt werden sollen.
        if (true === this.geoWerftData.geo_business_mode) {
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + ",mietpreis_pro_qm,bueroflaeche,teilbar_ab,bezug";
        }

        //Warmmiete hinzufügen, wenn im Customizer so ausgewählt
        if (true === this.geoWerftData.checkboxes.show_warmmiete) {
          homepageStatusFilterInRequestString = homepageStatusFilterInRequestString + ",warmmiete";
        }

        // Custom Felder variabel mit GTB hinzufügen.
        if ("" !== (geowerftSettings.custom_meta_extender || "")) {
          homepageStatusFilterInRequestString += "," + geowerftSettings.custom_meta_extender;
        }

        // Set value from settings object
        var url_seperator = "?";
        if (geowerftSettings.source_url.indexOf("?") > -1) {
          url_seperator = "&";
        }
        this.geoWerftData.source_url = geowerftSettings.source_url + url_seperator + "per_page=" + geowerftSettings.page_count + homepageStatusFilterInRequestString + "&lat=" + geowerftSettings.center.lat + "&lon=" + geowerftSettings.center.lng + "&qs_used=" + geowerftSettings.quicksearch_used;
      }
    }

    this.$set(this.geoWerftData, "list_item_limit", geowerftSettings.list_item_limit);
    this.$set(this.geoWerftData, "list_item_limit_old", geowerftSettings.list_item_limit);
    this.$set(this.geoWerftData, "show_cluster", geowerftSettings.show_cluster);
    this.$set(this.geoWerftData, "show_cluster_no_pictures", geowerftSettings.show_cluster_no_pictures);
    this.$set(this.geoWerftData, "cluster_break_zoom", geowerftSettings.cluster_break_zoom);
    this.$set(this.geoWerftData, "cluster_pin_near", geowerftSettings.cluster_pin_near);
    this.$set(this.geoWerftData, "cluster_pin_far", geowerftSettings.cluster_pin_far);
    this.$set(this.geoWerftData, "show_sold_banner", geowerftSettings.show_sold_banner);
    this.$set(this.geoWerftData, "steps_rooms", geowerftSettings.steps_rooms);
    this.$set(this.geoWerftData, "steps_space", geowerftSettings.steps_space);
    this.$set(this.geoWerftData, "steps_living_space", geowerftSettings.steps_living_space);
    this.$set(this.geoWerftData, "steps_plot_space", geowerftSettings.steps_plot_space);
    this.$set(this.geoWerftData, "auction_list_label", geowerftSettings.auction_list_label);
    this.$set(this.geoWerftData, "geowerft_setting_watchlist_icon", geowerftSettings.geowerft_setting_watchlist_icon);
    this.$set(this.geoWerftData, "geowerft_setting_watchlist_icon_custom", geowerftSettings.geowerft_setting_watchlist_icon_custom);
    this.$set(this.geoWerftData, "show_einheiten_in_list", geowerftSettings.show_einheiten_in_list);
    this.$set(this.geoWerftData, "geowerft_gtb_active", geowerftSettings.geowerft_gtb_active);
    this.$set(this.geoWerftData, "use_img_tag_in_list", geowerftSettings.use_img_tag_in_list);
    this.$set(this.geoWerftData, "geowerft_gtb_watchlist_active", geowerftSettings.geowerft_gtb_watchlist_active);
    this.$set(this.geoWerftData, "geowerft_gtb_watchlist_active_detailed", geowerftSettings.geowerft_gtb_watchlist_active_detailed);
    this.$set(this.geoWerftData, "geowerft_gtb_watchlist_rest", geowerftSettings.geowerft_gtb_watchlist_rest);
    this.$set(this.geoWerftData, "show_prov_free_banner", geowerftSettings.show_prov_free_banner);
    this.$set(this.geoWerftData, "step_num_kauf", geowerftSettings.step_num_kauf);
    this.$set(this.geoWerftData, "step_num_miete", geowerftSettings.step_num_miete);
    this.$set(this.geoWerftData, "show_extern_link", geowerftSettings.show_extern_link);

    // Set texts from customizer.
    this.$set(this.geoWerftData.texts, "display_text_price_rent", geowerftSettings.display_text_price_rent);
    this.$set(this.geoWerftData.texts, "display_text_price_purchase", geowerftSettings.display_text_price_purchase);
    this.$set(this.geoWerftData.texts, "display_text_no_buyer_comission", geowerftSettings.display_text_no_buyer_comission);
    this.$set(this.geoWerftData.texts, "display_extra_banderole", geowerftSettings.display_extra_banderole);
    this.$set(this.geoWerftData.texts, "no_immo_in_bounds_text", geowerftSettings.no_immo_in_bounds_text);
    this.$set(this.geoWerftData.texts, "no_immo_in_bounds_text_list_view", geowerftSettings.no_immo_in_bounds_text_list_view);
    this.$set(this.geoWerftData.texts, "prop_loading_text", geowerftSettings.prop_loading_text);
    this.$set(this.geoWerftData.texts, "not_in_scope_text", geowerftSettings.not_in_scope_text);
    this.$set(this.geoWerftData.texts, "select_cluster_hp_to_show", geowerftSettings.select_cluster_hp_to_show);
    this.$set(this.geoWerftData.map_settings, "google_search_zoom_level", geowerftSettings.google_search_zoom_level);

    // Additional infos
    this.$set(this.geoWerftData.additional_content, "geowerft_additional_info_box", geowerftSettings.geowerft_additional_info_box);
    this.$set(this.geoWerftData.additional_content, "geowerft_additional_info_box_template", geowerftSettings.geowerft_additional_info_box_template);

    // Set checkboxes from customizer.
    this.$set(this.geoWerftData.checkboxes, "display_google_search", geowerftSettings.display_google_search);
    this.$set(this.geoWerftData.checkboxes, "select_cluster_active", geowerftSettings.select_cluster_active);
    this.$set(this.geoWerftData.checkboxes, "display_custom_pin_in_list", geowerftSettings.display_custom_pin_in_list);
    this.$set(this.geoWerftData.checkboxes, "format_prices_cb", geowerftSettings.format_prices_cb);
    this.$set(this.geoWerftData.checkboxes, "show_price_prop_sold", geowerftSettings.show_price_prop_sold);
    this.$set(this.geoWerftData.checkboxes, "show_in_prep_banner", geowerftSettings.show_in_prep_banner);
    this.$set(this.geoWerftData.checkboxes, "show_price_prop_referenz", geowerftSettings.show_price_prop_referenz);
    this.$set(this.geoWerftData.checkboxes, "show_loading_icon", geowerftSettings.show_loading_icon);
    this.$set(this.geoWerftData.checkboxes, "display_marketing_method", geowerftSettings.display_marketing_method);
    this.$set(this.geoWerftData.checkboxes, "display_picture_max_width_or_height", geowerftSettings.display_picture_max_width_or_height);
    this.$set(this.geoWerftData, "custom_loading_icon", geowerftSettings.custom_loading_icon);

    // Set Marker Images
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_online", geowerftSettings.google_maps_marker_online);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_in_vorbereitung", geowerftSettings.google_maps_marker_in_vorbereitung);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_marktbeobachtung", geowerftSettings.google_maps_marker_marktbeobachtung);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_verkauft", geowerftSettings.google_maps_marker_verkauft);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_referenz", geowerftSettings.google_maps_marker_referenz);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_secret_sale", geowerftSettings.google_maps_marker_secret_sale);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_neubauobjekt", geowerftSettings.google_maps_marker_neubauobjekt);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_neubaureferenz", geowerftSettings.google_maps_marker_neubaureferenz);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_exlusive_object", geowerftSettings.google_maps_marker_exlusive_object);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_badge_new", geowerftSettings.google_maps_marker_badge_new);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_auction", geowerftSettings.google_maps_marker_auction);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_mietboerse", geowerftSettings.google_maps_marker_mietboerse);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_immobiliendepot", geowerftSettings.google_maps_marker_immobiliendepot);
    this.$set(this.geoWerftData.marker_image, "google_maps_marker_default", geowerftSettings.google_maps_marker_default);
    this.$set(this.geoWerftData.map, "map_type_id", geowerftSettings.map_type_id);
    this.$set(this.geoWerftData.map, "map_touch_mode", geowerftSettings.map_touch_mode);
    this.$set(this.geoWerftData.map, "map_zoom_control", geowerftSettings.map_zoom_control);

    // Set the media URL
    this.geoWerftData.media_url = geowerftSettings.media_url;

    // Check map zoom settings
    if (!geowerftSettings.zoom) {
      // Set error for user
      this.geoWerftData.hasError = "Missing zoom level setting";
    } else {
      // Set the value from settings object
      this.geoWerftData.map.zoom = parseInt(geowerftSettings.zoom);
    }

    // Check maps max zoom level
    if (0 !== parseInt(geowerftSettings.max_zoom)) {
      // Set the value from settings object
      this.$set(this.geoWerftData.map, "maxZoom", parseInt(geowerftSettings.max_zoom));
    }

    /*
     * Set placeholder images
     */
    // Placeholder - Secret sale
    this.$set(this.geoWerftData, "image_placeholder_secret", geowerftSettings.image_placeholder_secret);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_secret) {
      // Prepare a pre-loading
      var secret_sales_image = new Image();
      secret_sales_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      secret_sales_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - Aktive Marktbeobachtung
    this.$set(this.geoWerftData, "image_placeholder_market_watch", geowerftSettings.image_placeholder_market_watch);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_market_watch) {
      // Prepare a pre-loading
      var market_watch_image = new Image();
      market_watch_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      market_watch_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Haus.
    this.$set(this.geoWerftData, "image_placeholder_house_prep", geowerftSettings.image_placeholder_house_prep);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_house_prep) {
      // Prepare a pre-loading
      var house_prep_image = new Image();
      house_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      house_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Wohnung.
    this.$set(this.geoWerftData, "image_placeholder_flat_prep", geowerftSettings.image_placeholder_flat_prep);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_flat_prep) {
      // Prepare a pre-loading
      var flat_prep_image = new Image();
      flat_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      flat_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Grundstück.
    this.$set(this.geoWerftData, "image_placeholder_plot_prep", geowerftSettings.image_placeholder_plot_prep);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_plot_prep) {
      // Prepare a pre-loading
      var plot_prep_image = new Image();
      plot_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      plot_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - In Vorbereitung Grundstück.
    this.$set(this.geoWerftData, "image_placeholder_invest_prep", geowerftSettings.image_placeholder_invest_prep);
    this.$set(this.geoWerftData, "image_placeholder_market_watch_house", geowerftSettings.image_placeholder_market_watch_house);
    this.$set(this.geoWerftData, "image_placeholder_market_watch_flat", geowerftSettings.image_placeholder_market_watch_flat);
    this.$set(this.geoWerftData, "image_placeholder_market_watch_plot", geowerftSettings.image_placeholder_market_watch_plot);
    // Pre-load the image
    if ("" !== this.geoWerftData.image_placeholder_invest_prep) {
      // Prepare a pre-loading
      var invest_prep_image = new Image();
      invest_prep_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      invest_prep_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Placeholder - No image or still loading
    this.$set(this.geoWerftData, "image_placeholder_empty", geowerftSettings.image_placeholder_empty);
    // Pre-load the empty placeholder
    if ("" !== this.geoWerftData.image_placeholder_empty) {
      // Prepare a pre-loading
      var placeholder_image = new Image();
      placeholder_image.onload = function () {
        // Pre-loading done
      };
      // Add image url to pre-loading
      placeholder_image.src = this.geoWerftData.image_placeholder_empty;
    }

    // Check map center point setting
    if (!geowerftSettings.center || "object" !== _typeof(geowerftSettings.center)) {
      // Set error for user
      this.geoWerftData.hasError = "Missing center point setting";
    } else {
      // Set the values from settings object
      this.geoWerftData.map.center.lat = parseFloat(geowerftSettings.center.lat);
      this.geoWerftData.map.center.lng = parseFloat(geowerftSettings.center.lng);
    }

    if (document.body.classList.contains("logged-in")) {
      this.geoWerftData.user.logged_in = true;
    }

    var fetch_header = {};
    if (this.geoWerftData.texts.wp_nonce) {
      fetch_header = {
        headers: { "X-WP-Nonce": this.geoWerftData.texts.wp_nonce }
      };
    }

    if (geowerftSettings.raw_data) {
      this.$set(this.geoWerftData, "array_container", JSON.parse(geowerftSettings.raw_data));

      var that = this;
      this.get_props(0).then(function (data) {
        that.geoWerftData.objects.all = data;
        that.load_props(0 + parseInt(geowerftSettings.new_prop_data_per_load));
      });
    } else if (true === geowerftSettings.use_raw_data) {
      // Nutzer scheint nicht eingeloggt zu sein.
      // Daten aus der REST holen.
      this.$http.get(geowerftSettings.cached_url, fetch_header).then(function (data) {
        _this6.geoWerftData.objects.all = data.body.data;
        _this6.geoWerftData.geowerft_immo_loading = false;
        dispatchEvent(new CustomEvent("mw_map_list_loaded", {
          detail: { all_loaded_props: _this6.geoWerftData.objects.all },
          bubbles: true
        }));
      }).catch(function (error) {
        _this6.geoWerftData.geowerft_immo_loading = false;
        _this6.geoWerftData.geowerft_no_props_from_route = true;
      });
    } else {
      // Fetch the data from WP REST API
      this.$http.get(this.geoWerftData.source_url, fetch_header).then(function (data) {
        // Success handling - first page
        // Put the result into the bus
        data.body = this.reload_secret_sale_price(data.body);
        this.geoWerftData.objects.all = data.body;
        //this.$set( this.geoWerftData, 'is_loading', false );

        // Get the max number of pages to loop over
        var page_count = parseInt(data.headers.get("X-WP-TotalPages"));

        // Create url object
        var url = new URL(this.geoWerftData.source_url);
        // Loop all pages
        this.loadPoperties(url, 2, page_count, fetch_header);
      }, function (data) {
        // Error handling - first page
        // do nothing for now
      });
    }

    // Set the filter

    if (!geowerftSettings.filter || "object" === _typeof(geowerftSettings.filter)) {
      this.geoWerftData.filter = geowerftSettings.filter;
    }

    // Pre-select filter if settings say so
    if (undefined !== geowerftSettings.query) {
      // Loop all filters
      for (var key in geowerftSettings.query) {
        // Check if a good key is given
        if ("string" === typeof geowerftSettings.query[key]) {
          // Store the value into var
          var value = geowerftSettings.query[key].toLowerCase();
          // Use the fresh shortcode input.
          var statusval = geowerftSettings.query[key];

          // Check if strings need to be translated
          switch (key) {
            case "erwerbsart":
              // Rewrite key to english
              key = "acquisition";
              // Rewrite value to english
              switch (value) {
                case "miete":
                  value = "rent";
                  break;
                case "kauf":
                  value = "buy";
                  break;
              }
              break;
            case "objektart_geowerft":
            case "objektart":
              // Rewrite key to english
              key = "objecttype";
              // Rewrite value to english
              switch (value) {
                case "haus":
                  value = "house";
                  break;
                case "wohnung":
                  value = "flat";
                  break;
                case "grundstück":
                  value = "plot";
                  break;
                case "investment":
                  value = "investment";
                  break;
                case "gewerbe":
                  value = "business";
                  break;
              }
              break;
            case "homepage_status":
              // Rewrite key to english
              key = "status";
              value = statusval;
              // Rewrite value to english
              break;
            case "vermarktungsart":
              // Rewrite key to english
              key = "marketing";
              value = statusval;
              // Rewrite value to english
              break;
            case "geolage":
              // Rewrite key to english
              key = "regio";
              value = statusval;
              // Rewrite value to english
              break;
          }

          // Set the filter to it's value
          this.geoWerftData.filter[key].value = value;
        }
      }
    }

    // URL params take final precedence over both PHP filter defaults and shortcode query attribute.
    if (this.geoWerftData.filter) {
      var _urlParams = new URLSearchParams(window.location.search);
      if (_urlParams.get("quick_search_sender") === "quick_search_send_post_data") {
        var urlAcquisition = _urlParams.get("quick-erwerbsart");
        var urlObjecttype = _urlParams.get("quick-objektarten");
        if (urlAcquisition && urlAcquisition !== "leer" && this.geoWerftData.filter["acquisition"]) {
          this.geoWerftData.filter["acquisition"].value = urlAcquisition;
        }
        if (urlObjecttype && urlObjecttype !== "leer" && this.geoWerftData.filter["objecttype"]) {
          this.geoWerftData.filter["objecttype"].value = urlObjecttype;
        }
      }
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectList_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682e4af4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectList_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682e4af4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_eventbus_js__ = __webpack_require__(9);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ["geoWerftData"],
  computed: {
    filteredObjects: function filteredObjects() {
      return this.geoWerftData.objects.filtered;
    },
    visible0bjects: function visible0bjects() {
      return this.geoWerftData.objects.visible;
    },
    listedObjects: function listedObjects() {
      return this.geoWerftData.objects.listed;
    },
    loadingStatus: function loadingStatus() {
      // Return the length of the objects array
      return this.geoWerftData.objects.all.length;
    }
  },
  methods: {
    get_special_list_conf_html: function get_special_list_conf_html(arr_current_config, current_prop) {
      var current_key = arr_current_config.key || "";
      if (current_prop[current_key]) {
        var output_value = current_prop[current_key];
        // Hier noch eine Formattierung einbauen.
        if ("currency" === arr_current_config.format) {
          output_value = this.get_format_price(output_value, current_prop) + " €";
        }
        if ("area" === arr_current_config.format) {
          output_value = this.mw_format_area(output_value) + " m²";
        }
        return "<div class=\"tmp-label-wrapper " + arr_current_config.key + "\">" + arr_current_config.label + "</div><div class=\"tmp-value-wrapper " + arr_current_config.key + "\">" + output_value + "</div>";
      }
      return "";
    },
    get_suffix_special: function get_suffix_special(current_prop) {
      if (true === this.geoWerftData.price_on_request_cb && parseInt(current_prop.oo_price_on_request || "") === 1) {
        return "";
      }

      return this.geoWerftData.texts.currency_suffix;
    },
    mabye_get_on_request_price: function mabye_get_on_request_price(current_prop) {
      if (true === this.geoWerftData.price_on_request_cb && parseInt(current_prop.oo_price_on_request || "") === 1) {
        current_prop.kaufpreis = "0";
      }
      return current_prop.kaufpreis;
    },
    get_special_list_title: function get_special_list_title(object) {
      var output_title = object.objekttitel;
      if (true === this.geoWerftData.checkboxes.other_info_window_v2) {
        var additional_info_by_aquisition_type = "zum Kauf";
        if (object.erwerbsart.toLowerCase() === "miete" || object.erwerbsart.toLowerCase() === "rent") {
          additional_info_by_aquisition_type = "zur Miete";
        }
        output_title = object.objekttyp + " " + additional_info_by_aquisition_type + " <br> " + object.plz + " " + object.ort;
      }
      return output_title;
    },
    mw_list_get_settings_by_json: function mw_list_get_settings_by_json(current_list_prop_obj) {
      var current_possible_json = JSON.parse(this.geoWerftData.texts.list_visibility_json);
      var custom_html_to_return = "";
      if (current_possible_json) {
        for (var key in current_possible_json) {
          if (current_possible_json.hasOwnProperty(key)) {
            var running_arr_key_value = current_possible_json[key];

            var check_for_user_status = running_arr_key_value["only_check_if_user_offline"] || false;
            var current_user_status = geowerftSettings.user_is_logged_in;
            if (true === geowerftSettings.user_logged_in_by_cookie) {
              current_user_status = true;
            }

            if (true === check_for_user_status && false === current_user_status) {
              if (running_arr_key_value["check_meta"] && running_arr_key_value["check_meta_value"] || running_arr_key_value["check_meta_exist"] && current_list_prop_obj[running_arr_key_value["check_meta_exist"]]) {
                if ((current_list_prop_obj[running_arr_key_value["check_meta"]] || "").toLowerCase() === running_arr_key_value["check_meta_value"].toLowerCase()) {
                  // Prüfung okay, nun änderungen machen.
                  if (running_arr_key_value["change_meta"]) {
                    current_list_prop_obj[running_arr_key_value["change_meta"]] = running_arr_key_value["change_meta_value"] || undefined;
                  }
                  if (running_arr_key_value["custom_html"]) {
                    custom_html_to_return += this.mw_list_replace_placeholders(running_arr_key_value["custom_html"], current_list_prop_obj);
                  }
                }
              }
            }

            if (false === check_for_user_status) {
              if (running_arr_key_value["check_meta"] && running_arr_key_value["check_meta_value"] || running_arr_key_value["check_meta_exist"] && current_list_prop_obj[running_arr_key_value["check_meta_exist"]]) {
                if ((current_list_prop_obj[running_arr_key_value["check_meta"]] || "").toLowerCase() === running_arr_key_value["check_meta_value"].toLowerCase()) {
                  // Prüfung okay, nun änderungen machen.
                  if (running_arr_key_value["change_meta"]) {
                    current_list_prop_obj[running_arr_key_value["change_meta"]] = running_arr_key_value["change_meta_value"] || undefined;
                  }
                  if (running_arr_key_value["custom_html"]) {
                    custom_html_to_return += this.mw_list_replace_placeholders(running_arr_key_value["custom_html"], current_list_prop_obj);
                  }
                }
              }
            }
          }
        }
      }

      return custom_html_to_return;
    },
    mw_list_replace_placeholders: function mw_list_replace_placeholders(template, data) {
      var _this = this;

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$onMissing = _ref.onMissing,
          onMissing = _ref$onMissing === undefined ? "keep" : _ref$onMissing,
          _ref$missingValue = _ref.missingValue,
          missingValue = _ref$missingValue === undefined ? "" : _ref$missingValue;

      // onMissing: 'keep' | 'remove' | 'default'
      return template.replace(/\{([^{}]+)\}/g, function (match, key) {
        var cleanKey = key.trim();
        var is_currency = false;
        var is_area = false;
        // Hier muss noch geschaut werden, ob Formatierungen notwendig sind.
        if (cleanKey.includes("_currency")) {
          cleanKey = cleanKey.replace("_currency", "");
          is_currency = true;
        }

        if (cleanKey.includes("_area")) {
          cleanKey = cleanKey.replace("_area", "");
          is_area = true;
        }

        var value = data.hasOwnProperty(cleanKey) ? data[cleanKey] : undefined;

        if (value === undefined) {
          if (onMissing === "remove") return "";
          if (onMissing === "default") return String(missingValue);
          // 'keep'
          return match;
        }

        if (true === is_currency) {
          value = _this.get_format_price(value, data) + " €";
        }

        if (true === is_area) {
          value = _this.mw_format_area(value) + " m²";
        }

        return String(value);
      });
    },
    map_get_sold_label: function map_get_sold_label(object) {
      var tmp_label_string = "Verkauft";
      if (object.mw_map_star_rating) {
        var tmp_star_rating_number = parseInt(object.mw_map_star_rating);
        var tmp_star_rating_string = '<div class="map-star-rating">';
        for (var i = 1; i <= tmp_star_rating_number; i++) {
          tmp_star_rating_string += "&#9733;";
        }
        tmp_star_rating_string += "</div>";
        tmp_label_string += tmp_star_rating_string;
      }
      return tmp_label_string;
    },
    check_commision: function check_commision(object) {
      if (object.aussencourtage_ja !== undefined && this.geoWerftData.texts.display_text_no_buyer_comission && object.aussencourtage_ja !== null && object.erwerbsart && (object.erwerbsart.toLowerCase() === "kauf" || "buy" === object.erwerbsart.toLowerCase())) {
        if (object.aussencourtage_ja && "nein" === object.aussencourtage_ja.toLowerCase()) {
          return true;
        }
      }
      return false;
    },
    render_new_badge_content: function render_new_badge_content(current_prop) {
      var pricing = "";
      if (current_prop.erwerbsart && (current_prop.erwerbsart.toLowerCase() === "kauf" || current_prop.erwerbsart.toLowerCase() === "buy") && !isNaN(parseInt(current_prop.kaufpreis)) && undefined !== current_prop.kaufpreis && "" !== current_prop.kaufpreis) {
        pricing = this.get_format_price(current_prop.kaufpreis, current_prop) + " " + this.geoWerftData.texts.currency_suffix;
      }
      if (current_prop.erwerbsart && (current_prop.erwerbsart.toLowerCase() === "miete" || current_prop.erwerbsart.toLowerCase() === "rent") && !isNaN(parseInt(current_prop.nettokaltmiete)) && undefined !== current_prop.nettokaltmiete && "" !== current_prop.nettokaltmiete) {
        pricing = this.get_format_price(current_prop.nettokaltmiete, current_prop) + " " + this.geoWerftData.texts.currency_suffix;
      }
      return pricing;
    },
    mw_format_list_number_output: function mw_format_list_number_output(str_number) {
      var working_number = str_number || "";
      working_number = working_number.replace(".00", "");
      working_number = working_number.replace(".", ",");
      return working_number;
    },
    mw_format_area: function mw_format_area(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      var result = number;
      // replace special chars.
      result = this.replace_special_chars(result);
      // format the price.
      return new Intl.NumberFormat("de-DE", {
        style: "decimal"
      }).format(result);
    },
    get_placeholder_img_by_hp: function get_placeholder_img_by_hp(homepage_status, img_url, prop_type) {
      if (homepage_status && prop_type && false === this.geoWerftData.interactive_filter_active) {
        switch (homepage_status.toLowerCase()) {
          case "secret sale":
            if (false === this.geoWerftData.user.logged_in) {
              img_url = this.geoWerftData.image_placeholder_secret;
            }
            break;
          case "aktive marktbeobachtung":
            img_url = this.geoWerftData.image_placeholder_market_watch;
            if ("haus" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_house;
            }
            if ("wohnung" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_flat;
            }
            if ("grundstück" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_plot;
            }
            if ("" === img_url) {
              img_url = this.geoWerftData.image_placeholder_market_watch;
            }
            break;
          default:
            break;
        }
      }
      return img_url;
    },
    replace_special_chars: function replace_special_chars(str_number) {
      if (str_number.substring(str_number.length - 3) === ".00") {
        str_number = str_number.substring(0, str_number.length - 3);
      }

      str_number = str_number.replace(/€/g, "");
      str_number = str_number.replace(/CHF/g, "");
      str_number = str_number.replace(/m²/g, "");

      // Variante aus der Immowerft in JS implementiert
      var num_position_comma = str_number.indexOf(",");
      var num_position_dot = str_number.indexOf(".");
      var check_number = str_number.replace(",", "|");
      if (num_position_comma > num_position_dot) {
        check_number = check_number.replace(".", "");
      }
      str_number = check_number.replace("|", ".");

      str_number = str_number.trim();
      return str_number;
    },
    get_picture_url: function get_picture_url(img_url, placeholder, default_img_url, homepage_status, prop_type) {
      if (undefined === img_url || "" === img_url) {
        img_url = default_img_url;
      }

      if (undefined === img_url || "" === img_url) {
        img_url = placeholder;
      }

      var rgba_color = "0.4";
      if (true === this.geoWerftData.checkboxes.hide_picture_shadow) {
        rgba_color = "0";
      }

      // Hier noch mögliche Platzhalter setzen.
      img_url = this.get_placeholder_img_by_hp(homepage_status, img_url, prop_type);

      if (true === this.geoWerftData.use_img_tag_in_list) {
        return img_url;
      }

      return {
        background: ["-moz-linear-gradient(top, rgba(0, 0, 0, " + rgba_color + ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " + rgba_color + ") 100%), url(" + img_url + ") no-repeat", "-webkit-gradient(linear, left top, left bottom, color-stop(0%, rgba(0, 0, 0, " + rgba_color + ")), color-stop(50%, rgba(0, 0, 0, 0)), color-stop(100%, rgba(0, 0, 0, " + rgba_color + "))), url(" + img_url + ") no-repeat", "-webkit-linear-gradient(top, rgba(0, 0, 0, " + rgba_color + ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " + rgba_color + ") 100%), url(" + img_url + ") no-repeat", "-o-linear-gradient(top, rgba(0, 0, 0, " + rgba_color + ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " + rgba_color + ") 100%), url(" + img_url + ") no-repeat", "-ms-linear-gradient(top, rgba(0, 0, 0, " + rgba_color + ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " + rgba_color + ") 100%), url(" + img_url + ") no-repeat", "linear-gradient(to bottom, rgba(0, 0, 0, " + rgba_color + ") 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, " + rgba_color + ") 100%), url(" + img_url + ") no-repeat"],
        backgroundSize: ["cover"]
      };
    },
    get_the_correct_type: function get_the_correct_type(current_prop) {
      var curr_type = current_prop.objektart_geowerft || "";
      if (curr_type === "") {
        curr_type = current_prop.objektart_raw;
      }
      if (true === this.geoWerftData.geo_display_objecttype && current_prop.objekttyp) {
        curr_type = current_prop.objekttyp;
      }

      // Anpassung für Custom Objektart.
      if ("" !== (current_prop.objekttyp_custom || "")) {
        var replacements = {
          etage: "etagenwohnung",
          rohdachboden: "rohdachbodenwohnung",
          hochparterre: "hochparterrenwohnung",
          dachgeschoss: "dachgeschosswohnung",
          maisonette: "maisonettewohnung",
          "loft-studio-atelier": "loft/Studio/Atelierwohnung",
          penthouse: "penthousewohnung",
          terrassen: "terrassenwohnung",
          etagenwohnung: "etagenwohnung",
          erdgeschoss: "erdgeschosswohnung",
          souterrain: "souterrainwohnung"
        };
        curr_type = replacements[current_prop.objekttyp_custom.toString()] || current_prop.objekttyp_custom.toString();
      }

      return this.mw_capitalite_first_letter(curr_type);
    },
    mw_capitalite_first_letter: function mw_capitalite_first_letter(string) {
      if (string && string.length > 1) {
        string = string.charAt(0).toUpperCase() + string.slice(1);
      }
      return string;
    },
    get_active_watchlist_class: function get_active_watchlist_class(current_prop) {
      var class_name = "";

      if (true === this.current_user_can_see_watchlist_icons(current_prop)) {
        class_name = "watchlist-active";
      }

      return class_name;
    },
    current_user_can_see_watchlist_icons: function current_user_can_see_watchlist_icons(objekt) {
      // Anpassung für die Merkliste.
      if (true === this.geoWerftData.geowerft_gtb_active && false === this.geoWerftData.user.logged_in && true === this.geoWerftData.geowerft_gtb_watchlist_active) {
        // Wenn Gutenberg aktiv ist, die Merkliste nicht anzeigen, falls der Benutzer nicht eingeloggt ist.
        // Es gibt hier nun einen alternativen Code welcher dann in diesem Fall ausgeführt wird.
        return false;
      }
      var current_hp = "";
      var current_vermarktung = "placeholder";
      if (objekt.homepage_status) {
        current_hp = objekt.homepage_status.toLowerCase();
      }
      if (objekt.vermarktungsart) {
        current_vermarktung = objekt.vermarktungsart.toLowerCase();
      }
      var check_hp_array = this.geoWerftData.watchlist_to_hide_hp.toLowerCase().split("|");
      var check_vermakrtung_array = this.geoWerftData.watchlist_to_hide_vermarktung.toLowerCase().split("|");
      if (true === this.geoWerftData.prop_watchlist_active && true === this.geoWerftData.user.logged_in && false === check_hp_array.includes(current_hp) && false === check_vermakrtung_array.includes(current_vermarktung)) {
        return true;
      }
      return true === this.geoWerftData.prop_watchlist_active && true === this.geoWerftData.prop_watchlist_offline_mode && false === check_hp_array.includes(current_hp) && false === check_vermakrtung_array.includes(current_vermarktung);
    },
    current_user_can_see_blacklist: function current_user_can_see_blacklist() {
      // Anpassung für die Blacklist.
      if (true === this.geoWerftData.user.logged_in && true === this.geoWerftData.enable_blacklist) {
        return true;
      }

      return false;
    },
    current_user_can_see_offline_blacklist: function current_user_can_see_offline_blacklist() {
      // Anpassung für die Blacklist.
      if (true !== this.geoWerftData.user.logged_in && true === this.geoWerftData.enable_blacklist) {
        return true;
      }

      return false;
    },
    set_selected_prop_offline: function set_selected_prop_offline(dom_elm, mode) {
      // Nur ausführen wenn die Checkbox aktiv ist.
      var property_id = jQuery(dom_elm).closest(mode).attr("data-id");
      if (property_id && true === this.geoWerftData.checkboxes.allow_prop_offline_detection) {
        var that = this;
        if (confirm(this.geoWerftData.texts.prop_offline_explain_text)) {
          jQuery.ajax({
            url: rest_url + "geowerft/v1/property/" + property_id + "/offline",
            method: "PUT",
            data: {
              actionkind: this.geoWerftData.texts.prop_offline_akt_kind,
              actiontype: this.geoWerftData.texts.prop_offline_akt_type
            },
            beforeSend: function beforeSend(xhr) {
              xhr.setRequestHeader("X-WP-Nonce", wp_nonce.nonce);
            }
          }).done(function (response) {
            alert(that.geoWerftData.texts.prop_offline_success_text);
            setTimeout(function () {
              location.reload(true);
            }, 2000);
          });
        }
      }
    },
    get_future_extra_fields: function get_future_extra_fields(current_prop) {
      var content = "";
      var pos_content = [];
      if (current_prop) {
        var curr_rooms = current_prop.anzahl_zimmer;
        var arr_values_fl = [current_prop.wohnflaeche, current_prop.vermietbare_flaeche, current_prop.grundstuecksflaeche, current_prop.gesamtflaeche];
        for (var key in arr_values_fl) {
          if (arr_values_fl[key]) {
            pos_content.push("Wohnfläche: " + arr_values_fl[key] + " m²");
            // Only use the first you find.
            break;
          }
        }
        if (curr_rooms) {
          pos_content.push("Zimmer: " + curr_rooms);
        }
        content = pos_content.join("<br>");
      }
      return content;
    },
    return_no_immo_in_b_text: function return_no_immo_in_b_text(current_mode) {
      var display_text;
      if ("map" === current_mode) {
        display_text = this.geoWerftData.texts.no_immo_in_bounds_text;
      } else {
        display_text = this.geoWerftData.texts.no_immo_in_bounds_text_list_view;
      }
      return display_text;
    },
    trigger_banner_render: function trigger_banner_render(index) {
      var current_width = window.innerWidth;
      if (3 === index) {
        var main_element = document.querySelectorAll("*[data-index]");
        var banner_src = this.geoWerftData.texts.geo_banner_picture_src;

        if ("list" === this.geoWerftData.current_map_mode && "" !== this.geoWerftData.texts.geo_banner_picture_src_list) {
          banner_src = this.geoWerftData.texts.geo_banner_picture_src_list;
        }
        var banner_link = this.geoWerftData.texts.geo_banner_picture_link;
        var banner_html = this.geoWerftData.texts.geo_banner_custom_html;

        // Hier die Fenstergröße Prüfen und ggf. anderes Banner anzeigen.
        if (current_width <= parseInt(this.geoWerftData.texts.banner_mobile_first_px) && "" !== this.geoWerftData.texts.banner_mobile_first_link) {
          banner_src = this.geoWerftData.texts.banner_mobile_first_link;
        }

        if (main_element[3] !== undefined && (banner_src && banner_link || banner_html)) {
          if (document.querySelector(".geo-banner")) {
            document.querySelector(".geo-banner").remove();
          }
          if (banner_src && banner_link) {
            main_element[3].insertAdjacentHTML("afterend", '<li class="geo-banner geo-banner-wrapper"><a href="' + banner_link + '" target="_blank"><img class="geowerft-banner-img" alt="" src="' + banner_src + '"></a>');
          }
          if (banner_html) {
            main_element[3].insertAdjacentHTML("afterend", '<li class="geo-banner custom-html">' + banner_html + "</li>");
          }
        }
        if (main_element[3] === undefined && document.querySelector(".geo-banner")) {
          document.querySelector(".geo-banner").remove();
        }
        geowerft_position_banner("geo-banner");
      }

      if (index === 11 && "" !== this.geoWerftData.texts.banner_picture_src_second && "" !== this.geoWerftData.texts.banner_picture_link_second) {
        var main_element = document.querySelectorAll("*[data-index]");
        var banner_src = this.geoWerftData.texts.banner_picture_src_second;
        var banner_link = this.geoWerftData.texts.banner_picture_link_second;

        // Hier die Fenstergröße Prüfen und ggf. anderes Banner anzeigen.
        if (current_width <= parseInt(this.geoWerftData.texts.banner_mobile_second_px) && "" !== this.geoWerftData.texts.banner_mobile_second_link) {
          banner_src = this.geoWerftData.texts.banner_mobile_second_link;
        }

        if (main_element[11] !== undefined && banner_src && banner_link) {
          if (document.querySelector(".geo-banner-second")) {
            document.querySelector(".geo-banner-second").remove();
          }
          main_element[11].insertAdjacentHTML("afterend", '<li class="geo-banner-second geo-banner-wrapper"><a href="' + banner_link + '" target="_blank"><img class="geowerft-banner-img" alt="" src="' + banner_src + '"></a>');
        }
        if (main_element[11] === undefined && document.querySelector(".geo-banner-second")) {
          document.querySelector(".geo-banner-second").remove();
        }
        geowerft_position_banner("geo-banner-second");
      }
    },
    list_trigger_ajax_request: function list_trigger_ajax_request(current_prop, possible_values) {
      // Ajax erst einmal nur für Aktive markbeobachtung nutzen.
      if (true === this.geoWerftData.user.logged_in && true === this.geoWerftData.checkboxes.enable_market_watch_ajax) {
        if (current_prop && current_prop.homepage_status && "aktive marktbeobachtung" === current_prop.homepage_status.toLowerCase() || current_prop.vermarktungsart && "fremdobjekt" === current_prop.vermarktungsart.toLowerCase()) {
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "handle_marked_watch_click",
              current_link: current_prop.link_extern,
              current_id: current_prop.kennung,
              akt_kind: this.geoWerftData.texts.market_watch_akt_kind,
              akt_type: this.geoWerftData.texts.market_watch_akt_type,
              current_user_id: this.geoWerftData.user.current_user_id
            },
            success: function success(response) {}
          });
        }
      }
    },
    mw_display_gtb_watchlist: function mw_display_gtb_watchlist() {
      if (true === this.geoWerftData.geowerft_gtb_active && false === this.geoWerftData.user.logged_in && true === this.geoWerftData.geowerft_gtb_watchlist_active) {
        return true;
      }
      return false;
    },
    mw_display_gtb_watchlist_detailed: function mw_display_gtb_watchlist_detailed() {
      if (true === this.geoWerftData.geowerft_gtb_active && true === this.geoWerftData.user.logged_in && true === this.geoWerftData.geowerft_gtb_watchlist_active_detailed) {
        return true;
      }
      return false;
    },
    get_watchlist_detailed_current_icon: function get_watchlist_detailed_current_icon(current_prop_id) {
      var add_to_detailed_watchlist_svg = '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-add" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h400v80H160Zm0-480h640v-80H160v80ZM760-80v-120H640v-80h120v-120h80v120h120v80H840v120h-80ZM160-240v-480 480Z"/></svg>';
      var remove_from_detailed_watchlist_svg = '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-remove" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m871-203-71-71v-206H594L434-640h366v-80H354l-80-80h526q33 0 56.5 23.5T880-720v480q0 10-2 19.5t-7 17.5ZM385-462Zm192-35Zm-211 17H160v240h446L366-480ZM818-28 686-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800l80 80h-80v80h46L26-820l57-57L875-85l-57 57Z"/></svg>';
      var json_str_watch_list_detailed = this.geoWerftData.user_watchlist_detailed;

      if (true === json_str_watch_list_detailed.includes(current_prop_id.toString())) {
        return remove_from_detailed_watchlist_svg;
      } else {
        return add_to_detailed_watchlist_svg;
      }
    },
    check_current_watchlist_detailed_status: function check_current_watchlist_detailed_status(current_prop_id) {
      var json_str_watch_list_detailed = this.geoWerftData.user_watchlist_detailed;

      if (json_str_watch_list_detailed) {
        if (true === json_str_watch_list_detailed.includes(current_prop_id.toString())) {
          return "mw-detailed-watchlist-icon-wrapper mw-watchlist-detailed-remove";
        }
      }

      return "mw-detailed-watchlist-icon-wrapper mw-watchlist-detailed-add";
    },
    mw_gtb_open_login_or_register: function mw_gtb_open_login_or_register() {
      if (document.querySelector("#mw-ben-main-dialog")) {
        document.querySelector("#mw-ben-main-dialog").showModal();
      }
    },
    check_current_watchlist_status: function check_current_watchlist_status(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;

      var default_icon_class = "fa fa-star fa-2x";
      var default_icon_selected_class = "fa fa-star-o fa-2x";

      if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
        default_icon_class = "fa fa-heart fa-2x";
        default_icon_selected_class = "fa fa-heart-o fa-2x";
      }

      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (true === this.geoWerftData.geowerft_gtb_active && "" !== str_watch_list) {
        var tmp_new_list = "";
        var tmp_list_from_user_meta = JSON.parse(str_watch_list);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.entries(tmp_list_from_user_meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;

            var _ref3 = _slicedToArray(_ref2, 2);

            var key = _ref3[0];
            var value = _ref3[1];

            tmp_new_list += key + "|";
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      if ("" !== this.geoWerftData.geowerft_setting_watchlist_icon_custom) {
        default_icon_selected_class = "";
        default_icon_class = "";
      }

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          return default_icon_class + " mw-watchlist-ico mw-watchlist-delete";
        }
      }

      return default_icon_selected_class + " mw-watchlist-ico";
    },
    check_current_blacklist_status: function check_current_blacklist_status(current_prop_id) {
      var json_str_black_list = this.geoWerftData.user_blacklist;

      if (json_str_black_list) {
        if (true === json_str_black_list.includes(current_prop_id.toString())) {
          return "mw-blacklist-icon-wrapper mw-blacklist-remove";
        }
      }

      return "mw-blacklist-icon-wrapper mw-blacklist-add";
    },
    check_current_blacklist_status_title: function check_current_blacklist_status_title(current_prop_id) {
      var json_str_black_list = this.geoWerftData.user_blacklist;

      if (json_str_black_list) {
        if (true === json_str_black_list.includes(current_prop_id.toString())) {
          return "Immobilie einbeziehen";
        }
      }

      return "Immobilie ausschließen";
    },
    trigger_mw_blacklist: function trigger_mw_blacklist(current_prop_id, curr_click, user_id) {
      var _this2 = this;

      var current_method = "";
      if (jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper")).hasClass("mw-blacklist-add")) {
        current_method = "POST";
      }

      if (jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper")).hasClass("mw-blacklist-remove")) {
        current_method = "DELETE";
      }

      document.querySelector("#mw-ben-function-w8-loader").showModal();
      fetch(rest_url + "immowerft/v2/blacklist", {
        method: current_method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce
        },
        body: JSON.stringify({
          post_id: current_prop_id
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        document.querySelector("#mw-ben-function-w8-loader").close();
        if ("DELETE" !== current_method) {
          if ("true" === data.blacklist_status) {
            _this2.geoWerftData.objects.filtered = _this2.geoWerftData.objects.filtered.filter(function (obj) {
              return obj.id !== current_prop_id;
            });
          } else {
            jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper")).removeClass("mw-blacklist-add").addClass("mw-blacklist-remove").attr("title", "Immobilie einbeziehen");
          }
        } else {
          jQuery(curr_click.target.closest("div.mw-blacklist-icon-wrapper")).removeClass("mw-blacklist-remove").addClass("mw-blacklist-add").attr("title", "Immobilie ausschließen");
        }
      }).catch(function (error) {
        console.log("Fehler:", error);
      });
    },
    trigger_mw_watchlist_detailed: function trigger_mw_watchlist_detailed(current_prop_id, curr_click, user_id) {
      var current_method = "";
      var add_to_detailed_watchlist_svg = '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-add" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h400v80H160Zm0-480h640v-80H160v80ZM760-80v-120H640v-80h120v-120h80v120h120v80H840v120h-80ZM160-240v-480 480Z"/></svg>';
      var remove_from_detailed_watchlist_svg = '<svg class="mw-detailed-watchlist-icon-map mw-detailed-watchlist-icon-map-remove" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m871-203-71-71v-206H594L434-640h366v-80H354l-80-80h526q33 0 56.5 23.5T880-720v480q0 10-2 19.5t-7 17.5ZM385-462Zm192-35Zm-211 17H160v240h446L366-480ZM818-28 686-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800l80 80h-80v80h46L26-820l57-57L875-85l-57 57Z"/></svg>';
      if (jQuery(curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")).hasClass("mw-watchlist-detailed-add")) {
        current_method = "POST";
      }

      if (jQuery(curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")).hasClass("mw-watchlist-detailed-remove")) {
        current_method = "DELETE";
      }
      if (document.querySelector("#mw-ben-function-w8-loader")) {
        document.querySelector("#mw-ben-function-w8-loader").showModal();
      }

      fetch(rest_url + "benutzerwerft/v2/watchlist/detailed", {
        method: current_method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce
        },
        body: JSON.stringify({
          post_id: current_prop_id
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (document.querySelector("#mw-ben-function-w8-loader")) {
          document.querySelector("#mw-ben-function-w8-loader").close();
        }
        if ("POST" === current_method) {
          jQuery(curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")).removeClass("mw-watchlist-detailed-add").addClass("mw-watchlist-detailed-remove").attr("title", "Immobilie aus der Vergleichsliste raus nehmen").html(remove_from_detailed_watchlist_svg);
        } else {
          jQuery(curr_click.target.closest("div.mw-detailed-watchlist-icon-wrapper")).removeClass("mw-watchlist-detailed-remove").addClass("mw-watchlist-detailed-add").attr("title", "Immobilie in die Vergleichsliste aufnehmen").html(add_to_detailed_watchlist_svg);
        }
      }).catch(function (error) {
        console.log("Fehler:", error);
      });
    },
    trigger_mw_watchlist: function trigger_mw_watchlist(current_prop_id, curr_click, user_id) {
      if (!jQuery(curr_click.target).hasClass("mw-watchlist-delete")) {
        var str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
        var bool_already_in_list = false;
        if (str_watch_list) {
          var arr_list = str_watch_list.split("|");
          for (var key in arr_list) {
            if (arr_list[key].toString() === current_prop_id.toString()) {
              bool_already_in_list = true;
            }
          }
        }
        var new_list = "";
        if (false === bool_already_in_list) {
          if (null === str_watch_list) {
            str_watch_list = "";
          }
          new_list = str_watch_list + "|" + current_prop_id;
          if (true === this.geoWerftData.geowerft_gtb_active) {
            localStorage.setItem("mw_user_prop_watchlist_v2", new_list);
          } else {
            localStorage.setItem("mw_user_prop_watchlist", new_list);
          }
        }
        var default_icon_class = "fa fa-star fa-2x";

        if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
          default_icon_class = "fa fa-heart fa-2x";
        }

        // Nach dem Klick direkt die Klasse setzen.
        curr_click.target.classList = default_icon_class + " mw_watchlist_ico mw-watchlist-delete";

        // Hier prüfen, ob alte oder neue Route verwendet werden soll.
        if (true === this.geoWerftData.geowerft_gtb_active) {
          // Gutenberg Route für die Vergleich-Liste verwenden.
          fetch(rest_url + "benutzerwerft/v2/watchlist", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": wp_nonce.nonce
            },
            body: JSON.stringify({
              post_id: current_prop_id
            })
          });
        } else {
          jQuery.ajax({
            url: this.geoWerftData.texts.ajax_url,
            type: "POST",
            cache: false,
            data: {
              action: "add_prop_to_watchlist",
              new_prop_id: current_prop_id,
              current_user: user_id
            },
            success: function success(response) {}
          });
        }
      } else {
        var current_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          current_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
        var arr_list = current_list.split("|");
        for (var key in arr_list) {
          if (arr_list[key].toString() === current_prop_id.toString()) {
            arr_list.splice(key, 1);
          }
        }
        var newlist = arr_list.join("|");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          localStorage.setItem("mw_user_prop_watchlist_v2", newlist);
        } else {
          localStorage.setItem("mw_user_prop_watchlist", newlist);
        }

        var _default_icon_class = "fa fa-star-o fa-2x";

        if (true === this.geoWerftData.geowerft_setting_watchlist_icon) {
          _default_icon_class = "fa fa-heart-o fa-2x";
        }

        // Nach dem Klick direkt die Klasse setzen.
        curr_click.target.classList = _default_icon_class + " mw-watchlist-ico";

        // Hier prüfen, ob alte oder neue Route verwendet werden soll.
        if (true === this.geoWerftData.geowerft_gtb_active) {
          fetch(rest_url + "benutzerwerft/v2/watchlist", {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": wp_nonce.nonce
            },
            body: JSON.stringify({
              post_id: current_prop_id
            })
          });
        } else {
          jQuery.ajax({
            url: this.geoWerftData.texts.ajax_url,
            type: "POST",
            cache: false,
            data: {
              action: "mw_delete_immo_from_watch_list",
              to_delete_id: current_prop_id,
              current_user: user_id
            },
            success: function success(response) {}
          });
        }
      }
    },
    trigger_mw_watchlist_new: function trigger_mw_watchlist_new(current_prop_id, curr_click, user_id) {
      // Normalize clicked element
      var target = curr_click && curr_click.target ? curr_click.target : null;
      var svgEl = null;

      if (target) {
        var tag = target.tagName ? target.tagName.toLowerCase() : "";
        if (tag === "svg") {
          svgEl = target;
        } else if (tag === "path") {
          var parentSvg = target.closest ? target.closest("svg") : null;
          if (parentSvg) {
            svgEl = parentSvg;
          }
        }
      }

      var method = "";
      if (svgEl && svgEl.classList.contains("watchlist-add-icon")) {
        method = "POST";
        svgEl.closest("div.mw-watchlist-remember-immo").title = "Immobilie nicht mehr merken";
        svgEl.classList.add("mw-watchlist-delete");
        svgEl.classList.remove("watchlist-add-icon");
      } else if (svgEl && svgEl.classList.contains("mw-watchlist-delete")) {
        method = "DELETE";
        svgEl.closest("div.mw-watchlist-remember-immo").title = "Immobilie merken";
        svgEl.classList.add("watchlist-add-icon");
        svgEl.classList.remove("mw-watchlist-delete");
      }
      if (document.querySelector("#mw-ben-function-w8-loader")) {
        document.querySelector("#mw-ben-function-w8-loader").showModal();
      }
      fetch(rest_url + "benutzerwerft/v2/watchlist", {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce
        },
        body: JSON.stringify({
          post_id: current_prop_id
        })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (document.querySelector("#mw-ben-function-w8-loader")) {
          document.querySelector("#mw-ben-function-w8-loader").close();
        }
      }).catch(function (error) {
        console.log("Fehler:", error);
      });
    },
    get_new_watchlist_titel: function get_new_watchlist_titel(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;
      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (true === this.geoWerftData.geowerft_gtb_active && "" !== str_watch_list) {
        var tmp_new_list = "";
        var tmp_list_from_user_meta = JSON.parse(str_watch_list);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = Object.entries(tmp_list_from_user_meta)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ref4 = _step2.value;

            var _ref5 = _slicedToArray(_ref4, 2);

            var key = _ref5[0];
            var value = _ref5[1];

            tmp_new_list += key + "|";
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      var current_titel = "Immobilie merken";

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          current_titel = "Immobilie nicht mehr merken";
        }
      }
      return current_titel;
    },
    get_new_watchlist_icon: function get_new_watchlist_icon(current_prop_id) {
      var str_watch_list = this.geoWerftData.user_watchlist;
      // Wenn Gutenberg für die Merkliste verwendet wird, muss noch einmal das Meta aufbereitet werden.
      if (true === this.geoWerftData.geowerft_gtb_active && "" !== str_watch_list) {
        var tmp_new_list = "";
        var tmp_list_from_user_meta = JSON.parse(str_watch_list);
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = Object.entries(tmp_list_from_user_meta)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref6 = _step3.value;

            var _ref7 = _slicedToArray(_ref6, 2);

            var key = _ref7[0];
            var value = _ref7[1];

            tmp_new_list += key + "|";
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        str_watch_list = tmp_new_list;
        localStorage.setItem("mw_user_prop_watchlist_v2", str_watch_list);
      }

      if (str_watch_list === "") {
        // Versuchen mit dem Localstorage zu arbeiten.
        str_watch_list = localStorage.getItem("mw_user_prop_watchlist");
        if (true === this.geoWerftData.geowerft_gtb_active) {
          str_watch_list = localStorage.getItem("mw_user_prop_watchlist_v2");
        }
      }

      // Basierend auf dem Custom-Icon (SVG-String)
      var customSvg = this.geoWerftData.geowerft_setting_watchlist_icon_custom || "";

      if (str_watch_list) {
        var arr_list = str_watch_list.split("|");
        if (true === arr_list.includes(current_prop_id.toString())) {
          // Falls Objekt bereits gemerkt ist: SVG zurückgeben, aber mit Klasse "mw-watchlist-delete"
          if (typeof customSvg === "string") {
            // Ersetze alle Vorkommen der Default-Klasse durch die Delete-Klasse
            return customSvg.replace(/watchlist-add-icon/g, "mw-watchlist-delete");
          }
          return customSvg;
        }
      }
      // Standard: Unverändertes SVG zurückgeben
      return customSvg;
    },
    get_correct_info_text: function get_correct_info_text() {
      var info_text = this.geoWerftData.texts.text_sc_info_text;
      if (info_text === "") {
        info_text = this.geoWerftData.texts.not_in_scope_text;
      }
      return info_text;
    },
    parseDate: function parseDate(input) {
      var format = "dd.mm.yyyy"; // default format
      var parts = input.match(/(\d+)/g),
          i = 0,
          fmt = {};
      // extract date-part indexes from the format
      format.replace(/(yyyy|dd|mm)/g, function (part) {
        fmt[part] = i++;
      });

      return new Date(parts[fmt["yyyy"]], parts[fmt["mm"]] - 1, parts[fmt["dd"]]);
    },
    send_info_to_map: function send_info_to_map(current_id) {
      __WEBPACK_IMPORTED_MODULE_0__data_eventbus_js__["default"].$emit("geowerft_list_click", current_id);
    },
    handle_picture_click: function handle_picture_click(current_prop, event) {
      if (this.geoWerftData.current_map_mode === "list" && true === this.geoWerftData.checkboxes.picture_click_active && "h2" !== event.target.localName && "div" !== event.target.localName && "em" !== event.target.localName || true === this.geoWerftData.checkboxes.picture_click_always_active) {
        var current_hp_status = current_prop.homepage_status;
        var current_vermakt = current_prop.vermarktungsart;
        var result = void 0;
        if ((current_hp_status === "Aktive Marktbeobachtung" || current_vermakt === "Fremdobjekt") && current_prop.link_extern === "" && false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active) {
          result = "";
        } else if ((current_hp_status === "Aktive Marktbeobachtung" || current_vermakt === "Fremdobjekt") && true === this.geoWerftData.checkboxes.logged_in_market_watch && false === this.geoWerftData.user.logged_in) {
          result = this.geoWerftData.texts.market_watch_alt_link;
        } else if ((current_hp_status === "Aktive Marktbeobachtung" || current_vermakt === "Fremdobjekt") && false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active) {
          result = current_prop.link_extern;
        } else if (true === this.geoWerftData.show_extern_link && current_prop.link_extern !== "" && false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active) {
          result = current_prop.link_extern;
        } else if (this.geoWerftData.checkboxes.other_info_window) {
          result = current_prop.link;
        } else {
          result = current_prop.link;
        }
        if (result !== "") {
          window.open(result, "_blank");
        }
      }
      this.list_trigger_ajax_request(current_prop);
    },
    handle_custom_link_click: function handle_custom_link_click(link) {
      window.open(link, "_blank");
    },
    get_format_price: function get_format_price(number, current_prop) {
      if (true === this.geoWerftData.price_on_request_cb && parseInt(current_prop.oo_price_on_request || "") === 1) {
        return "Auf Anfrage";
      }
      if (undefined === number || "" === number) {
        return "";
      }
      if (this.geoWerftData.checkboxes.format_prices_cb) {
        number = number.toString().replace(",", ".");
        var val = (number / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        number = parseInt(number);
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    set_alt_tag: function set_alt_tag(current_prop) {
      var map_picture_alt = current_prop.map_picture_alt || "";
      if (map_picture_alt === "") {
        map_picture_alt = current_prop.objektart_raw || "Bild der Immobilie";
      }
      return map_picture_alt;
    },
    handle_place_view: function handle_place_view(current_prop) {
      var tmp_place = current_prop.ort || "";
      if ("" === tmp_place && true === this.geoWerftData.checkboxes.show_geo_as_fallback) {
        tmp_place = current_prop.geolage || "";
      }
      return tmp_place;
    },
    get_customizer_image_for_marker: function get_customizer_image_for_marker(currentMarkerStatus) {
      var display_badge_new = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var link = void 0;

      link = this.geoWerftData.marker_image.google_maps_marker_default + "/images/GooglePin.png";

      if (currentMarkerStatus === "" || currentMarkerStatus === undefined) {
        return link;
      }

      if (display_badge_new !== "") {
        return this.geoWerftData.marker_image.google_maps_marker_badge_new;
      }

      currentMarkerStatus = currentMarkerStatus.toLowerCase();

      switch (currentMarkerStatus) {
        case "online":
          if (this.geoWerftData.marker_image.google_maps_marker_online !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_online;
          }
          break;
        case "in vorbereitung":
          if (this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung;
          }
          break;
        case "verkauft":
          if (this.geoWerftData.marker_image.google_maps_marker_verkauft !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_verkauft;
          }
          break;
        case "referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_referenz !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_referenz;
          }
          break;
        case "secret sale":
          if (this.geoWerftData.marker_image.google_maps_marker_secret_sale !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_secret_sale;
          }
          break;
        case "aktive marktbeobachtung":
          if (this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung;
          }
          break;
        case "marktbeobachtung":
          if (this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung;
          }
          break;
        case "neubau":
        case "neubau stammobjekt":
        case "neubau stammobjekt referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau objekt":
          if (this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_neubaureferenz !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubaureferenz;
          }
          break;
        case "exklusiv referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_exlusive_object !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_exlusive_object;
          }
          break;
        case "bieterverfahren":
          if (this.geoWerftData.marker_image.google_maps_marker_auction !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_auction;
          }
          break;
        case "mietbörse":
        case "mietboerse":
          if (this.geoWerftData.marker_image.google_maps_marker_mietboerse !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_mietboerse;
          }
          break;
        case "immobiliendepot":
          if (this.geoWerftData.marker_image.google_maps_marker_immobiliendepot !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_immobiliendepot;
          }
          break;
        default:
          link = this.geoWerftData.marker_image.google_maps_marker_default + "/images/GooglePin.png";
          break;
      }

      return link;
    },

    sanitize_title_method: function sanitize_title_method(value) {
      if (typeof value === "undefined" || value === null) {
        return "";
      }
      return value.replace(/\s+/g, "-").toLowerCase();
    },
    replaceUmlauts: function replaceUmlauts(inputStr) {
      var map = {
        ä: "ae",
        ö: "oe",
        ü: "ue",
        ß: "ss",
        Ä: "Ae",
        Ö: "Oe",
        Ü: "Ue"
      };

      return inputStr.replace(/[äöüßÄÖÜ]/g, function (match) {
        return map[match];
      });
    },


    get_link_extern: function get_link_extern(object) {
      var result = "";
      if (object.link_extern) {
        result = object.link_extern.replace("https://www.", "").replace("https://", "").split("/")[0];
      }
      return result;
    },
    get_the_title: function get_the_title(current_prop) {
      var current_title = void 0;
      current_title = current_prop.objektart_raw;
      if (current_prop.vermarktungsart !== undefined && current_prop.vermarktungsart !== "not_set_ver" && current_prop.vermarktungsart !== "") {
        current_title = current_title + "-" + current_prop.vermarktungsart;
      }
      if ((current_prop.homepage_status || "").toLowerCase() === "verkauft" && (current_prop.erwerbsart || "").toLowerCase() === "rent") {
        current_title = current_title + "-" + "Vermietet";
      } else {
        current_title = current_title + "-" + current_prop.homepage_status;
      }
      return this.decodeHtmlEntity(current_title);
    },
    decodeHtmlEntity: function decodeHtmlEntity(str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_eventbus_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps_dist_components_cluster__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps_dist_components_cluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps_dist_components_cluster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InfoWindow__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoWindowPaginator__ = __webpack_require__(76);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    GmapCluster: __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps_dist_components_cluster___default.a,
    InfoWindow: __WEBPACK_IMPORTED_MODULE_2__InfoWindow__["a" /* default */],
    InfoWindowPaginator: __WEBPACK_IMPORTED_MODULE_3__InfoWindowPaginator__["a" /* default */]
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_0__data_eventbus_js__["default"].$on("geowerft_list_click", function (current_id) {
      that.geoWerftData.map.zoom = that.geoWerftData.map.maxZoom;
      that.toggle_single_info_window_on_emit(current_id);
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        var elmnt = document.getElementById("geowerft-map-wrapper");
        elmnt.scrollIntoView();
      }
    });
  },

  props: ["geoWerftData"],
  data: function data() {
    return {
      estates: [],
      gridSize: 50,
      clusterStyles: [{
        textColor: "white",
        url: this.geoWerftData.cluster_pin_far,
        height: 32.2,
        width: 33,
        fontWeight: this.geoWerftData.cluster_font_weight
      }, {
        textColor: "white",
        url: this.geoWerftData.cluster_pin_far,
        height: 32.2,
        width: 33,
        fontWeight: this.geoWerftData.cluster_font_weight
      }, {
        textColor: "white",
        url: this.geoWerftData.cluster_pin_far,
        height: 32.2,
        width: 33,
        fontWeight: this.geoWerftData.cluster_font_weight
      }],
      infoContent: "",
      image_url: "",
      permalink: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      win_id: "",
      win_price: "",
      win_price_rent: "",
      win_price_qm: "",
      win_objekttitel: "",
      win_plz: "",
      win_ort: "",
      win_geolocation: "",
      win_objektart_raw: "",
      win_kennung: "",
      win_count_adults: "",
      win_count_childs: "",
      win_barrierefrei: "",
      win_haustiere: "",
      win_zimmer: "",
      win_teilbarkeit: "",
      win_bueroflaeche: "",
      win_bezug: "",
      win_wohnflaeche: "",
      win_vermietbare_flaeche: "",
      win_grundstuecksflaeche: "",
      win_homepage_status: "",
      win_link_extern: "",
      win_link_extern_url: "",
      win_headline: "",
      win_headline_ort: "",
      win_strasse: "",
      win_tel: "",
      win_tel_zwei: "",
      win_mail: "",
      win_fax: "",
      win_vermarktungsart: "",
      win_erwerbsart: "",
      win_res_begin: "",
      win_res_ende: "",
      win_display_badge_new: "",
      win_filialen_id: "",
      win_img_src: "",
      win_name: "",
      win_gesamtflaeche: "",
      win_tour: "",
      coords_array: [],
      current_center: 0,
      props_loaded_once: false,
      init_optimal_bounds: []
    };
  },

  computed: {
    filteredObjects: function filteredObjects() {
      return this.geoWerftData.objects.filtered.length;
    },
    loadingStatus: function loadingStatus() {
      // Return the length of the objects array
      return this.geoWerftData.objects.visible.length;
    },
    inView: function inView() {
      // Return the length of the objects array
      return this.geoWerftData.objects.visible;
    },
    found_props: function found_props() {
      return this.geoWerftData.objects.all.length;
    }
  },
  watch: {
    filteredObjects: function filteredObjects(len) {
      this.build_coords_array();
    },
    loadingStatus: function loadingStatus(arrayLength) {
      var _this = this;

      if (true === this.geoWerftData.enable_comfort_zoom && arrayLength > 0 && this.props_loaded_once === false && !new URLSearchParams(window.location.search).get("google_search")) {
        this.props_loaded_once = true;
        this.$refs.main_gmap_obj.$mapPromise.then(function (main_map_obj) {
          _this.generateOptimalMapSettings(main_map_obj, _this.geoWerftData.objects.filtered);
        });
      }
      this.addMarkers();
    }
  },
  methods: {
    generateOptimalMapSettings: function generateOptimalMapSettings(map_obj, filtered_props) {
      // Calculate the bounds of the locations.
      var tmp_bounds = new google.maps.LatLngBounds();
      filtered_props.forEach(function (single_prop) {
        // Extend the bounds to include this location.
        if (single_prop.geo_latitude && single_prop.geo_longitude) {
          tmp_bounds.extend(new google.maps.LatLng(single_prop.geo_latitude, single_prop.geo_longitude));
        }
      });
      this.geoWerftData.map.center = tmp_bounds.getCenter();
      map_obj.fitBounds(tmp_bounds);
      // Hier die Bounds zwischenspeichern, um diese später nutzen zu können.
      this.init_optimal_bounds = tmp_bounds;
    },
    mw_restore_init_bounds: function mw_restore_init_bounds() {
      this.geoWerftData.map.center = this.init_optimal_bounds.getCenter();
      this.$refs.main_gmap_obj.fitBounds(this.init_optimal_bounds);
    },
    mw_change_watchlist_status_on_load: function mw_change_watchlist_status_on_load(current_id) {
      if (current_id && document.querySelector("#watch-class-" + current_id) && document.querySelector("#watch-class-" + current_id).classList.contains("mw-watchlist-delete")) {
        setTimeout(function () {
          document.querySelector("#mw-gtb-like-in-window-" + current_id).classList.add("mw-gtb-watchlist-liked");
        }, 800);
      }
    },
    mw_format_area: function mw_format_area(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      var result = number;
      // replace special chars.
      result = this.replace_special_chars(result);
      // format the price.
      return new Intl.NumberFormat("de-DE", {
        style: "decimal"
      }).format(result);
    },
    replace_special_chars: function replace_special_chars(str_number) {
      if (str_number.substring(str_number.length - 3) === ".00") {
        str_number = str_number.substring(0, str_number.length - 3);
      }

      str_number = str_number.replace(/€/g, "");
      str_number = str_number.replace(/CHF/g, "");
      str_number = str_number.replace(/m²/g, "");

      // Variante aus der Immowerft in JS implementiert
      var num_position_comma = str_number.indexOf(",");
      var num_position_dot = str_number.indexOf(".");
      var check_number = str_number.replace(",", "|");
      if (num_position_comma > num_position_dot) {
        check_number = check_number.replace(".", "");
      }
      str_number = check_number.replace("|", ".");

      str_number = str_number.trim();
      return str_number;
    },
    geowerft_get_cookie_by_name: function geowerft_get_cookie_by_name(cookie_name) {
      var name = cookie_name + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var cookie_list = decodedCookie.split(";");
      var len = cookie_list.length;
      for (var i = 0; i < len; i++) {
        var current_cookie = cookie_list[i];
        while (current_cookie.charAt(0) === " ") {
          current_cookie = current_cookie.substring(1);
        }
        if (current_cookie.indexOf(name) === 0) {
          return current_cookie.substring(name.length, current_cookie.length);
        }
      }
      return "empty";
    },
    mw_set_geowerft_cookie: function mw_set_geowerft_cookie(name) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "1";
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var maxAgeSeconds = options.maxAgeSeconds,
          days = options.days,
          hours = options.hours,
          minutes = options.minutes,
          _options$path = options.path,
          path = _options$path === undefined ? "/" : _options$path,
          domain = options.domain,
          _options$secure = options.secure,
          secure = _options$secure === undefined ? typeof location !== "undefined" ? location.protocol === "https:" : false : _options$secure,
          _options$sameSite = options.sameSite,
          sameSite = _options$sameSite === undefined ? "Lax" : _options$sameSite;

      // Wert sicher kodieren

      var encodedValue = encodeURIComponent(String(value));

      // Dauer berechnen
      var parts = [name + "=" + encodedValue];

      if (typeof maxAgeSeconds === "number") {
        parts.push("Max-Age=" + Math.max(0, Math.floor(maxAgeSeconds)));
      } else if (days || hours || minutes) {
        var totalMs = (days ? days * 24 * 60 * 60 * 1000 : 0) + (hours ? hours * 60 * 60 * 1000 : 0) + (minutes ? minutes * 60 * 1000 : 0);
        var expires = new Date(Date.now() + totalMs).toUTCString();
        parts.push("Expires=" + expires);
      } else {
        // Fallback: 1 Jahr
        var _expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
        parts.push("Expires=" + _expires);
      }

      // Path/Domain
      if (path) parts.push("Path=" + path);
      if (domain) parts.push("Domain=" + domain);

      // SameSite/ Secure
      if (sameSite) parts.push("SameSite=" + sameSite);
      if (secure || sameSite === "None") parts.push("Secure");

      document.cookie = parts.join("; ");
    },
    render_next_tutorial_step: function render_next_tutorial_step(event) {
      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      var current_action = event.target.getAttribute("data-geo-tutorial");
      var current_box = event.target.getAttribute("data-geo-box");
      var next_box = event.target.getAttribute("data-geo-box-next");
      var wrapper = document.querySelector(".geowerft-tutorial-wrapper");

      var arrow_one = document.querySelector(".mw-geo-arrow-one-wrapper");
      var arrow_two = document.querySelector(".mw-geo-arrow-two-wrapper");
      var arrow_three = document.querySelector(".mw-geo-arrow-three-wrapper");
      var arrow_wrapper = document.querySelector(".mw-geowerft-tut-arrow-wrapper");

      switch (current_action) {
        case "skip":
          // Falls die Marktbeobachtungserklärung aktiv ist, wird dieser schritt abgeändert.
          if ("three" === step && true === this.geoWerftData.checkboxes.prop_offline_include_overlay && true === this.geoWerftData.user.logged_in) {
            arrow_wrapper.style.display = "none";
            arrow_three.style.display = "none";
            document.querySelector(".geowerft-tutorialbox-three-wrapper").style.display = "none";
            document.querySelector("#prop-offline-explain").style.display = "block";
          } else {
            // Der Benutzer möchte das Tutorial überspringen. Cookie setzen und schließen.
            wrapper.style.display = "none";
            arrow_wrapper.style.display = "none";
            arrow_three.style.display = "none";
            arrow_two.style.display = "none";
            arrow_one.style.display = "none";
            this.mw_set_geowerft_cookie("geowerft_tutorial", "1", { days: 30 });
          }
          break;
        case "box-2":
          arrow_one.style.display = "none";
          arrow_two.style.display = "block";
          document.querySelector("." + current_box).style.display = "none";
          document.querySelector("." + next_box).style.display = "block";
          break;
        case "box-3":
          arrow_two.style.display = "none";
          arrow_three.style.display = "block";
          document.querySelector("." + current_box).style.display = "none";
          document.querySelector("." + next_box).style.display = "block";
          break;
      }
    },
    update_current_map_center: function update_current_map_center(event) {
      this.geoWerftData.map.center = this.current_center;
    },
    get_current_zoom: function get_current_zoom(zoom) {
      this.geoWerftData.map.zoom = zoom;
    },
    setPlace: function setPlace(place) {
      if (!place) return;
      this.geoWerftData.map.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.geoWerftData.map.zoom = parseInt(this.geoWerftData.map_settings.google_search_zoom_level);
    },
    searchLocation: function searchLocation(event) {
      // Don't run if value is missing
      if (undefined == event) {
        return;
      }
      // Get the values from the event
      var northEast = event.getNorthEast();
      var southWest = event.getSouthWest();
      // Update the dat bus
      this.geoWerftData.map.bound = {
        northEast: {
          lat: parseFloat(northEast.lat()),
          lng: parseFloat(northEast.lng())
        },
        southWest: {
          lat: parseFloat(southWest.lat()),
          lng: parseFloat(southWest.lng())
        }
      };
      this.current_center = event.getCenter();
    },
    get_customizer_image_for_marker: function get_customizer_image_for_marker(currentMarkerStatus, display_badge_new) {
      var link = "";

      if (currentMarkerStatus) {
        currentMarkerStatus = currentMarkerStatus.toLowerCase();
      }

      if (display_badge_new) {
        return this.geoWerftData.marker_image.google_maps_marker_badge_new;
      }

      switch (currentMarkerStatus) {
        case "online":
          if (this.geoWerftData.marker_image.google_maps_marker_online !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_online;
          }
          break;
        case "in vorbereitung":
          if (this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_in_vorbereitung;
          }
          break;
        case "verkauft":
          if (this.geoWerftData.marker_image.google_maps_marker_verkauft !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_verkauft;
          }
          break;
        case "referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_referenz !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_referenz;
          }
          break;
        case "secret sale":
          if (this.geoWerftData.marker_image.google_maps_marker_secret_sale !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_secret_sale;
          }
          break;
        case "aktive marktbeobachtung":
          if (this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung;
          }
          break;
        case "marktbeobachtung":
          if (this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_marktbeobachtung;
          }
          break;
        case "neubau":
        case "neubau stammobjekt":
        case "neubau stammobjekt referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau objekt":
          if (this.geoWerftData.marker_image.google_maps_marker_neubauobjekt !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubauobjekt;
          }
          break;
        case "neubau referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_neubaureferenz !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_neubaureferenz;
          }
          break;
        case "exklusiv referenz":
          if (this.geoWerftData.marker_image.google_maps_marker_exlusive_object !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_exlusive_object;
          }
          break;
        case "bieterverfahren":
          if (this.geoWerftData.marker_image.google_maps_marker_auction !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_auction;
          }
          break;
        case "mietbörse":
        case "mietboerse":
          if (this.geoWerftData.marker_image.google_maps_marker_mietboerse !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_mietboerse;
          }
          break;
        case "immobiliendepot":
          if (this.geoWerftData.marker_image.google_maps_marker_immobiliendepot !== false) {
            link = this.geoWerftData.marker_image.google_maps_marker_immobiliendepot;
          }
          break;
        default:
          link = this.geoWerftData.marker_image.google_maps_marker_default + "/images/GooglePin.png";
          break;
      }

      return link;
    },
    build_coords_array: function build_coords_array() {
      this.coords_array = [];
      for (var i = 0; i < this.geoWerftData.objects.filtered.length; i++) {
        // Hier Prüfen ob nur bestimmte Objekte ausgeschlossen werden sollen.
        if (true === this.geoWerftData.checkboxes.exclude_in_closest_prop && (this.geoWerftData.texts.exclude_in_closest_prop_status.includes(this.geoWerftData.objects.filtered[i].homepage_status) || this.geoWerftData.texts.exclude_in_closest_prop_status.includes(this.geoWerftData.objects.filtered[i].vermarktungsart))) {
          // Wenn das aktuelle Objekt ein treffer ist dann im Loop überspringen.
          continue;
        }
        this.coords_array.push({
          position: {
            lat: parseFloat(this.geoWerftData.objects.filtered[i].geo_latitude),
            lng: parseFloat(this.geoWerftData.objects.filtered[i].geo_longitude)
          }
        });
      }
    },
    set_selected_prop_offline: function set_selected_prop_offline(dom_elm, id) {
      if (id && true === this.geoWerftData.checkboxes.allow_prop_offline_detection) {
        var that = this;
        if (confirm(this.geoWerftData.texts.prop_offline_explain_text)) {
          jQuery.ajax({
            url: rest_url + "geowerft/v1/property/" + id + "/offline",
            method: "PUT",
            data: {
              actionkind: this.geoWerftData.texts.prop_offline_akt_kind,
              actiontype: this.geoWerftData.texts.prop_offline_akt_type
            },
            beforeSend: function beforeSend(xhr) {
              xhr.setRequestHeader("X-WP-Nonce", wp_nonce.nonce);
            }
          }).done(function (response) {
            alert(that.geoWerftData.texts.prop_offline_success_text);
            setTimeout(function () {
              location.reload(true);
            }, 2000);
          });
        }
      }
    },
    addMarkers: function addMarkers() {
      // Empty the markers array
      this.geoWerftData.map.markers = [];
      this.geoWerftData.map.no_cluster_markers = [];

      // Loop the objects and put them on the map
      var title = void 0,
          url = void 0;
      var exclude_status = "";
      for (var i = 0; i < this.geoWerftData.objects.visible.length; i++) {
        // Add marker to the array

        title = (this.geoWerftData.objects.visible[i].kennung || "") + "-";

        if (this.geoWerftData.checkboxes.enable_filialen_mode) {
          title = this.geoWerftData.objects.visible[i].ort;
          url = this.geoWerftData.cluster_pin_near;
        } else {
          title += this.geoWerftData.objects.visible[i].objektart_raw || "";
          if (this.geoWerftData.objects.visible[i].vermarktungsart !== "" && this.geoWerftData.objects.visible[i].vermarktungsart !== "not_set_ver" && this.geoWerftData.objects.visible[i].vermarktungsart !== undefined) {
            title = title + "-" + this.geoWerftData.objects.visible[i].vermarktungsart;
          }
          if (this.geoWerftData.objects.visible[i].homepage_status.toLowerCase() === "verkauft" && this.geoWerftData.objects.visible[i].erwerbsart.toLowerCase() === "rent") {
            title = title + "-" + "Vermietet";
          } else if (this.geoWerftData.objects.visible[i].homepage_status) {
            title = title + "-" + this.geoWerftData.objects.visible[i].homepage_status;
          }
          if (undefined === this.geoWerftData.objects.visible[i].map_pin || "" === this.geoWerftData.objects.visible[i].map_pin) {
            url = this.get_customizer_image_for_marker(this.geoWerftData.objects.visible[i].homepage_status, this.geoWerftData.objects.visible[i].display_badge_new);
          } else {
            url = this.geoWerftData.objects.visible[i].map_pin;
          }
          if (this.geoWerftData.objects.visible[i].vermarktungsart) {
            exclude_status = "," + this.geoWerftData.objects.visible[i].vermarktungsart.toLowerCase() + ",";
          }
        }

        // Wenn die Funktion an ist und nicht leer, dann werden nur Pins geclustert die Übergeben werden.
        if (this.geoWerftData.checkboxes.select_cluster_active && "" !== this.geoWerftData.texts.select_cluster_hp_to_show && this.geoWerftData.texts.select_cluster_hp_to_show.indexOf(exclude_status, 0) === -1) {
          this.geoWerftData.map.no_cluster_markers.push({
            // Add position
            position: {
              lat: parseFloat(this.geoWerftData.objects.visible[i].geo_latitude),
              lng: parseFloat(this.geoWerftData.objects.visible[i].geo_longitude)
            },
            permalink: this.geoWerftData.objects.visible[i].link,
            title: this.decodeHtmlEntity(title),
            url: url,
            label: "",
            animation: null,
            id: this.geoWerftData.objects.visible[i].id,
            index: i
          });
        } else {
          this.geoWerftData.map.markers.push({
            // Add position
            position: {
              lat: parseFloat(this.geoWerftData.objects.visible[i].geo_latitude),
              lng: parseFloat(this.geoWerftData.objects.visible[i].geo_longitude)
            },
            permalink: this.geoWerftData.objects.visible[i].link,
            title: this.decodeHtmlEntity(title),
            url: url,
            label: "",
            animation: null,
            id: this.geoWerftData.objects.visible[i].id,
            index: 1
          });
        }
      }
    },
    get_the_closest_marker: function get_the_closest_marker() {
      var distance_table = [];
      var current_marker = "";
      for (var i = 0; i < this.coords_array.length; i++) {
        var current_distance = this.getDistance(this.current_center, this.coords_array[i].position);
        distance_table.push({
          distance: { current_distance: current_distance },
          markerpos: this.coords_array[i].position
        });
      }
      current_marker = this.get_smalest_number(distance_table);
      if (!isNaN(distance_table[current_marker].markerpos.lat) && !isNaN(distance_table[current_marker].markerpos.lng) && distance_table[current_marker].markerpos !== undefined) {
        this.geoWerftData.map.center = distance_table[current_marker].markerpos;
      }
    },
    get_smalest_number: function get_smalest_number(temp) {
      var index = 0;
      // Set Very high starting value to get the best result.
      var value = 99999999999999999999999;
      for (var i = 0; i < temp.length; i++) {
        if (!isNaN(temp[i].distance.current_distance) && !isNaN(temp[i].markerpos.lat) && !isNaN(temp[i].markerpos.lng)) {
          if (temp[i].distance.current_distance < value) {
            value = temp[i].distance.current_distance;
            index = i;
          }
        }
      }
      return index;
    },
    getDistance: function getDistance(current_center, current_marker) {
      var rad = function rad(x) {
        return x * Math.PI / 180;
      };
      var earth_radius = 6378137; // Earth’s mean radius in meter
      var dLat = rad(current_marker.lat - current_center.lat());
      var dLong = rad(current_marker.lng - current_center.lng());
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(current_center.lat())) * Math.cos(rad(current_marker.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = earth_radius * c;
      return distance; // returns the distance in meter
    },
    decodeHtmlEntity: function decodeHtmlEntity(str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    },
    toggle_single_info_window_on_emit: function toggle_single_info_window_on_emit(current_id) {
      var fake_marker = [];
      for (var i = 0; i < this.geoWerftData.objects.visible.length; i++) {
        if (this.geoWerftData.objects.visible[i].id === current_id) {
          fake_marker = {
            position: {
              lat: parseFloat(this.geoWerftData.objects.visible[i].geo_latitude),
              lng: parseFloat(this.geoWerftData.objects.visible[i].geo_longitude)
            }
          };
          if (this.geoWerftData.checkboxes.enable_filialen_mode) {
            this.toggle_filialen_window(fake_marker, i);
          } else {
            this.toggleInfoWindow(fake_marker, i);
          }
          break;
        }
      }
    },
    get_placeholder_img_by_hp: function get_placeholder_img_by_hp(homepage_status, img_url, prop_type) {
      if (homepage_status !== undefined && prop_type !== undefined && false === this.geoWerftData.interactive_filter_active) {
        switch (homepage_status.toLowerCase()) {
          case "secret sale":
            img_url = this.geoWerftData.image_placeholder_secret;
            break;
          case "aktive marktbeobachtung":
            img_url = this.geoWerftData.image_placeholder_market_watch;
            if ("haus" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_house;
            }
            if ("wohnung" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_flat;
            }
            if ("grundstück" === prop_type.toLowerCase()) {
              img_url = this.geoWerftData.image_placeholder_market_watch_plot;
            }
            if ("" === img_url) {
              img_url = this.geoWerftData.image_placeholder_market_watch;
            }
            break;
          default:
            break;
        }
      }
      return img_url;
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.markerInfo = true;
      localStorage.setItem("mw-last-visit-immoslider", window.location.href);
      this.win_id = this.inView[idx].id || "";
      this.win_display_badge_new = this.inView[idx].display_badge_new || "";
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;
      if (this.inView[idx].object_image_url === undefined || this.inView[idx].object_image_url === "") {
        this.inView[idx].object_image_url = this.inView[idx].map_picture || "";
      }
      this.win_gesamtflaeche = this.mw_format_area(this.inView[idx].gesamtflaeche || "");
      this.win_tour = this.inView[idx].ogulo_tour || "";

      this.image_url = this.inView[idx].object_image_url || "";
      this.win_objekttitel = this.inView[idx].objekttitel || "";
      if (undefined !== this.inView[idx].plz) {
        this.win_plz = this.inView[idx].plz;
      }
      this.win_ort = this.inView[idx].ort || "";
      this.win_geolocation = this.inView[idx].geolage || "";
      // Check if Objektart_geowerft is set.
      if ((this.inView[idx].objektart_geowerft || "") === "") {
        this.win_objektart_raw = this.inView[idx].objektart_raw || "";
      } else {
        this.win_objektart_raw = this.inView[idx].objektart_geowerft || "";
      }
      if (true === this.geoWerftData.geo_display_objecttype && this.inView[idx].objekttyp) {
        this.win_objektart_raw = this.inView[idx].objekttyp.charAt(0).toUpperCase() + this.inView[idx].objekttyp.slice(1);
      }
      this.win_vermarktungsart = this.inView[idx].vermarktungsart || "";
      this.win_kennung = this.inView[idx].kennung || "";
      this.win_count_adults = this.inView[idx].count_adults || 0;
      this.win_count_childs = this.inView[idx].count_childs || 0;
      this.win_barrierefrei = this.inView[idx].barrierefrei || 0;
      this.win_haustiere = this.inView[idx].haustiere || 0;
      this.win_price = this.inView[idx].kaufpreis || 0;
      this.win_price_rent = this.inView[idx].nettokaltmiete || 0;
      this.win_price_qm = this.inView[idx].mietpreis_pro_qm || 0;
      this.win_teilbarkeit = this.mw_format_area(this.inView[idx].teilbar_ab);
      this.win_bueroflaeche = this.mw_format_area(this.inView[idx].bueroflaeche);
      this.win_bezug = this.inView[idx].bezug || "";
      this.win_zimmer = this.inView[idx].anzahl_zimmer || 0;
      this.win_wohnflaeche = this.mw_format_area(this.inView[idx].wohnflaeche);
      this.win_vermietbare_flaeche = this.mw_format_area(this.inView[idx].vermietbare_flaeche);
      this.win_grundstuecksflaeche = this.mw_format_area(this.inView[idx].grundstuecksflaeche);
      this.win_homepage_status = this.inView[idx].homepage_status || "";
      this.win_link_extern_url = this.inView[idx].link_extern || "";
      if ((this.inView[idx].homepage_status && "aktive marktbeobachtung" === this.inView[idx].homepage_status.toLowerCase() || this.inView[idx].vermarktungsart && "fremdobjekt" === this.inView[idx].vermarktungsart.toLowerCase()) && true === this.geoWerftData.checkboxes.logged_in_market_watch && false === this.geoWerftData.user.logged_in) {
        this.win_link_extern_url = this.geoWerftData.texts.market_watch_alt_link || "";
      }

      this.image_url = this.get_placeholder_img_by_hp(this.inView[idx].homepage_status, this.inView[idx].object_image_url, this.inView[idx].objektart_raw);

      this.win_link_extern = this.inView[idx].link_extern || "";
      this.win_link_extern = this.win_link_extern.replace("https://www.", "").split("/")[0];
      this.win_erwerbsart = this.inView[idx].erwerbsart || "";
      this.win_res_begin = this.inView[idx].reservierung_begin || "";
      this.win_res_ende = this.inView[idx].reservierung_ende || "";
      this.permalink = this.inView[idx].link || "";
      //Check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //If different marker set infowindow to open and reset current marker index
      else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      if (true === this.geoWerftData.user.logged_in && true === this.geoWerftData.geowerft_gtb_watchlist_active) {
        document.querySelectorAll(".mw-gtb-watchlist-liked").forEach(function (elm) {
          if (elm.classList.contains("mw-gtb-watchlist-liked")) {
            elm.classList.remove("mw-gtb-watchlist-liked");
          }
        });
        this.mw_change_watchlist_status_on_load(this.inView[idx].id || "");
      }
    },
    toggleClusterMarker: function toggleClusterMarker(event) {
      this.geoWerftData.map.center = {
        lat: event.center_.lat() + 0.0001,
        lng: event.center_.lng()
      };

      this.markerInfo = false;

      if (event.getMap().zoom < this.geoWerftData.map.maxZoom) {
        return;
      }

      var estates = [];
      var realEstates = event.getMarkers();
      for (var i in realEstates) {
        var estate = this.getEstateById(realEstates[i].title);

        if (estate) {
          if (estate.object_image_url === undefined || estate.object_image_url === "") {
            estate.object_image_url = estate.map_picture || "";
          }
          estate.image_url = estate.object_image_url || "";
          estate.win_objekttitel = estate.objekttitel || "";
          if (undefined !== estate.plz) {
            estate.win_plz = estate.plz;
          }
          estate.win_ort = estate.ort || "";
          estate.win_geolocation = estate.geolage || "";
          if (estate.objektart_geowerft === "") {
            estate.win_objektart_raw = estate.objektart_raw || "";
          } else {
            estate.win_objektart_raw = estate.objektart_geowerft || "";
          }
          if (true === this.geoWerftData.geo_display_objecttype && estate.objekttyp) {
            this.win_objektart_raw = estate.objekttyp.charAt(0).toUpperCase() + estate.objekttyp.slice(1);
          }
          estate.win_vermarktungsart = estate.vermarktungsart || "";
          estate.win_kennung = estate.kennung || "";
          estate.win_count_adults = estate.count_adults || 0;
          estate.win_count_childs = estate.count_childs || 0;
          estate.win_homepage_status = estate.homepage_status || "";
          estate.win_count_adults = estate.count_adults || 0;
          estate.win_count_childs = estate.count_childs || 0;
          estate.win_price = estate.kaufpreis || 0;
          estate.win_price_rent = estate.nettokaltmiete || 0;
          estate.win_price_qm = estate.mietpreis_pro_qm || 0;
          estate.win_teilbarkeit = this.mw_format_area(estate.teilbar_ab);
          estate.win_bueroflaeche = this.mw_format_area(estate.bueroflaeche);
          estate.win_bezug = estate.bezug || "";
          estate.win_zimmer = estate.anzahl_zimmer || 0;
          estate.win_wohnflaeche = this.mw_format_area(estate.wohnflaeche);
          estate.win_vermietbare_flaeche = this.mw_format_area(estate.vermietbare_flaeche);
          estate.win_grundstuecksflaeche = this.mw_format_area(estate.grundstuecksflaeche);
          this.win_link_extern = estate.link_extern || "";
          estate.win_link_extern = this.win_link_extern.replace("https://www.", "").split("/")[0];
          estate.win_link_extern_url = estate.link_extern || "";
          if ((estate.homepage_status && "aktive marktbeobachtung" === estate.homepage_status.toLowerCase() || estate.vermarktungsart && "fremdobjekt" === estate.vermarktungsart.toLowerCase()) && true === this.geoWerftData.checkboxes.logged_in_market_watch && false === this.geoWerftData.user.logged_in) {
            estate.win_link_extern_url = this.geoWerftData.texts.market_watch_alt_link || "";
          }
          estate.permalink = estate.link || "";
          estate.win_erwerbsart = estate.erwerbsart || "";
          estate.win_haustiere = estate.haustiere || 0;
          estate.win_barrierefrei = estate.barrierefrei || 0;
          estate.win_id = estate.id || "";
          estates.push(estate);
        }
      }
      var marker = realEstates[0];
      var idx = 0;
      this.estates = estates;
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    getEstateById: function getEstateById(title) {
      for (var i in this.inView) {
        var kennung = this.inView[i].kennung || "";
        if ("" !== kennung && true === title.includes(kennung)) {
          return this.inView[i];
        }
      }
    },
    toggle_filialen_window: function toggle_filialen_window(marker, idx) {
      this.geoWerftData.map.center = marker.position;
      this.infoWindowPos = marker.position;

      this.win_filialen_id = this.inView[idx].id;
      this.win_img_src = this.inView[idx].object_image_url;
      this.win_name = this.inView[idx].objekt_titel;
      this.win_headline = this.inView[idx].info_head;
      this.win_headline_ort = this.inView[idx].info_ort;
      this.win_strasse = this.inView[idx].strasse;
      this.win_plz = this.inView[idx].plz;
      this.win_tel = this.inView[idx].telefon;
      this.win_tel_zwei = this.inView[idx].telefon_zwei;
      this.win_mail = this.inView[idx].email;
      this.win_fax = this.inView[idx].fax;
      this.win_link_extern_url = this.inView[idx].link;
      //Check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //If different marker set infowindow to open and reset current marker index
      else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindow_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6414f4b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindow_vue__ = __webpack_require__(75);
function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6414f4b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6414f4b6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectList_vue__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InfoWindow",
  computed: {
    objectList: function objectList() {
      return __WEBPACK_IMPORTED_MODULE_0__objectList_vue__["a" /* default */];
    }
  },
  props: ["win_id", "geoWerftData", "image_url", "permalink", "win_objekttitel", "win_plz", "win_ort", "win_geolocation", "win_objektart_raw", "win_kennung", "win_gesamtflaeche", "win_tour", "win_res_begin", "win_res_ende", "win_price", "win_price_rent", "win_display_badge_new", "win_erwerbsart", "win_vermarktungsart", "win_homepage_status", "win_count_adults", "win_count_childs", "win_barrierefrei", "win_haustiere", "win_price", "win_price_rent", "win_price_qm", "win_teilbarkeit", "win_bueroflaeche", "win_bezug", "win_zimmer", "win_wohnflaeche", "win_vermietbare_flaeche", "win_grundstuecksflaeche", "win_link_extern", "win_link_extern_url"],
  methods: {
    mw_add_to_watchlist: function mw_add_to_watchlist(event) {
      var current_clicked_elm = event.target;
      var current_id = current_clicked_elm.closest("span").getAttribute("data-current-id");
      var current_elm_liked = false;
      var current_type = "POST";
      if (current_clicked_elm.classList.contains("mw-gtb-watchlist-liked")) {
        current_elm_liked = true;
        current_type = "DELETE";
      }

      if (false === current_elm_liked) {
        current_clicked_elm.classList.add("mw-gtb-watchlist-liked");
      } else {
        current_clicked_elm.classList.remove("mw-gtb-watchlist-liked");
      }

      if (current_id && document.querySelector("#watch-class-" + current_id)) {
        if (document.querySelector("#watch-class-" + current_id)) {
          if (document.querySelector("#watch-class-" + current_id).classList.contains("mw-watchlist-delete")) {
            document.querySelector("#watch-class-" + current_id).classList.remove("mw-watchlist-delete");
            document.querySelector("#watch-class-" + current_id).classList.replace("fa-star", "fa-star-o");
            document.querySelector("#watch-class-" + current_id).classList.replace("fa-heart", "fa-heart-o");
          } else {
            document.querySelector("#watch-class-" + current_id).classList.add("mw-watchlist-delete");
            document.querySelector("#watch-class-" + current_id).classList.replace("fa-star-o", "fa-star");
            document.querySelector("#watch-class-" + current_id).classList.replace("fa-heart-o", "fa-heart");
          }
        }
      }
      fetch(this.geoWerftData.geowerft_gtb_watchlist_rest, {
        method: current_type,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": this.geoWerftData.texts.wp_nonce
        },
        body: JSON.stringify({ post_id: current_id })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {});
    },
    mw_open_watchlist: function mw_open_watchlist() {
      if (document.querySelector(".mw-ben-dialog-watchlist")) {
        document.querySelector(".mw-ben-dialog-watchlist").click();
      }
    },
    mw_gtb_open_login_or_register: function mw_gtb_open_login_or_register() {
      if (document.querySelector("#mw-ben-main-dialog")) {
        document.querySelector("#mw-ben-main-dialog").showModal();
      }
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    get_price_label: function get_price_label(win_homepage_status, win_vermarktungsart, win_price_rent, win_price, win_erwerbsart) {
      if (win_homepage_status && !(win_homepage_status && win_homepage_status === "Aktive Marktbeobachtung") || win_vermarktungsart && win_vermarktungsart === "Fremdobjekt") {
        var price_label = "";
        var current_hp_status = win_homepage_status.toLowerCase();
        var current_price_rent = win_price_rent;
        var current_price_buy = win_price;
        switch (win_erwerbsart.toLowerCase()) {
          case "miete":
          case "rent":
            price_label = this.geoWerftData.texts.display_text_price_rent;
            // Hier noch die verschiedenen HP Status prüfen und ggf. das Label anpassen.
            if (current_hp_status === "verkauft" || current_hp_status === "referenz") {
              price_label = "Vermietet";
            }
            if (current_hp_status === "in vorbereitung") {
              price_label = "In Vorbereitung";
            }
            if (current_hp_status === "bieterverfahren") {
              price_label = "Bieterverfahren";
            }
            // Hier noch Prüfen ob, eine Preisblende eingefügt werden muss.
            if (current_price_rent && isNaN(current_price_rent)) {
              price_label = current_price_rent;
            }
            break;
          case "buy":
          case "kauf":
            price_label = this.geoWerftData.texts.display_text_price_purchase;
            // Hier noch die verschiedenen HP Status prüfen und ggf. das Label anpassen.
            if (current_hp_status === "verkauft" || current_hp_status === "referenz") {
              price_label = "Verkauft";
            }
            if (current_hp_status === "in vorbereitung") {
              price_label = "In Vorbereitung";
            }
            if (current_hp_status === "bieterverfahren") {
              price_label = "Bieterverfahren";
            }
            // Hier noch Prüfen ob, eine Preisblende eingefügt werden muss.
            if (current_price_buy && isNaN(current_price_buy)) {
              price_label = current_price_buy;
            }
            break;
        }
        return price_label;
      }
      return;
    },
    get_price: function get_price(win_homepage_status, win_vermarktungsart, win_price_rent, win_price, win_erwerbsart) {
      if (win_homepage_status && !(win_homepage_status && win_homepage_status === "Aktive Marktbeobachtung") || win_vermarktungsart && win_vermarktungsart === "Fremdobjekt") {
        var price = "";
        var current_hp_status = win_homepage_status.toLowerCase();
        var current_price_rent = win_price_rent;
        var current_price_buy = win_price;
        switch (win_erwerbsart.toLowerCase()) {
          case "rent":
          case "miete":
            if (current_price_rent && !isNaN(current_price_rent)) {
              price = this.get_format_price(current_price_rent) + " " + this.geoWerftData.texts.currency_suffix;
              if (current_hp_status === "verkauft" || current_hp_status === "referenz") {
                price = "";
              }
              if (current_hp_status === "in vorbereitung") {
                price = "";
              }
              if (current_hp_status === "bieterverfahren") {
                price = "";
              }
            }
            break;
          case "kauf":
          case "buy":
            if (current_price_buy && !isNaN(current_price_buy)) {
              price = this.get_format_price(current_price_buy) + " " + this.geoWerftData.texts.currency_suffix;
              if (current_hp_status === "verkauft" || current_hp_status === "referenz") {
                price = "";
              }
              if (current_hp_status === "in vorbereitung") {
                price = "";
              }
              if (current_hp_status === "bieterverfahren") {
                price = "";
              }
            }
            break;
        }
        return price;
      }
      return;
    },
    map_trigger_ajax_request: function map_trigger_ajax_request(current_prop, possible_values) {
      // Ajax erst einmal nur für Aktive markbeobachtung nutzen.
      if (true === this.geoWerftData.user.logged_in && true === this.geoWerftData.checkboxes.enable_market_watch_ajax) {
        if (current_prop && ("aktive marktbeobachtung" === current_prop.homepage_status.toLowerCase() || "fremdobjekt" === current_prop.vermarktungsart.toLowerCase())) {
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "handle_marked_watch_click",
              current_link: possible_values["link"],
              current_id: possible_values["kennung"],
              akt_kind: this.geoWerftData.texts.market_watch_akt_kind,
              akt_type: this.geoWerftData.texts.market_watch_akt_type,
              current_user_id: this.geoWerftData.user.current_user_id
            },
            success: function success(response) {}
          });
        }
      }
    },
    geowerft_map_get_banner: function geowerft_map_get_banner(homepage_status, erwerbsart, reservierung_begin, reservierung_ende, price, price_rent) {
      var display_badge_new = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";

      var result = "";
      // Preis Gegen Gebot.
      if ("kauf" === erwerbsart || "buy" === erwerbsart && isNaN(parseInt(price)) && undefined !== price && "" !== price) {
        result = price;
      }
      if ("miete" === erwerbsart || "rent" === erwerbsart && isNaN(parseInt(price_rent)) && undefined !== price_rent && "" !== price_rent) {
        result = price_rent;
      }
      // Verkauft und Vermietet.
      if ("verkauft" === homepage_status || "referenz" === homepage_status) {
        if ("kauf" === erwerbsart || "buy" === erwerbsart) {
          result = "Verkauft";
        } else {
          result = "Vermietet";
        }
      }
      if ("in vorbereitung" === homepage_status) {
        result = "In Vorbereitung";
      }
      if (display_badge_new !== "") {
        result = "Neu";
      }
      // Reserviert.
      if (reservierung_ende !== undefined && reservierung_ende !== "" && Date.parse(this.convert_date_format(reservierung_ende)) >= Date.now() || reservierung_begin !== undefined && reservierung_begin !== "" && (reservierung_ende === undefined || reservierung_ende === "") && Date.parse(this.convert_date_format(reservierung_begin)) <= Date.now()) {
        result = "Reserviert";
      }
      return result;
    },
    get_format_price: function get_format_price(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      if (this.geoWerftData.checkboxes.format_prices_cb) {
        number = number.toString().replace(",", ".");
        var val = (number / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        number = parseInt(number);
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    convert_date_format: function convert_date_format(input) {
      var format = "dd.mm.yyyy"; // default format
      var parts = input.match(/(\d+)/g),
          i = 0,
          fmt = {};
      // extract date-part indexes from the format
      format.replace(/(yyyy|dd|mm)/g, function (part) {
        fmt[part] = i++;
      });

      return new Date(parts[fmt["yyyy"]], parts[fmt["mm"]] - 1, parts[fmt["dd"]]);
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfoWindow__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InfoWindowPaginator",
  components: { InfoWindow: __WEBPACK_IMPORTED_MODULE_0__InfoWindow__["a" /* default */] },
  data: function data() {
    return {
      reload: 0,
      itemNumber: 0,
      itemLength: 0,
      items: [],
      currentItem: []
    };
  },

  props: ["estates", "geoWerftData"],
  methods: {
    next: function next() {
      this.itemNumber++;
    },
    prev: function prev() {
      this.itemNumber--;
    }
  },
  watch: {
    estates: function estates(newVal, oldVal) {
      this.itemNumber = 0;
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      init_zoom: this.geoWerftData.map.zoom,
      display_filter: false
    };
  },

  props: ["geoWerftData"],
  mounted: function mounted() {
    // this.geolocate();
  },
  created: function created() {
    /**
     * Wenn der nutzer über die Schnellsuche kommt werden hier mögliche Parameter direkt geklickt.
     */
    var urlParams = new URLSearchParams(window.location.search);

    // Für den interaktiven Filter: Direkte GET-Parameter auf Filter mappen
    if (true === this.geoWerftData.interactive_filter_active) {
      // Erst alle direkten Parameter verarbeiten
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = Object.entries(this.geoWerftData.filter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var filterKey = _ref2[0];
          var filterSettings = _ref2[1];

          var paramValue = urlParams.get(filterKey);
          if (paramValue) {
            var tmpValue = paramValue;

            // Bei Checkboxen als Array setzen
            if (filterSettings.type === "checkbox") {
              tmpValue = [tmpValue];
            }

            // Komma-getrennte Werte in Array umwandeln
            if (paramValue.includes(",")) {
              tmpValue = paramValue.split(",");
            }

            filterSettings.value = tmpValue;
          }
        }

        // Legacy-Parameter für interaktiven Filter
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var legacyParams = {
        "quick-erwerbsart": "erwerbsart",
        "quick-objektarten": "objektart_raw",
        "quick-status": "homepage_status",
        "quick-epass-class": "epass_wertklasse",
        maxPrice: "kaufpreis"
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.entries(legacyParams)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = _slicedToArray(_ref3, 2);

          var legacyKey = _ref4[0];
          var newKey = _ref4[1];

          var paramValue = urlParams.get(legacyKey);
          if (paramValue && paramValue !== "leer" && this.geoWerftData.filter[newKey]) {
            var _tmpValue = paramValue;

            // Bei Checkboxen als Array setzen
            if (this.geoWerftData.filter[newKey].type === "checkbox") {
              _tmpValue = [_tmpValue];
            }

            // Komma-getrennte Werte in Array umwandeln
            if (paramValue.includes(",")) {
              _tmpValue = paramValue.split(",");
            }

            if (Array.isArray(_tmpValue)) {
              _tmpValue = _tmpValue.map(function (val) {
                return val.replace("buy", "kauf").replace("rent", "miete").replace("house", "haus").replace("flat", "wohnung").replace("plot", "grundstueck");
              });
            } else {
              _tmpValue = _tmpValue.replace("buy", "kauf").replace("rent", "miete").replace("house", "haus").replace("flat", "wohnung").replace("plot", "grundstueck");
            }

            this.geoWerftData.filter[newKey].value = _tmpValue;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else {
      // Alter Filter (bestehende Logik)
      var object_type = null;
      var acquisition_type = null;

      // PHP-set defaults via shortcode query attribute.
      if (geowerftSettings.query && geowerftSettings.query["objektart"]) {
        object_type = geowerftSettings.query["objektart"].replace("haus", "house").replace("wohnung", "flat").replace("grundstück", "plot").replace("gewerbe", "business");
      }
      if (geowerftSettings.query && geowerftSettings.query["erwerbsart"]) {
        acquisition_type = geowerftSettings.query["erwerbsart"].replace("kauf", "buy").replace("miete", "rent");
      }

      // URL params take precedence over PHP-set values.
      if (urlParams.get("quick_search_sender") === "quick_search_send_post_data") {
        var url_object_type = urlParams.get("quick-objektarten");
        var url_acquisition_type = urlParams.get("quick-erwerbsart");
        if (url_object_type && url_object_type !== "leer") {
          object_type = url_object_type;
        }
        if (url_acquisition_type && url_acquisition_type !== "leer") {
          acquisition_type = url_acquisition_type;
        }
      }

      if (object_type) {
        this.handel_option_click("objecttype", object_type);
      }
      if (acquisition_type) {
        this.handel_option_click("acquisition", acquisition_type);
      }
    }
  },

  methods: {
    interactive_filter_cb_status_class: function interactive_filter_cb_status_class(current_filter, filter_value) {
      if (current_filter.value.includes(filter_value)) {
        return filter_value.replace("a+", "a-plus") + " active";
      }
      return filter_value.replace("a+", "a-plus");
    },
    mw_get_main_filter_class: function mw_get_main_filter_class(geoWerftData) {
      var classname = "mw-interactive-filter no-filters-set";
      if (true === geoWerftData.enable_class_for_diff_view) {
        classname = classname + " erwerbsart-seperate";
      }
      return classname;
    },
    show_dialog_filter: function show_dialog_filter() {
      var tmp_dialog = document.querySelector("#mw-interactive-show-all-filter-dialog");
      document.querySelectorAll(".interactive-filter-wrapper").forEach(function (current_wrapper) {
        tmp_dialog.append(current_wrapper);
      });
      document.querySelector("#mw-interactive-show-all-filter-dialog-wrapper").showModal();
      document.querySelector("#mw-interactive-show-all-filter-dialog-wrapper").focus();
      var main_input_container = document.querySelector(".mw-interactive-filter");
      document.querySelector("#mw-interactive-show-all-filter-dialog-wrapper").addEventListener("close", function () {
        Array.from(tmp_dialog.querySelectorAll(".interactive-filter-wrapper")).reverse().forEach(function (current_wrapper) {
          main_input_container.prepend(current_wrapper);
        });
      });
    },
    init_show_filter_action: function init_show_filter_action(given_config) {
      var current_max_visible_input_wrapper = given_config.visible_count || 4;
      document.querySelectorAll(".interactive-filter-wrapper").forEach(function (current_wrapper) {
        var classListArray = Array.from(current_wrapper.classList);
        classListArray.forEach(function (classItem) {
          var matchedNumbers = classItem.match(/\d+/g);
          if (matchedNumbers !== null && matchedNumbers >= current_max_visible_input_wrapper) {
            current_wrapper.classList.toggle("hidden_show_filter");
          }
        });
      });
      return given_config.label.inactive;
    },
    trigger_show_more_filter_actions: function trigger_show_more_filter_actions(given_config, $event) {
      $event.target.classList.toggle("inactive");
      if ($event.target.classList.contains("inactive")) {
        $event.target.innerHTML = given_config.label.inactive;
      } else {
        $event.target.innerHTML = given_config.label.active;
      }
      var current_max_visible_input_wrapper = given_config.visible_count || 4;
      document.querySelectorAll(".interactive-filter-wrapper").forEach(function (current_wrapper) {
        var classListArray = Array.from(current_wrapper.classList);
        classListArray.forEach(function (classItem) {
          var matchedNumbers = classItem.match(/\d+/g);
          if (matchedNumbers !== null && matchedNumbers >= current_max_visible_input_wrapper) {
            current_wrapper.classList.toggle("hidden-show-filter");
          }
        });
      });
    },
    handleCheckboxChange: function handleCheckboxChange(current_filter, current_input) {
      current_filter.value = [];
      document.querySelectorAll(".single-epass-pair input").forEach(function (elm) {
        elm.checked = false;
      });
      switch (current_input.target.value) {
        case "a+":
          current_filter.value = ["a+"];
          break;
        case "a":
          current_filter.value = ["a+", "a"];
          break;
        case "b":
          current_filter.value = ["a+", "a", "b"];
          break;
        case "c":
          current_filter.value = ["a+", "a", "b", "c"];
          break;
        case "d":
          current_filter.value = ["a+", "a", "b", "c", "d"];
          break;
        case "e":
          current_filter.value = ["a+", "a", "b", "c", "d", "e"];
          break;
        case "f":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f"];
          break;
        case "g":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f", "g"];
          break;
        case "h":
          current_filter.value = ["a+", "a", "b", "c", "d", "e", "f", "g", "h"];
          break;
      }
    },
    handle_field_visibility: function handle_field_visibility(current_filter, current_index_as_class, count, geoWerftData) {
      var _this = this;

      var arr_requirements = current_filter.requires || [];
      var tmp_require_check_value = void 0;
      var arr_requirements_size = Object.keys(arr_requirements).length;

      // Prüfen, ob noch der "Mehr anzeigen" Button vorhanden ist.
      var visible_by_button_class = "";
      if (geoWerftData.show_more_filter && count >= (geoWerftData.show_more_filter.visible_count || 4)) {
        visible_by_button_class = " hidden-show-filter";
      }

      if (arr_requirements_size >= 1) {
        var _loop = function _loop(tmp_key, tmp_arr_values) {
          tmp_require_check_value = _this.geoWerftData.filter[tmp_key] || [];
          tmp_require_check_value = tmp_require_check_value.value || "";
          if ("" === tmp_require_check_value || !Array.isArray(tmp_require_check_value) && !tmp_arr_values.includes(tmp_require_check_value) || Array.isArray(tmp_require_check_value) && !tmp_require_check_value.some(function (val) {
            return tmp_arr_values.includes(val);
          })) {
            return {
              v: "inactive-require-input " + current_index_as_class + " filter-elm-count-" + count + visible_by_button_class
            };
          }
        };

        // Hier nun prüfen, welche requirements gegeben sind.
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = Object.entries(arr_requirements)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref5 = _step3.value;

            var _ref6 = _slicedToArray(_ref5, 2);

            var tmp_key = _ref6[0];
            var tmp_arr_values = _ref6[1];

            var _ret = _loop(tmp_key, tmp_arr_values);

            if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      return current_index_as_class + " filter-elm-count-" + count + visible_by_button_class;
    },
    interactive_filter_set_selected: function interactive_filter_set_selected(current_filter, current_select_value) {
      var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

      var tmp_value = current_filter.value || [];
      if (tmp_value.length !== 0 && tmp_value.includes(current_select_value)) {
        // Change Filter Set Status.
        this.remove_filters_not_set(true);
        if ("checkbox" === mode) {
          return "checked";
        }
        return "selected";
      }
    },
    interactive_filter_input_mode: function interactive_filter_input_mode(current_filter) {
      var current_format = current_filter.format || "";
      if (current_format === "currency" || "number" === current_format || "buildyear_from" === current_format || "buildyear_to" === current_format) {
        return "decimal";
      }
    },
    interactive_filter_format_value: function interactive_filter_format_value(current_filter) {
      if (current_filter.value !== "") {
        // Change Filter Set Status.
        this.remove_filters_not_set();
        if ("text" !== (current_filter.format || "") && "" !== (current_filter.format || "")) {
          current_filter.value = this.mw_interactive_format_number_values(this.mw_interactive_remove_currency_and_not_working_chars(current_filter.value, current_filter.format || ""), current_filter.format || "", current_filter.extension || "", current_filter.digits || "0");
        }
      }
    },
    remove_filters_not_set: function remove_filters_not_set() {
      var call_from_init_cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var remove_filter_unset_class = function remove_filter_unset_class() {
        if (document.querySelector(".no-filters-set")) {
          document.querySelectorAll(".no-filters-set").forEach(function (elm) {
            elm.classList.remove("no-filters-set");
          });
        }
      };
      if (true === call_from_init_cb) {
        setTimeout(function () {
          remove_filter_unset_class();
        }, 1000);
      } else {
        remove_filter_unset_class();
      }
    },
    mw_interactive_remove_currency_and_not_working_chars: function mw_interactive_remove_currency_and_not_working_chars(curreny_string) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "currency";

      var numeric_string = "0";
      if ("number" === type) {
        numeric_string = curreny_string.replaceAll(",", ".");
      }
      if ("buildyear_from" === type || "buildyear_to" === type) {
        return parseInt(curreny_string);
      }
      if ("currency" === type || "area" === type) {
        numeric_string = curreny_string.replaceAll(",00", "").replaceAll(".", "");
      }
      return parseFloat(numeric_string);
    },
    mw_interactive_format_number_values: function mw_interactive_format_number_values(value) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "currency";
      var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "€";
      var digits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "0";

      digits = parseInt(digits);
      if (value !== "") {
        var options = {};
        switch (type) {
          case "currency":
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
          case "area":
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
          case "buildyear_from":
          case "buildyear_to":
            return parseInt(value);
          default:
            options = { style: "decimal", minimumFractionDigits: digits };
            break;
        }
        value = new Intl.NumberFormat("de-DE", options).format(value) + " " + extension;
      }
      return value;
    },
    get_pre_filter_labels: function get_pre_filter_labels(current_filter, type) {
      var pre_filter_label = current_filter;
      if (this.geoWerftData.texts.custom_pre_filter_label_von.length > 0 && type === "von") {
        pre_filter_label = this.geoWerftData.texts.custom_pre_filter_label_von.trim();
      }
      if (this.geoWerftData.texts.custom_pre_filter_label_bis.length > 0 && type === "bis") {
        pre_filter_label = this.geoWerftData.texts.custom_pre_filter_label_bis;
      }
      return pre_filter_label;
    },
    isMobile: function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    },
    handel_option_click: function handel_option_click(filterIndex, filter_value) {
      // check zoom
      if (undefined !== this.geoWerftData.map.zoom_types && this.geoWerftData.map.zoom_types.length > 0) {
        for (var i = 0; i < this.geoWerftData.map.zoom_types.length; i++) {
          var zoom_type = this.geoWerftData.map.zoom_types[i];
          if ("" !== zoom_type[0] && zoom_type.type.toLowerCase() === filter_value.toLowerCase()) {
            var curr_zoom = parseInt(zoom_type.zoom);
            if (true === this.isMobile()) {
              curr_zoom = curr_zoom - 1;
            }
            this.geoWerftData.map.zoom = curr_zoom;
            this.geoWerftData.map.center = {
              lat: parseFloat(zoom_type.lat),
              lng: parseFloat(zoom_type.lng)
            };
          }
        }
      }

      if ("acquisition" === filterIndex) {
        if ("buy" === filter_value.toLowerCase()) {
          this.geoWerftData.filter["price"].label = this.geoWerftData.texts.filter_label_price_buy;
        }
        if ("rent" === filter_value.toLowerCase()) {
          this.geoWerftData.filter["price"].label = this.geoWerftData.texts.filter_label_price_rent;
        }
        if ("" === filter_value.toLowerCase()) {
          this.geoWerftData.filter["price"].label = this.geoWerftData.texts.filter_label_price;
        }
      }

      if ("objecttype" === filterIndex) {
        switch (filter_value.toLowerCase()) {
          case "house":
            this.geoWerftData.filter["rooms"].label = this.geoWerftData.texts.filter_space_label_house;
            this.geoWerftData.filter["rooms"].space_max_extension = this.geoWerftData.texts.filter_space_label_house_max_extension;
            break;
          case "plot":
            this.geoWerftData.filter["rooms"].label = this.geoWerftData.texts.filter_space_label_grundstueck;
            this.geoWerftData.filter["rooms"].space_max_extension = this.geoWerftData.texts.filter_space_label_grundstueck_max_extension;
            break;
          case "business":
            this.geoWerftData.filter["rooms"].label = this.geoWerftData.texts.filter_space_label_gewerbe;
            this.geoWerftData.filter["rooms"].space_max_extension = this.geoWerftData.texts.filter_space_label_gewerbe_max_extension;
            break;
          case "investment":
            this.geoWerftData.filter["rooms"].label = this.geoWerftData.texts.filter_space_label_invest;
            this.geoWerftData.filter["rooms"].space_max_extension = this.geoWerftData.texts.filter_space_label_invest_max_extension;
            break;
          default:
            if (this.geoWerftData.filter["rooms"]) {
              this.geoWerftData.filter["rooms"].label = this.geoWerftData.texts.filter_label_rooms;
            }
            break;
        }
      }
    },
    handle_listen_click: function handle_listen_click(zoom, display_filter, current_filter, button) {
      this.geoWerftData.current_map_mode = button;
      this.display_filter = display_filter;
      this.geoWerftData.map.zoom = zoom;
      // Wenn man von der Listenansicht auf die Karte
      if ("map" === button && current_filter.regio) {
        current_filter.regio.value = "";
      }
    },
    geolocate: function geolocate() {
      var _this2 = this;

      // Try to get the current position of the user
      navigator.geolocation.getCurrentPosition(function (position) {
        // Set the map to this position
        _this2.geoWerftData.map.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    get_correct_step: function get_correct_step(used_type) {
      used_type = used_type.toLowerCase();

      var step_val = 1;

      if (used_type.includes("preis") || used_type.includes("kauf")) {
        step_val = this.geoWerftData.step_num_kauf;
      }

      if (used_type.includes("miet")) {
        step_val = this.geoWerftData.step_num_miete;
      }

      if (used_type.includes("zimmer")) {
        step_val = this.geoWerftData.steps_rooms;
      }

      if (used_type.includes("fläche")) {
        step_val = this.geoWerftData.steps_space;
      }

      if (used_type.includes("wohn")) {
        step_val = this.geoWerftData.steps_living_space;
      }

      if (used_type.includes("grund")) {
        step_val = this.geoWerftData.steps_plot_space;
      }

      return step_val;
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = is_consent_google_maps;
function is_consent_google_maps() {
  // Anpassung, falls Cookiebot an ist.
  // Hier muss verhindert werden, dass bereits gesetzte Cookies von Enfold, Cookiebot behindern.
  var tmp_cookie_bot = window.Cookiebot || "";
  if ("" !== tmp_cookie_bot) {
    // Hier direkt False zurückgeben, damit alte Enfold Cookies sicht nicht einmischen..
    return false;
  }

  // CCM berücksichtigen.
  if (window.CCM) {
    return false;
  }

  var current_google_cookie = geowerft_get_cookie_by_name("aviaPrivacyGoogleMapsDisabled");
  var current_consent_cookie = geowerft_get_cookie_by_name("aviaCookieConsent");

  if ("empty" !== current_consent_cookie && "empty" === current_google_cookie) {
    return true;
  }
  return false;
}

function geowerft_get_cookie_by_name(cookie_name) {
  var name = cookie_name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookie_list = decodedCookie.split(";");
  var len = cookie_list.length;
  for (var i = 0; i < len; i++) {
    var current_cookie = cookie_list[i];
    while (current_cookie.charAt(0) === " ") {
      current_cookie = current_cookie.substring(1);
    }
    if (current_cookie.indexOf(name) === 0) {
      return current_cookie.substring(name.length, current_cookie.length);
    }
  }
  return "empty";
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./buero_praxis.js": 86,
	"./business.js": 87,
	"./einzelhandel.js": 88,
	"./eventbus.js": 9,
	"./flat.js": 89,
	"./house.js": 90,
	"./investment.js": 91,
	"./lager_produktion.js": 92,
	"./parking.js": 93,
	"./plot.js": 94,
	"./rest.js": 95,
	"./villa.js": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GeoWerft_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__check_consent__ = __webpack_require__(27);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







document.addEventListener("DOMContentLoaded", function () {
  // Quick check for logged in.
  if (document.querySelector("body.logged-in")) {
    window.addEventListener("mw_manipulate_images", function (e) {
      fetch(rest_url + "geowerft/v1/reload_content", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce
        },
        body: JSON.stringify({ posts: e.detail.img_list })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.data) {
          window.mw_tmp_geo_img_list = data.data;
          dispatchEvent(new CustomEvent("mw_reload_images_done", {
            detail: { list: window.mw_tmp_geo_img_list },
            bubbles: true
          }));
        }
      });
    });
  }

  setTimeout(function () {
    // Maybe reload images.
    if (document.querySelector(".single-object") && document.querySelector(".js_may_reload_img")) {
      var img_list = [];
      document.querySelectorAll(".js_may_reload_img").forEach(function (item) {
        var current_li_post_id = item.closest(".single-object").getAttribute("data-id");
        if (current_li_post_id !== "") {
          img_list.push(current_li_post_id);
        }
      });
      fetch(rest_url + "geowerft/v1/reload_content", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": wp_nonce.nonce
        },
        body: JSON.stringify({ posts: img_list })
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.data) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = Object.entries(data.data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref = _step.value;

              var _ref2 = _slicedToArray(_ref, 2);

              var key = _ref2[0];
              var value = _ref2[1];

              if (document.querySelector('.single-object[data-id="' + key + '"] img')) {
                document.querySelector('.single-object[data-id="' + key + '"] img').src = value;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
      });
    }
  }, 2000);
});

var cookie_bot = window.Cookiebot || "";

// Use vue-resource package
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
if (true === Object(__WEBPACK_IMPORTED_MODULE_4__check_consent__["a" /* default */])() && "" === cookie_bot && !window.CCM) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
    load: {
      key: geowerftSettings.google_maps_api_key,
      libraries: "places"
    }
  });
}

// Hier müssen noch Aktionen ausgeführt werden, falls etwas bei den Cookies geändert wird.
window.addEventListener("CookiebotOnConsentReady", function (e) {
  if (cookie_bot && true === cookie_bot.consent.marketing) {
    localStorage.setItem("mw_cookie_bot_map_consent", "1");
    sessionStorage.setItem("mw_cookie_bot_map_consent", "1");
  }
  window.addEventListener("CookiebotOnAccept", function (e) {
    // Hier eine Endlosschleife vermeiden.
    var tmp_locale_session_consent = localStorage.getItem("mw_cookie_bot_map_consent") || "";
    var tmp_session_consent = sessionStorage.getItem("mw_cookie_bot_map_consent") || "";
    // Prüfen, mit welcher Speicherung gearbeitet werden kann.
    var current_consent_set_check = tmp_locale_session_consent;
    if ("" === tmp_locale_session_consent && "" !== tmp_session_consent) {
      current_consent_set_check = tmp_session_consent;
    }
    if (current_consent_set_check !== "1") {
      localStorage.setItem("mw_cookie_bot_map_consent", "1");
      sessionStorage.setItem("mw_cookie_bot_map_consent", "1");
      location.reload();
    }
  }, false);

  window.addEventListener("CookiebotOnDecline", function (e) {
    localStorage.removeItem("mw_cookie_bot_map_consent");
    sessionStorage.removeItem("mw_cookie_bot_map_consent");
  }, false);
}, false);

window.addEventListener("ccm19WidgetClosed", function (args) {
  // Die Cookie einstellungen haben sich ggf. verändert.
  window.CCM.acceptedEmbeddings.forEach(function (item) {
    if ("Google Maps" === item.name) {
      location.reload();
    }
  });
});

if (cookie_bot && true === cookie_bot.consent.marketing) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
    load: {
      key: geowerftSettings.google_maps_api_key,
      libraries: "places"
    }
  });
}

if (window.CCM) {
  window.CCM.acceptedEmbeddings.forEach(function (item) {
    if ("Google Maps" === item.name) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
        load: {
          key: geowerftSettings.google_maps_api_key,
          libraries: "places"
        }
      });
    }
  });
}

// Filters
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("format-price", function (x) {
  return parseFloat(x).toLocaleString("de-DE", {
    minimumSignificantDigits: 3
  });
});

var MaklerWeftGeoWerft = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#geowerft",
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__GeoWerft_vue__["a" /* default */]);
  }
});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(31);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(32)))

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(34);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 34 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreetViewPanorama = exports.MountableMixin = exports.Autocomplete = exports.MapElementFactory = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Cluster = exports.Circle = exports.Polygon = exports.Polyline = exports.Marker = exports.loadGmapApi = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Vue component imports


exports.install = install;
exports.gmapApi = gmapApi;

var _lazyValue = __webpack_require__(36);

var _lazyValue2 = _interopRequireDefault(_lazyValue);

var _manager = __webpack_require__(37);

var _marker = __webpack_require__(38);

var _marker2 = _interopRequireDefault(_marker);

var _polyline = __webpack_require__(39);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(40);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(41);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(42);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _infoWindow = __webpack_require__(43);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(46);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(52);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(57);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(59);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(11);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

var _mountableMixin = __webpack_require__(8);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var Cluster = undefined;

var GmapApi = null;

// export everything
exports.loadGmapApi = _manager.loadGmapApi;
exports.Marker = _marker2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Cluster = Cluster;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.MapElementFactory = _mapElementFactory2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
exports.StreetViewPanorama = _streetViewPanorama2.default;
function install(Vue, options) {
  // Set defaults
  options = _extends({
    installComponents: true,
    autobindAllEvents: false
  }, options);

  // Update the global `GmapApi`. This will allow
  // components to use the `google` global reactively
  // via:
  //   import {gmapApi} from 'vue2-google-maps'
  //   export default {  computed: { google: gmapApi }  }
  GmapApi = new Vue({ data: { gmapApi: null } });

  var defaultResizeBus = new Vue();

  // Use a lazy to only load the API when
  // a VGM component is loaded
  var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
      this.$gmapOptions = options;
      this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    }
  });
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

function makeGmapApiPromiseLazy(options) {
  // Things to do once the API is loaded
  function onApiLoaded() {
    GmapApi.gmapApi = {};
    return window.google;
  }

  if (options.load) {
    // If library should load the API
    return (0, _lazyValue2.default)(function () {
      // Load the
      // This will only be evaluated once
      if (typeof window === 'undefined') {
        // server side -- never resolve this promise
        return new Promise(function () {}).then(onApiLoaded);
      } else {
        return new Promise(function (resolve, reject) {
          try {
            window['vueGoogleMapsInit'] = resolve;
            (0, _manager.loadGmapApi)(options.load, options.loadCn);
          } catch (err) {
            reject(err);
          }
        }).then(onApiLoaded);
      }
    });
  } else {
    // If library should not handle API, provide
    // end-users with the global `vueGoogleMapsInit: () => undefined`
    // when the Google Maps API has been loaded
    var promise = new Promise(function (resolve) {
      if (typeof window === 'undefined') {
        // Do nothing if run from server-side
        return;
      }
      window['vueGoogleMapsInit'] = resolve;
    }).then(onApiLoaded);

    return (0, _lazyValue2.default)(function () {
      return promise;
    });
  }
}

function gmapApi() {
  return GmapApi.gmapApi && window.google;
}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js

exports.default = function (fn) {
  var called = false;
  var ret = void 0;

  return function () {
    if (!called) {
      called = true;
      ret = fn();
    }

    return ret;
  };
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isApiSetUp = false;

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var loadGmapApi = exports.loadGmapApi = function (options, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!isApiSetUp) {
    isApiSetUp = true;

    var googleMapScript = document.createElement('SCRIPT');

    // Allow options to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
      throw new Error('options should  be an object');
    }

    // libraries
    if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn === 'boolean' && loadCn === true) {
      baseUrl = 'https://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + Object.keys(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.head.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  options: {
    type: Object
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'marker',
  ctr: function ctr() {
    return google.maps.Marker;
  },

  inject: {
    '$clusterPromise': {
      default: null
    }
  },

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length === 0) {
      return '';
    } else if (this.$slots.default.length === 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) {
      return;
    }

    if (this.$clusterObject) {
      // Repaint will be performed in `updated()` of cluster
      this.$clusterObject.removeMarker(this.$markerObject, true);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    if (this.$clusterPromise) {
      this.$clusterPromise.then(function (co) {
        co.addMarker(inst);
        _this.$clusterObject = co;
      });
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,

  name: 'polyline',
  ctr: function ctr() {
    return google.maps.Polyline;
  },

  afterCreate: function afterCreate() {
    var _this = this;

    var clearEvents = function () {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true,
    noBind: true
  },
  paths: {
    type: Array,
    twoWay: true,
    noBind: true
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  props: {
    deepWatch: {
      type: Boolean,
      default: false
    }
  },
  events: events,
  mappedProps: props,
  name: 'polygon',
  ctr: function ctr() {
    return google.maps.Polygon;
  },

  beforeCreate: function beforeCreate(options) {
    if (!options.path) delete options.path;
    if (!options.paths) delete options.paths;
  },
  afterCreate: function afterCreate(inst) {
    var _this = this;

    var clearEvents = function () {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        inst.setPaths(paths);

        var updatePaths = function () {
          _this.$emit('paths_changed', inst.getPaths());
        };
        var eventListeners = [];

        var mvcArray = inst.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        inst.setPaths(path);

        var mvcPath = inst.getPath();
        var eventListeners = [];

        var updatePaths = function () {
          _this.$emit('path_changed', inst.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function () {
          eventListeners.map(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });
  }
});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'circle',
  ctr: function ctr() {
    return google.maps.Circle;
  },
  events: events
});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  name: 'rectangle',
  ctr: function ctr() {
    return google.maps.Rectangle;
  },
  events: events
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(12);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(45);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'infoWindow',
  ctr: function ctr() {
    return google.maps.InfoWindow;
  },
  props: {
    opened: {
      type: Boolean,
      default: true
    }
  },

  inject: {
    '$markerPromise': {
      default: null
    }
  },

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  beforeCreate: function beforeCreate(options) {
    var _this = this;

    options.content = this.$refs.flyaway;

    if (this.$markerPromise) {
      delete options.position;
      return this.$markerPromise.then(function (mo) {
        _this.$markerObject = mo;
        return mo;
      });
    }
  },


  methods: {
    _openInfoWindow: function _openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindowObject.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindowObject.open(this.$map);
        }
      } else {
        this.$infoWindowObject.close();
      }
    }
  },

  afterCreate: function afterCreate() {
    var _this2 = this;

    this._openInfoWindow();
    this.$watch('opened', function () {
      _this2._openInfoWindow();
    });
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(13);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(51);
function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(48);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b6f23878", content, true, {});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(6);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(4);

var _mountableMixin = __webpack_require__(8);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(14);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(7);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object,
    noBind: true
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number,
    noBind: true
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['bounds_changed', 'click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = ['panBy', 'panTo', 'panToBounds', 'fitBounds'].reduce(function (all, methodName) {
  all[methodName] = function () {
    if (this.$mapObject) {
      this.$mapObject[methodName].apply(this.$mapObject, arguments);
    }
  };
  return all;
}, {});

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) {
      return;
    }

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },


  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

  provide: function provide() {
    var _this = this;

    this.$mapPromise = new Promise(function (resolve, reject) {
      _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$mapPromise': this.$mapPromise
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    },
    finalLatLng: function finalLatLng() {
      return { lat: this.finalLat, lng: this.finalLng };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

      // manually trigger center and zoom
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        _this2.$mapObject.addListener('center_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('center_changed', _this2.$mapObject.getCenter());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$mapObject.setCenter(_this2.finalLatLng);
        });
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

      return _this2.$mapObject;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: _extends({}, customMethods, linkedMethods)
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(15);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(56);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(54);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("f6bcaac0", content, true, {});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindEvents = __webpack_require__(6);

var _bindEvents2 = _interopRequireDefault(_bindEvents);

var _bindProps = __webpack_require__(4);

var _mountableMixin = __webpack_require__(8);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _TwoWayBindingWrapper = __webpack_require__(14);

var _TwoWayBindingWrapper2 = _interopRequireDefault(_TwoWayBindingWrapper);

var _WatchPrimitiveProperties = __webpack_require__(7);

var _WatchPrimitiveProperties2 = _interopRequireDefault(_WatchPrimitiveProperties);

var _mapElementFactory = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object,
    noBind: true
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

exports.default = {
  mixins: [_mountableMixin2.default],
  props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
  replace: false, // necessary for css styles
  methods: {
    resize: function resize() {
      if (this.$panoObject) {
        google.maps.event.trigger(this.$panoObject, 'resize');
      }
    }
  },

  provide: function provide() {
    var _this = this;

    var promise = new Promise(function (resolve, reject) {
      _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
    });
    return {
      '$panoPromise': promise,
      '$mapPromise': promise // so that we can use it with markers
    };
  },


  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    },
    finalLatLng: function finalLatLng() {
      return {
        lat: this.finalLat,
        lng: this.finalLng
      };
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return this.$gmapApiPromiseLazy().then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _extends({}, _this2.options, (0, _bindProps.getPropsValues)(_this2, props));
      delete options.options;

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
      // binding events
      (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

      // manually trigger position
      (0, _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
        // Panos take a while to load
        increment();

        _this2.$panoObject.addListener('position_changed', function () {
          if (shouldUpdate()) {
            _this2.$emit('position_changed', _this2.$panoObject.getPosition());
          }
          decrement();
        });

        (0, _WatchPrimitiveProperties2.default)(_this2, ['finalLat', 'finalLng'], function updateCenter() {
          increment();
          _this2.$panoObject.setPosition(_this2.finalLatLng);
        });
      });

      _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

      return _this2.$panoPromise;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(58);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(18);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(61);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _bindProps = __webpack_require__(4);

var _simulateArrowDown = __webpack_require__(17);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _mapElementFactory = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mappedProps = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object,
    // Do not bind -- must check for undefined
    // in the property
    noBind: true
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  }
};

var props = {
  selectFirstOnEnter: {
    required: false,
    type: Boolean,
    default: false
  },
  options: {
    type: Object
  }
};

exports.default = {
  mounted: function mounted() {
    var _this = this;

    this.$gmapApiPromiseLazy().then(function () {
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      if (typeof google.maps.places.Autocomplete !== 'function') {
        throw new Error('google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');
      }

      /* eslint-disable no-unused-vars */
      var finalOptions = _extends({}, (0, _bindProps.getPropsValues)(_this, mappedProps), _this.options);

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      // Not using `bindEvents` because we also want
      // to return the result of `getPlace()`
      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: _extends({}, (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps), props)
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoWerft_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d976ae84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoWerft_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoWerft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d976ae84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoWerft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(64);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("67ea03d3", content, true, {});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("45690b14", content, true, {});

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.geoWerftData.checkboxes.enable_filialen_mode)?[_c('div',{staticClass:"object-list",attrs:{"id":"geowerft-list-wrapper"}},[_c('ul',{staticClass:"list-area"},[(!_vm.visible0bjects.length && _vm.loadingStatus)?_c('li',[_c('p',{staticClass:"geoblink"},[_vm._v("\n          Im ausgewählten Bereich sind keine Filialen vorhanden.\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.loadingStatus)?_c('li',[(_vm.geoWerftData.checkboxes.show_loading_icon)?_c('div',[(_vm.geoWerftData.custom_loading_icon !== '')?_c('div',{staticClass:"geowerft-loading-spinner-custom-wrapper"},[_c('img',{staticClass:"geowerft-custom-spinner-icon",attrs:{"alt":"","loading":"lazy","src":_vm.geoWerftData.custom_loading_icon}}),_vm._v(" "),_c('span',{staticClass:"geowerft-loading-spinner-text"},[_vm._v("Filialen werden geladen ...")])]):_c('div',{staticClass:"geowerft-loading-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-3x fa-fw",attrs:{"id":"geowerft-spinner-ico-fil"}}),_vm._v(" "),_c('span',{staticClass:"geowerft-loading-spinner-text"},[_vm._v("Filialen werden geladen ...")])])]):_c('p',[_vm._v("Filialen werden geladen ...")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.listedObjects),function(object){return _c('li',{class:[
          'single-real-estate-agent',
          object.image_search_running ? 'loading-image' : '' ],attrs:{"id":object.id + '-list-click'},on:{"click":function($event){return _vm.send_info_to_map(object.id)}}},[_c('div',{staticClass:"mw-geo-real-estate-agent-wrapper"},[_c('div',{staticClass:"single-real-estate-agent-image"},[_c('img',{attrs:{"alt":"","loading":"lazy","src":object.object_image_url}})]),_vm._v(" "),_c('div',{staticClass:"single-real-estate-agent-content"},[_c('div',{staticClass:"single-real-estate-agent-name"},[_c('h2',{domProps:{"innerHTML":_vm._s(object.objekt_titel)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(object.ort)}})]),_vm._v(" "),_c('div',{staticClass:"single-real-estate-agent-adress-contact-wrapper"},[_c('div',{staticClass:"single-real-estate-agent-adress"},[_c('span',{domProps:{"innerHTML":_vm._s(object.strasse)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(object.plz)}})]),_vm._v(" "),_c('div',{staticClass:"single-real-estate-agent-contact"},[_c('span',[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n                  "+_vm._s(object.telefon)+"\n                ")]),_vm._v(" "),_c('a',{attrs:{"href":'mailto:' + object.email}},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(" E-Mail\n                  Kontakt\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"single-real-estate-agent-url"},[_c('a',{staticClass:"mw-filiale-link-left",attrs:{"href":object.link,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.filialen_landingpage_label)}}),_vm._v(" "),(object.success_story)?_c('a',{staticClass:"mw-filiale-link-right",attrs:{"href":object.success_story,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.filialen_success_story_label)}}):_vm._e()])])])])}),_vm._v(" "),(_vm.visible0bjects.length > _vm.listedObjects.length)?_c('li',[_c('p',[_vm._v("\n          Kartenauschnitt verkleinern um alle verfügbaren Filialen in dieser\n          Liste darzustellen.\n        ")])]):_vm._e()],2)])]:[_c('div',{class:_vm.geoWerftData.checkboxes.user_has_searchwish
        ? 'object-list user-has-searchwish'
        : 'object-list',attrs:{"id":"geowerft-list-wrapper"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"geowerft-visible-immo-counter"},[_vm._v("\n      "+_vm._s(_vm.geoWerftData.objects.visible.length)+" Objekte im\n      Karten-Auschnitt."),_c('br'),_vm._v("\n      "+_vm._s(_vm.geoWerftData.objects.filtered.length)+" von\n      "+_vm._s(_vm.geoWerftData.objects.all.length)+" Objekte erfüllen die Filtern.\n    ")]),_vm._v(" "),_c('ul',{staticClass:"list-area",attrs:{"onclick":"localStorage.setItem( 'mw-last-visit-immoslider', window.location.href )"}},[('' !== this.geoWerftData.texts.text_sc_info_text)?_c('li',{staticClass:"mw-geowerft-special-info-text"},[_c('p',{domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_sc_info_text)}})]):_vm._e(),_vm._v(" "),(true === this.current_user_can_see_blacklist())?_c('li',{staticClass:"mw-blacklist-config-wrapper"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(
          true ===
          _vm.geoWerftData.additional_content.geowerft_additional_info_box
        )?_c('li',{staticClass:"mw-additional-content-li-wrapper"},[_c('div',{staticClass:"geowerft_additonal_content_wrapper",domProps:{"innerHTML":_vm._s(
            _vm.geoWerftData.additional_content
              .geowerft_additional_info_box_template
          )}})]):_vm._e(),_vm._v(" "),(
          _vm.geoWerftData.checkboxes.secret_bar_active &&
          !_vm.geoWerftData.user.logged_in
        )?_c('li',[_c('div',{staticClass:"geowerft-sneak-peak-wrapper"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"geowerft-sneak-peak-border"}),_vm._v(" "),_c('div',{staticClass:"geowerft-sneak-peak-content"},[_vm._v("\n            "+_vm._s(_vm.geoWerftData.secret_bar_max_count)+"\n            "+_vm._s(_vm.geoWerftData.texts.secret_sale_headline)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"geowerft-sneak-peak-sub-head"},[_vm._v("\n            "+_vm._s(_vm.geoWerftData.texts.secret_sale_sub_text)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"geowerft-sneak-peak-register-wrap"},[_c('a',{attrs:{"href":_vm.geoWerftData.texts.secret_bar_register_link,"target":"_blank"}},[_vm._v(_vm._s(_vm.geoWerftData.texts.secret_sale_button))])])])]):_vm._e(),_vm._v(" "),(!_vm.visible0bjects.length && _vm.loadingStatus)?_c('li',[_c('p',{staticClass:"geoblink",domProps:{"innerHTML":_vm._s(
            _vm.return_no_immo_in_b_text(this.geoWerftData.current_map_mode)
          )}})]):_vm._e(),_vm._v(" "),(
          true === _vm.geoWerftData.geowerft_immo_loading &&
          'map' === this.geoWerftData.current_map_mode
        )?_c('li',[(_vm.geoWerftData.checkboxes.show_loading_icon)?_c('div',[(_vm.geoWerftData.custom_loading_icon !== '')?_c('div',{staticClass:"geowerft-loading-spinner-custom-wrapper"},[_c('img',{staticClass:"geowerft-custom-spinner-icon",attrs:{"alt":"","loading":"lazy","src":_vm.geoWerftData.custom_loading_icon}}),_vm._v(" "),_c('span',{staticClass:"geowerft-loading-spinner-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.prop_loading_text)}})]):_c('div',{staticClass:"geowerft-loading-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-3x fa-fw",attrs:{"id":"geowerft-spinner-ico"}}),_vm._v(" "),_c('span',{staticClass:"geowerft-loading-spinner-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.prop_loading_text)}})])]):_c('p',{domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.prop_loading_text)}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.listedObjects),function(object,index){return _c('li',{class:[
          'single-object',
          object.image_search_running ? 'loading-image' : '',
          _vm.sanitize_title_method(object.homepage_status),
          _vm.sanitize_title_method(object.vermarktungsart),
          _vm.geoWerftData.checkboxes.display_picture_max_width_or_height
            ? 'mw-prop-pricture-max-width'
            : 'mw-prop-pricture-max-height',
          object.vermarktungsart &&
          object.vermarktungsart.toLowerCase() ===
            _vm.geoWerftData.texts.blur_hp_status_name.toLowerCase() &&
          _vm.geoWerftData.checkboxes.display_marketing_method === true
            ? 'mw-display-fremdobjekt-li'
            : '' ],attrs:{"title":_vm.get_the_title(object),"data-index":index,"data-id":object.id}},[(_vm.geoWerftData.texts.list_visibility_json)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.mw_list_get_settings_by_json(object))}}):_vm._e(),_vm._v(" "),_c('div',_vm._b({},'div',_vm.trigger_banner_render(index),false)),_vm._v(" "),(
            true === _vm.current_user_can_see_watchlist_icons(object) &&
            '' === _vm.geoWerftData.geowerft_setting_watchlist_icon_custom
          )?_c('div',{class:'mw-watchlist-remember-immo',attrs:{"title":"Immobilie merken","data-mw-prop-kennung":object.id},on:{"click":function($event){return _vm.trigger_mw_watchlist(
              object.id,
              $event,
              _vm.geoWerftData.user.current_user_id
            )}}},[_c('div',[_c('em',{class:_vm.check_current_watchlist_status(object.id),attrs:{"id":'watch-class-' + object.id,"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(
            true === _vm.current_user_can_see_watchlist_icons(object) &&
            '' !== _vm.geoWerftData.geowerft_setting_watchlist_icon_custom
          )?_c('div',{class:'mw-watchlist-remember-immo',attrs:{"title":_vm.get_new_watchlist_titel(object.id),"data-mw-prop-kennung":object.id},on:{"click":function($event){return _vm.trigger_mw_watchlist_new(
              object.id,
              $event,
              _vm.geoWerftData.user.current_user_id
            )}}},[('' !== _vm.geoWerftData.geowerft_setting_watchlist_icon_custom)?_c('div',{class:_vm.check_current_watchlist_status(object.id),attrs:{"id":'watch-class-' + object.id},domProps:{"innerHTML":_vm._s(_vm.get_new_watchlist_icon(object.id))}}):_vm._e()]):_vm._e(),_vm._v(" "),(true === _vm.current_user_can_see_blacklist())?_c('div',{class:'mw-blacklist-immo',attrs:{"data-mw-prop-kennung":object.id},on:{"click":function($event){return _vm.trigger_mw_blacklist(
              object.id,
              $event,
              _vm.geoWerftData.user.current_user_id
            )}}},[_c('div',{class:_vm.check_current_blacklist_status(object.id),attrs:{"title":_vm.check_current_blacklist_status_title(object.id),"id":'mw-blacklist-id-' + object.id,"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.user_blacklist_icon)}})]):(true === _vm.current_user_can_see_offline_blacklist())?_c('div',{class:'mw-blacklist-immo',attrs:{"data-mw-prop-kennung":object.id},on:{"click":function($event){return _vm.mw_gtb_open_login_or_register()}}},[_c('div',{staticClass:"mw-blacklist-icon-wrapper mw-offline-blacklist",attrs:{"title":_vm.check_current_blacklist_status_title(object.id),"id":'mw-blacklist-id-' + object.id,"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.user_blacklist_icon)}})]):_vm._e(),_vm._v(" "),(true === _vm.mw_display_gtb_watchlist())?_c('div',{staticClass:"mw-watchlist-gtb-offline",attrs:{"title":"Immobilie merken"},on:{"click":function($event){return _vm.mw_gtb_open_login_or_register()}}},[('' === _vm.geoWerftData.geowerft_setting_watchlist_icon_custom)?_c('em',{staticClass:"fa fa-heart-o fa-2x"}):_vm._e(),_vm._v(" "),('' !== _vm.geoWerftData.geowerft_setting_watchlist_icon_custom)?_c('div',{class:_vm.check_current_watchlist_status(object.id),attrs:{"id":'watch-class-' + object.id},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.geowerft_setting_watchlist_icon_custom)}}):_vm._e()]):_vm._e(),_vm._v(" "),(true === _vm.mw_display_gtb_watchlist_detailed())?_c('div',{class:_vm.check_current_watchlist_detailed_status(object.id),attrs:{"data-mw-prop-kennung":object.id},domProps:{"innerHTML":_vm._s(_vm.get_watchlist_detailed_current_icon(object.id))},on:{"click":function($event){return _vm.trigger_mw_watchlist_detailed(
              object.id,
              $event,
              _vm.geoWerftData.user.current_user_id
            )}}}):_vm._e(),_vm._v(" "),(
            (true === _vm.geoWerftData.checkboxes.allow_prop_offline_detection &&
              ((true ===
                _vm.geoWerftData.checkboxes
                  .allow_prop_offline_detection_only_logged_in &&
                _vm.geoWerftData.user.logged_in) ||
                false ===
                  _vm.geoWerftData.checkboxes
                    .allow_prop_offline_detection_only_logged_in) &&
              object.homepage_status &&
              object.homepage_status.toLowerCase() ===
                _vm.geoWerftData.texts.prop_offline_hp_status.toLowerCase()) ||
            (object.vermarktungsart &&
              object.vermarktungsart.toLowerCase() ===
                _vm.geoWerftData.texts.prop_offline_hp_status.toLowerCase())
          )?_c('div',{class:'mw-geo-set-prop-offline-list ' +
            _vm.get_active_watchlist_class(object),on:{"click":function($event){return _vm.set_selected_prop_offline($event.target, 'li')}}},[_c('div',{staticClass:"mw-set-prop-offline-content",attrs:{"title":"Dieses Angebot ist nicht mehr verfügbar?"}},[_c('img',{attrs:{"alt":"","src":_vm.geoWerftData.texts.prop_offline_picture}})])]):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.use_img_tag_in_list)?_c('img',{staticClass:"mw-geowerft-list-single-prop-img mw-geowerft-bg-image",attrs:{"src":_vm.get_picture_url(
              object.object_image_url,
              _vm.geoWerftData.image_placeholder_empty,
              object.map_picture,
              object.homepage_status,
              object.objektart_raw
            ),"alt":_vm.set_alt_tag(object),"loading":"lazy","width":"100%","height":"230px"},on:{"click":function($event){return _vm.handle_picture_click(object, $event)}}}):_vm._e(),_vm._v(" "),(false === _vm.geoWerftData.use_img_tag_in_list)?_c('div',{staticClass:"mw-geowerft-bg-image",style:(_vm.get_picture_url(
              object.object_image_url,
              _vm.geoWerftData.image_placeholder_empty,
              object.map_picture,
              object.homepage_status,
              object.objektart_raw
            )),on:{"click":function($event){return _vm.handle_picture_click(object, $event)}}}):_vm._e(),_vm._v(" "),(
            ('ja' === (object.ogulo_tour || '') ||
              '1' === (object.ogulo_tour || '')) &&
            _vm.geoWerftData.checkboxes.display_tour_icon
          )?_c('div',{staticClass:"mw-list-tour-icon-wrapper"},[_c('div',{staticClass:"tour-ico-wrapper"},[('' !== _vm.geoWerftData.customimages.tour_icon_src)?_c('img',{attrs:{"alt":"","src":_vm.geoWerftData.customimages.tour_icon_src}}):_vm._e()])]):_vm._e(),_vm._v(" "),(
            _vm.geoWerftData.current_map_mode === 'map' &&
            object.vermarktungsart &&
            'zukunftsmarktradar' === object.vermarktungsart.toLowerCase()
          )?_c('div',{staticClass:"mw-geo-future-extra-info",domProps:{"innerHTML":_vm._s(_vm.get_future_extra_fields(object))}}):_vm._e(),_vm._v(" "),(
            (object.homepage_status === 'Aktive Marktbeobachtung' ||
              object.vermarktungsart === 'Fremdobjekt') &&
            object.link_extern === '' &&
            false === _vm.geoWerftData.checkboxes.custom_marketwatch_temp_active
          )?_c('span'):(
            (object.homepage_status === 'Aktive Marktbeobachtung' ||
              object.vermarktungsart === 'Fremdobjekt') &&
            true === _vm.geoWerftData.checkboxes.logged_in_market_watch &&
            false === _vm.geoWerftData.user.logged_in
          )?_c('a',{attrs:{"href":_vm.geoWerftData.texts.market_watch_alt_link,"target":"_blank"}},[_c('h2',{staticClass:"object-titel",domProps:{"innerHTML":_vm._s(object.objekttitel)}})]):(
            (object.homepage_status === 'Aktive Marktbeobachtung' ||
              object.vermarktungsart === 'Fremdobjekt') &&
            false === _vm.geoWerftData.checkboxes.custom_marketwatch_temp_active
          )?_c('a',{attrs:{"href":object.link_extern,"target":"_blank"}},[_c('h2',{staticClass:"object-titel",domProps:{"innerHTML":_vm._s(_vm.get_special_list_title(object))}})]):(
            true === _vm.geoWerftData.show_extern_link &&
            object.link_extern &&
            object.link_extern !== '' &&
            false === _vm.geoWerftData.checkboxes.custom_marketwatch_temp_active
          )?_c('a',{staticClass:"btn-details",attrs:{"href":object.link_extern,"target":"_blank"}},[_c('h2',{staticClass:"object-titel",domProps:{"innerHTML":_vm._s(object.objekttitel)}})]):(_vm.geoWerftData.checkboxes.other_info_window)?_c('a',{attrs:{"href":object.link,"target":"_blank"}},[_c('h2',{staticClass:"object-titel",domProps:{"innerHTML":_vm._s(
              object.plz + ' ' + object.ort + ' | ' + object.objektart_raw
            )}})]):_c('a',{staticClass:"geowerft-list-anker",attrs:{"href":object.link,"target":"_blank"}},[_c('h2',{staticClass:"object-titel",domProps:{"innerHTML":_vm._s(_vm.get_special_list_title(object))}})]),_vm._v(" "),(object.mw_display_vermarktungsart)?_c('span',{staticClass:"object-display-special-banner"},[_vm._v(_vm._s(object.mw_display_vermarktungsart))]):_vm._e(),_vm._v(" "),(_vm.geoWerftData.checkboxes.other_info_window)?_c('p',{staticClass:"object-place",domProps:{"innerHTML":_vm._s('Objekt Nr.: ' + object.kennung)}}):_c('p',{staticClass:"object-place"},[(
              object.vermarktungsart &&
              'zukunftsmarktradar' === object.vermarktungsart.toLowerCase()
            )?_c('span',{staticClass:"geo-plz-list",domProps:{"innerHTML":_vm._s(object.plz + ' ')}}):_vm._e(),_vm._v(" "),(
              true === _vm.geoWerftData.checkboxes.display_kennung_in_object_place
            )?_c('span',{staticClass:"geo-kennung-list",domProps:{"innerHTML":_vm._s(object.kennung + ' | ')}}):_vm._e(),_vm._v(" "),(
              true === _vm.geoWerftData.checkboxes.display_plz_in_object_place &&
              false === _vm.geoWerftData.checkboxes.other_info_window_v2
            )?_c('span',{staticClass:"geo-plz-list",domProps:{"innerHTML":_vm._s(object.plz + ' ')}}):_vm._e(),_vm._v(" "),(
              false === _vm.geoWerftData.checkboxes.set_geolocation &&
              false === _vm.geoWerftData.checkboxes.other_info_window_v2
            )?_c('span',{staticClass:"city",domProps:{"innerHTML":_vm._s(_vm.handle_place_view(object))}}):_vm._e(),_vm._v(" "),(
              true === _vm.geoWerftData.checkboxes.set_geolocation &&
              object.geolage
            )?_c('span',{staticClass:"mw-geo-geolage",domProps:{"innerHTML":_vm._s(object.geolage + ' | ')}}):_vm._e(),_vm._v(" "),(false === _vm.geoWerftData.checkboxes.other_info_window_v2)?_c('span',{staticClass:"type",domProps:{"innerHTML":_vm._s(_vm.get_the_correct_type(object))}}):_vm._e(),_vm._v(" "),(
              object.homepage_status === 'Aktive Marktbeobachtung' ||
              object.vermarktungsart === 'Fremdobjekt' ||
              (_vm.geoWerftData.checkboxes.display_sorce_in_market_watch &&
                object.vermarktungsart &&
                object.vermarktungsart.toLowerCase() ===
                  _vm.geoWerftData.texts.market_watch_name.toLowerCase())
            )?_c('span',{staticClass:"source-external-link"},[_vm._v("\n            Quelle:\n            "),(object.link_extern !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.get_link_extern(object))}}):_c('span',{domProps:{"innerHTML":_vm._s(object.kennung)}})]):_vm._e(),_vm._v(" "),(
              true === _vm.geoWerftData.checkboxes.other_info_window_v2 &&
              object.vermarktungsart !== 'Fremdobjekt'
            )?_c('span',[_vm._v("\n            Quelle:\n            "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.prop_own_source_text)}})]):_vm._e()]),_vm._v(" "),(_vm.geoWerftData.list_view_config)?_c('div',{staticClass:"mw-config-special-list-fields"},_vm._l((_vm.geoWerftData
              .list_view_config.fields),function(arr_setting,index,count){return _c('div',{staticClass:"mw-config-special-list-fields-single-wrapper",domProps:{"innerHTML":_vm._s(_vm.get_special_list_conf_html(arr_setting, object))}})}),0):_vm._e(),_vm._v(" "),(
            true === _vm.geoWerftData.checkboxes.show_more_info_in_list ||
            (_vm.geoWerftData.checkboxes.list_map_switcher &&
              _vm.geoWerftData.checkboxes.advanced_list_view &&
              'list' === _vm.geoWerftData.current_map_mode)
          )?_c('span',{class:'geowerft-list-values-wrapper-whole' +
            ' ' +
            _vm.replaceUmlauts(object.objektart_raw)},[_c('span',{staticClass:"geowerft-list-values-wrapper"},[(object.anzahl_zimmer)?_c('span',{staticClass:"geowerft-list-values-single-row zimmer"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-rooms"},[_c('svg',{attrs:{"viewBox":"0 0 22 24"}},[_c('path',{attrs:{"d":"M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z","transform":"translate(0 0)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Zimmer")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s(_vm.mw_format_list_number_output(object.anzahl_zimmer))}})]):_vm._e(),_vm._v(" "),(object.baujahr)?_c('span',{staticClass:"geowerft-list-values-single-row baujahr"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-build"},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"M192 576l64 384h192V640h128v320h192l64-384L512 256 192 576zM832 384V128H704l0.312 128.312L512 64 0 576h128l384-384 384 384h128L832 384z"}}),_vm._v("\n                  ';\n                ")])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Baujahr")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s(object.baujahr)}})]):_vm._e(),_vm._v(" "),(
                object.objektart_raw &&
                object.wohnflaeche &&
                -1 === object.objektart_raw.toLowerCase().indexOf('invest')
              )?_c('span',{staticClass:"geowerft-list-values-single-row wohnflaeche"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"stroke",attrs:{"viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7","transform":"translate(-0.98 -0.98)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Wohnfläche")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s('ca. ' + _vm.mw_format_area(object.wohnflaeche) + ' m²')}})]):_vm._e(),_vm._v(" "),(
                (object.gesamtflaeche &&
                  true === _vm.geoWerftData.geo_business_mode &&
                  false === _vm.geoWerftData.geo_business_mode_bueroflaeche) ||
                (object.gesamtflaeche &&
                  true === _vm.geoWerftData.checkboxes.display_ges_flaeche)
              )?_c('span',{staticClass:"geowerft-list-values-single-row gesamtflaeche"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"stroke",attrs:{"viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7","transform":"translate(-0.98 -0.98)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.label_flaeche_list_view)}}),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s('ca. ' + _vm.mw_format_area(object.gesamtflaeche) + ' m²')}})]):_vm._e(),_vm._v(" "),(
                object.anzahl_wohneinheiten &&
                true === _vm.geoWerftData.show_einheiten_in_list
              )?_c('span',{staticClass:"geowerft-list-values-single-row anzahl_wohneinheiten"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-rooms"},[_c('svg',{attrs:{"viewBox":"0 0 22 24"}},[_c('path',{attrs:{"d":"M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z","transform":"translate(0 0)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Einheiten")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s(
                  _vm.mw_format_list_number_output(object.anzahl_wohneinheiten)
                )}})]):_vm._e(),_vm._v(" "),(
                object.bueroflaeche &&
                true === _vm.geoWerftData.geo_business_mode &&
                true === _vm.geoWerftData.geo_business_mode_bueroflaeche
              )?_c('span',{staticClass:"geowerft-list-values-single-row bueroflaeche"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"stroke",attrs:{"viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7","transform":"translate(-0.98 -0.98)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.label_flaeche_list_view)}}),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s('ca. ' + _vm.mw_format_area(object.bueroflaeche) + ' m²')}})]):_vm._e(),_vm._v(" "),(
                object.teilbar_ab && true === _vm.geoWerftData.geo_business_mode
              )?_c('span',{staticClass:"geowerft-list-values-single-row teilbarkeit"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"teilbarkeit-ab",attrs:{"viewBox":"0 0 22 24"}},[_c('path',{attrs:{"d":"M10,8H0V0H10ZM22,0H12V8H22ZM10,10H0V24H10Zm12,0H12V24H22Z","transform":"translate(0 0)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Teilbarkeit ab")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s('ca. ' + _vm.mw_format_area(object.teilbar_ab) + ' m²')}})]):_vm._e(),_vm._v(" "),(
                object.objektart_raw &&
                object.vermietbare_flaeche &&
                -1 !== object.objektart_raw.toLowerCase().indexOf('invest')
              )?_c('span',{staticClass:"geowerft-list-values-single-row vermietbarefl"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"stroke",attrs:{"viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7","transform":"translate(-0.98 -0.98)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Vermietbare Fläche")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s(
                  'ca. ' + _vm.mw_format_area(object.vermietbare_flaeche) + ' m²'
                )}})]):_vm._e(),_vm._v(" "),(
                (true ===
                  _vm.geoWerftData.checkboxes.show_ground_fl_for_house_in_list &&
                  object.objektart_raw &&
                  object.grundstuecksflaeche &&
                  -1 !==
                    object.objektart_raw.toLowerCase().indexOf('haus')) ||
                (object.objektart_raw &&
                  object.grundstuecksflaeche &&
                  -1 !== object.objektart_raw.toLowerCase().indexOf('grund'))
              )?_c('span',{staticClass:"geowerft-list-values-single-row grundstuecksfl"},[_c('span',{staticClass:"geowerft-list-icon-wrapper geowerft-list-svg-fleache"},[_c('svg',{staticClass:"stroke",attrs:{"viewBox":"0 0 23 23"}},[_c('path',{attrs:{"d":"M23.48,23.48h-16v-16h16ZM8.48,3V7m3-6V7m3-4V7m3-6V7m3-4V7m3-6V7M3,8.48H7m-6,3H7m-4,3H7m-6,3H7m-4,3H7m-6,3H7","transform":"translate(-0.98 -0.98)"}})])]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value-text"},[_vm._v("Grundstücksfläche")]),_vm._v(" "),_c('span',{staticClass:"geowerft-list-value",domProps:{"innerHTML":_vm._s(
                  'ca. ' + _vm.mw_format_area(object.grundstuecksflaeche) + ' m²'
                )}})]):_vm._e(),_vm._v(" "),(
                ('ja' === (object.ogulo_tour || '') ||
                  '1' === (object.ogulo_tour || '')) &&
                _vm.geoWerftData.checkboxes.display_tour_icon
              )?_c('span',{staticClass:"mw-list-tour-icon-wrapper-side-icon"},[_c('div',{staticClass:"tour-ico-wrapper-side-icon"},[('' !== _vm.geoWerftData.customimages.tour_icon_src)?_c('img',{attrs:{"alt":"","src":_vm.geoWerftData.customimages.tour_icon_src}}):_vm._e()])]):_vm._e()]),_vm._v(" "),(true === _vm.check_commision(object))?_c('span',{staticClass:"object-pricing-no-commission"},[_vm._v("\n            "+_vm._s(_vm.geoWerftData.texts.display_text_no_buyer_comission)+"\n          ")]):_vm._e()]):_vm._e(),_vm._v(" "),(
            true === _vm.geoWerftData.show_sold_banner &&
            object.homepage_status &&
            ('verkauft' === object.homepage_status.toLowerCase() ||
              'vermarktet' === object.homepage_status.toLowerCase() ||
              object.homepage_status.toLowerCase().indexOf('referenz') >= 0)
          )?_c('span',{staticClass:"geowerft-sold-banner type-sold"},[(
              object.erwerbsart &&
              (object.erwerbsart.toLowerCase() === 'kauf' ||
                object.erwerbsart.toLowerCase() === 'buy')
            )?_c('span',{staticClass:"geowerft-sold-banner-inner",domProps:{"innerHTML":_vm._s(_vm.map_get_sold_label(object))}}):(
              object.erwerbsart &&
              (object.erwerbsart.toLowerCase() === 'miete' ||
                object.erwerbsart.toLowerCase() === 'rent')
            )?_c('span',{staticClass:"geowerft-sold-banner-inner"},[_vm._v("Vermietet")]):_vm._e()]):(
            (object.reservierung_ende !== undefined &&
              object.reservierung_ende !== '' &&
              Date.parse(_vm.parseDate(object.reservierung_ende)) >=
                Date.now()) ||
            (object.reservierung_begin !== undefined &&
              object.reservierung_begin !== '' &&
              (object.reservierung_ende === undefined ||
                object.reservierung_ende === '') &&
              Date.parse(_vm.parseDate(object.reservierung_begin)) <= Date.now())
          )?_c('span',{staticClass:"geowerft-sold-banner reserved-status"},[_vm._v("\n          Reserviert\n        ")]):(
            object.homepage_status &&
            true === _vm.geoWerftData.checkboxes.show_in_prep_banner &&
            'in vorbereitung' === object.homepage_status.toLowerCase()
          )?_c('span',{staticClass:"geowerft-sold-banner prep-status"},[_vm._v("\n          In Vorbereitung\n        ")]):(object.display_badge_new)?_c('span',{staticClass:"geowerft-sold-banner prep-status"},[_c('span',{staticClass:"new-prop-badge"},[_vm._v("NEU")]),_vm._v(" "),_c('span',{staticClass:"new-prop-price",domProps:{"innerHTML":_vm._s(_vm.render_new_badge_content(object))}})]):(
            object.homepage_status &&
            'bieterverfahren' === object.homepage_status.toLowerCase()
          )?_c('span',{staticClass:"geowerft-sold-banner auction",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.auction_list_label)}}):(
            object.erwerbsart &&
            (object.erwerbsart.toLowerCase() === 'miete' ||
              object.erwerbsart.toLowerCase() === 'rent') &&
            isNaN(parseInt(object.nettokaltmiete)) &&
            undefined !== object.nettokaltmiete &&
            '' !== object.nettokaltmiete
          )?_c('span',{class:[
            'geowerft-rent-banner',
            'status-' + object.homepage_status,
            'vermarktungsart-' + object.vermarktungsart,
            (object.nettokaltmiete || '')
              .trim()
              .toLowerCase()
              .replace(/\s/g, '') ]},[_vm._v("\n          "+_vm._s(object.nettokaltmiete)+"\n        ")]):(
            object.erwerbsart &&
            (object.erwerbsart.toLowerCase() === 'kauf' ||
              object.erwerbsart.toLowerCase() === 'buy') &&
            isNaN(parseInt(object.kaufpreis)) &&
            undefined !== object.kaufpreis &&
            '' !== object.kaufpreis
          )?_c('span',{class:[
            'geowerft-sold-banner',
            'status-' + object.homepage_status,
            'vermarktungsart-' + object.vermarktungsart,
            (object.kaufpreis || '').trim().toLowerCase().replace(/\s/g, '') ]},[_vm._v("\n          "+_vm._s(object.kaufpreis)+"\n        ")]):(
            (!isNaN(parseInt(_vm.mabye_get_on_request_price(object))) &&
              object.homepage_status &&
              'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
            (!isNaN(parseInt(_vm.mabye_get_on_request_price(object))) &&
              object.homepage_status &&
              'in vorbereitung' === object.homepage_status.toLowerCase() &&
              true === _vm.geoWerftData.checkboxes.display_prep_price)
          )?_c('p',{staticClass:"object-pricing"},[_c('span',[_vm._v(_vm._s(_vm.geoWerftData.texts.display_text_price_purchase))]),_vm._v(" "),(
              true === _vm.geoWerftData.checkboxes.display_extra_commision_info &&
              true === _vm.check_commision(object)
            )?_c('span',{staticClass:"extra-no-comission-info-wrapper"},[_c('span',{staticClass:"extra-no-comission-info"},[_vm._v(_vm._s(_vm.geoWerftData.texts.display_text_no_buyer_comission))])]):_vm._e(),_vm._v("\n          "+_vm._s(_vm.get_format_price(object.kaufpreis, object))+"\n          "+_vm._s(_vm.get_suffix_special(object))+"\n        ")]):(
            (!isNaN(parseInt(object.nettokaltmiete)) &&
              object.homepage_status &&
              'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
            (!isNaN(parseInt(object.nettokaltmiete)) &&
              object.homepage_status &&
              'in vorbereitung' === object.homepage_status.toLowerCase() &&
              true === _vm.geoWerftData.checkboxes.display_prep_price)
          )?_c('p',{staticClass:"object-pricing"},[_c('span',[_vm._v(_vm._s(_vm.geoWerftData.texts.display_text_price_rent))]),_vm._v("\n          "+_vm._s(_vm.geoWerftData.checkboxes.show_warmmiete
              ? _vm.get_format_price(object.warmmiete, object)
              : _vm.get_format_price(object.nettokaltmiete, object))+"\n          "+_vm._s(_vm.geoWerftData.texts.currency_suffix)+"\n        ")]):(
            (!isNaN(parseInt(object.mietpreis_pro_qm)) &&
              object.homepage_status &&
              'in vorbereitung' !== object.homepage_status.toLowerCase()) ||
            (!isNaN(parseInt(object.mietpreis_pro_qm)) &&
              object.homepage_status &&
              'in vorbereitung' === object.homepage_status.toLowerCase() &&
              true === _vm.geoWerftData.checkboxes.display_prep_price)
          )?_c('p',{staticClass:"object-pricing"},[_c('span',[_vm._v(_vm._s(_vm.geoWerftData.texts.mietpreis_pro_qm_pre))]),_vm._v("\n          "+_vm._s(_vm.get_format_price(object.mietpreis_pro_qm, object))+"\n          "+_vm._s(_vm.geoWerftData.texts.mietpreis_pro_qm_post)+"\n        ")]):(
            true === _vm.geoWerftData.checkboxes.other_info_window_v2 &&
            object.erwerbsart &&
            (object.erwerbsart.toLowerCase() === 'kauf' ||
              object.erwerbsart.toLowerCase() === 'buy') &&
            (object.vermarktungsart || '').toLowerCase() === 'fremdobjekt' &&
            '' === (object.kaufpreis || '')
          )?_c('p',{staticClass:"object-pricing no-price"},[_c('span',[_vm._v(_vm._s(_vm.geoWerftData.texts.display_text_price_purchase))]),_vm._v(" "),_c('span',{staticClass:"no-price-text"},[_vm._v("ohne Preisangabe")])]):_vm._e(),_vm._v(" "),(
            true === _vm.geoWerftData.checkboxes.other_info_window_v2 &&
            (object.vermarktungsart || '').toLowerCase() === 'fremdobjekt' &&
            '' !== _vm.geoWerftData.texts.display_extra_banderole
          )?_c('div',{staticClass:"extra-fremdobject-banderole-outer-wrapper",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.display_extra_banderole)}}):(
            true === _vm.geoWerftData.checkboxes.other_info_window_v2 &&
            (object.vermarktungsart || '').toLowerCase() !== 'fremdobjekt' &&
            'in vorbereitung' === object.homepage_status.toLowerCase() &&
            false === _vm.geoWerftData.checkboxes.display_prep_price
          )?_c('span',{staticClass:"in-prep-price-wrapper"},[_c('span',{staticClass:"in-prep-price-label"},[_vm._v(_vm._s(_vm.geoWerftData.texts.display_text_price_purchase))]),_vm._v(" "),_c('span',{staticClass:"in-prep-price-value"},[_vm._v("in Vorbereitung")])]):_vm._e(),_vm._v(" "),(object.mw_marktwert)?_c('span',{staticClass:"object-pricing-marktwert"},[_c('span',[_vm._v("Marktwert")]),_vm._v("\n          "+_vm._s(_vm.get_format_price(object.mw_marktwert, object))+"\n          "+_vm._s(_vm.geoWerftData.texts.currency_suffix))]):_vm._e(),_vm._v(" "),(
            true === _vm.geoWerftData.show_prov_free_banner &&
            'nein' === (object.aussencourtage_ja || 'ja').toLowerCase() &&
            'kauf' ===
              (object.erwerbsart || '').toLowerCase().replace('buy', 'kauf')
          )?_c('span',{staticClass:"geowerft-prov-free-banner"},[_vm._v("\n          Provisionsfrei\n        ")]):_vm._e(),_vm._v(" "),(
            _vm.geoWerftData.checkboxes.display_custom_pin_in_list === true &&
            _vm.loadingStatus
          )?_c('span',{class:'geowerft-pin-wrapper' +
            ' ' +
            _vm.sanitize_title_method(object.homepage_status)},[_c('span',[(
                object.map_pin === '' || typeof object.map_pin === 'undefined'
              )?_c('img',{staticClass:"geowerft-custom-marker",attrs:{"loading":"lazy","src":_vm.get_customizer_image_for_marker(
                  object.homepage_status,
                  object.display_badge_new
                ),"alt":""},on:{"click":function($event){return _vm.send_info_to_map(object.id)}}}):_c('img',{staticClass:"geowerft-custom-marker",attrs:{"src":object.map_pin,"loading":"lazy","alt":""},on:{"click":function($event){return _vm.send_info_to_map(object.id)}}})])]):_c('span',[_c('p',{staticClass:"object-center-pin"},[_c('span',[_c('i',{staticClass:"fa fa-map-marker",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.send_info_to_map(object.id)}}})])])])])}),_vm._v(" "),(_vm.visible0bjects.length > _vm.listedObjects.length)?_c('li',{staticClass:"mw-geowerft-not-in-scope"},[_c('p',{domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.not_in_scope_text)}})]):_vm._e(),_vm._v(" "),(
          false === this.geoWerftData.geowerft_immo_loading &&
          0 === this.geoWerftData.objects.all.length
        )?_c('li',{staticClass:"geowerft-no-immo-in-route",domProps:{"innerHTML":_vm._s(this.geoWerftData.no_prop_in_route_text)}}):_vm._e(),_vm._v(" "),(true === this.geoWerftData.geowerft_no_props_from_route)?_c('li',[_vm._v("\n        Zurzeit können keine Immobilien angezeigt werden. Bitte versuchen Sie\n        es später noch einmal.\n      ")]):_vm._e()],2)])]}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geowerft-lasche"},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw-toggle-blacklist-config"},[_c('p',[_vm._v("Ausgeschlossene Immobilien:")]),_vm._v(" "),_c('a',{staticClass:"avia-button mw-toggle-blacklist-on",attrs:{"href":"","aria-label":"Ausgeschlossene Immobilien ausblenden"}},[_vm._v("Ausblenden")]),_vm._v(" "),_c('a',{staticClass:"avia-button mw-toggle-blacklist-off",attrs:{"href":"","aria-label":"Ausgeschlossene Immobilien anzeigen"}},[_vm._v("Anzeigen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geowerft-sneak-peak-ico-wrapper"},[_c('i',{staticClass:"fa fa-bell geowerft-sneak-peak-bell-icon",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectMap_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b89cbdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectMap_vue__ = __webpack_require__(80);
function injectStyle (ssrContext) {
  __webpack_require__(69)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b89cbdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(70);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4d46b174", content, true, {});

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".info-window-content{overflow:hidden;width:100%;max-width:20ch;word-wrap:break-word}", ""]);

// exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _markerClustererPlus = __webpack_require__(72);

var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus);

var _mapElementFactory = __webpack_require__(0);

var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                               * @class Cluster
                                                                                                                                                                                                                               * @prop $clusterObject -- Exposes the marker clusterer to
                                                                                                                                                                                                                                     descendent Marker classes. Override this if you area
                                                                                                                                                                                                                                     extending the class
                                                                                                                                                                                                                             
                                                                                                                                                                                                                               List of properties from
                                                                                                                                                                                                                               https://github.com/googlemaps/v3-utility-library/blob/master/markerclustererplus/src/markerclusterer.js
                                                                                                                                                                                                                             **/


var props = {
  maxZoom: {
    type: Number,
    twoWay: false
  },
  batchSizeIE: {
    type: Number,
    twoWay: false
  },
  calculator: {
    type: Function,
    twoWay: false
  },
  enableRetinaIcons: {
    type: Boolean,
    twoWay: false
  },
  gridSize: {
    type: Number,
    twoWay: false
  },
  ignoreHidden: {
    type: Boolean,
    twoWay: false
  },
  imageExtension: {
    type: String,
    twoWay: false
  },
  imagePath: {
    type: String,
    twoWay: false
  },
  imageSizes: {
    type: Array,
    twoWay: false
  },
  minimumClusterSize: {
    type: Number,
    twoWay: false
  },
  styles: {
    type: Array,
    twoWay: false
  },
  zoomOnClick: {
    type: Boolean,
    twoWay: false
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

exports.default = (0, _mapElementFactory2.default)({
  mappedProps: props,
  events: events,
  name: 'cluster',
  ctr: function ctr() {
    if (typeof _markerClustererPlus2.default === 'undefined') {
      /* eslint-disable no-console */
      console.error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
      throw new Error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
    }
    return _markerClustererPlus2.default;
  },
  ctrArgs: function ctrArgs(_ref) {
    var map = _ref.map,
        otherOptions = _objectWithoutProperties(_ref, ['map']);

    return [map, [], otherOptions];
  },

  render: function render(h) {
    // <div><slot></slot></div>
    return h('div', this.$slots.default);
  },
  afterCreate: function afterCreate(inst) {
    var reinsertMarkers = function () {
      var oldMarkers = inst.getMarkers();
      inst.clearMarkers();
      inst.addMarkers(oldMarkers);
    };

    for (var prop in props) {
      if (props[prop].twoWay) {
        this.$on(prop.toLowerCase() + '_changed', reinsertMarkers);
      }
    }
  },
  updated: function updated() {
    if (this.$clusterObject) {
      this.$clusterObject.repaint();
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;

    /* Performance optimization when destroying a large number of markers */
    this.$children.forEach(function (marker) {
      if (marker.$clusterObject === _this.$clusterObject) {
        marker.$clusterObject = null;
      }
    });

    if (this.$clusterObject) {
      this.$clusterObject.clearMarkers();
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.cluster_ = cluster;
  this.className_ = cluster.getMarkerClusterer().getClusterClass();
  this.styles_ = styles;
  this.center_ = null;
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function () {
  var cClusterIcon = this;
  var cMouseDownInCluster;
  var cDraggingMapByCluster;

  this.div_ = document.createElement("div");
  this.div_.className = this.className_;
  if (this.visible_) {
    this.show();
  }

  this.getPanes().overlayMouseTarget.appendChild(this.div_);

  // Fix for Issue 157
  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
    cDraggingMapByCluster = cMouseDownInCluster;
  });

  google.maps.event.addDomListener(this.div_, "mousedown", function () {
    cMouseDownInCluster = true;
    cDraggingMapByCluster = false;
  });

  google.maps.event.addDomListener(this.div_, "click", function (e) {
    cMouseDownInCluster = false;
    if (!cDraggingMapByCluster) {
      var theBounds;
      var mz;
      var mc = cClusterIcon.cluster_.getMarkerClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (mc.getZoomOnClick()) {
        // Zoom into the cluster.
        mz = mc.getMaxZoom();
        theBounds = cClusterIcon.cluster_.getBounds();
        mc.getMap().fitBounds(theBounds);
        // There is a fix for Issue 170 here:
        setTimeout(function () {
          mc.getMap().fitBounds(theBounds);
          // Don't zoom beyond the max zoom level
          if (mz !== null && (mc.getMap().getZoom() > mz)) {
            mc.getMap().setZoom(mz + 1);
          }
        }, 100);
      }

      // Prevent event propagation to the map:
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  });

  google.maps.event.addDomListener(this.div_, "mouseover", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
  });

  google.maps.event.addDomListener(this.div_, "mouseout", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
  });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function () {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    google.maps.event.removeListener(this.boundsChangedListener_);
    google.maps.event.clearInstanceListeners(this.div_);
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function () {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + "px";
    this.div_.style.left = pos.x + "px";
  }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function () {
  if (this.div_) {
    this.div_.style.display = "none";
  }
  this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function () {
  if (this.div_) {
    var img = "";
    // NOTE: values must be specified in px units
    var bp = this.backgroundPosition_.split(" ");
    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
    }
    img += "'>";
    this.div_.innerHTML = img + "<div style='" +
        "position: absolute;" +
        "top: " + this.anchorText_[0] + "px;" +
        "left: " + this.anchorText_[1] + "px;" +
        "color: " + this.textColor_ + ";" +
        "font-size: " + this.textSize_ + "px;" +
        "font-family: " + this.fontFamily_ + ";" +
        "font-weight: " + this.fontWeight_ + ";" +
        "font-style: " + this.fontStyle_ + ";" +
        "text-decoration: " + this.textDecoration_ + ";" +
        "text-align: center;" +
        "width: " + this.width_ + "px;" +
        "line-height:" + this.height_ + "px;" +
        "'>" + this.sums_.text + "</div>";
    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
    } else {
      this.div_.title = this.sums_.title;
    }
    this.div_.style.display = "";
  }
  this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function (sums) {
  this.sums_ = sums;
  var index = Math.max(0, sums.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style.url;
  this.height_ = style.height;
  this.width_ = style.width;
  this.anchorText_ = style.anchorText || [0, 0];
  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
  this.textColor_ = style.textColor || "black";
  this.textSize_ = style.textSize || 11;
  this.textDecoration_ = style.textDecoration || "none";
  this.fontWeight_ = style.fontWeight || "bold";
  this.fontStyle_ = style.fontStyle || "normal";
  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
  this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
  this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
  var style = [];
  style.push("cursor: pointer;");
  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
  return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= this.anchorIcon_[1];
  pos.y -= this.anchorIcon_[0];
  pos.x = parseInt(pos.x, 10);
  pos.y = parseInt(pos.y, 10);
  return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
  this.markerClusterer_ = mc;
  this.map_ = mc.getMap();
  this.gridSize_ = mc.getGridSize();
  this.minClusterSize_ = mc.getMinimumClusterSize();
  this.averageCenter_ = mc.getAverageCenter();
  this.markers_ = [];
  this.center_ = null;
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function () {
  return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function () {
  return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function () {
  return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function () {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function () {
  var i;
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function () {
  this.clusterIcon_.setMap(null);
  this.markers_ = [];
  delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function (marker) {
  var i;
  var mCount;
  var mz;

  if (this.isMarkerAlreadyAdded_(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  mCount = this.markers_.length;
  mz = this.markerClusterer_.getMaxZoom();
  if (mz !== null && this.map_.getZoom() > mz) {
    // Zoomed in past max zoom, so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount < this.minClusterSize_) {
    // Min cluster size not reached so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount === this.minClusterSize_) {
    // Hide the markers that were showing.
    for (i = 0; i < mCount; i++) {
      this.markers_[i].setMap(null);
    }
  } else {
    marker.setMap(null);
  }

  this.updateIcon_();
  return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function () {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function () {
  var mCount = this.markers_.length;
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz !== null && this.map_.getZoom() > mz) {
    this.clusterIcon_.hide();
    return;
  }

  if (mCount < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.useStyle(sums);
  this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
  var i;
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) !== -1;
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        return true;
      }
    }
  }
  return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);

  opt_markers = opt_markers || [];
  opt_options = opt_options || {};

  this.markers_ = [];
  this.clusters_ = [];
  this.listeners_ = [];
  this.activeMap_ = null;
  this.ready_ = false;

  this.gridSize_ = opt_options.gridSize || 60;
  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
  this.maxZoom_ = opt_options.maxZoom || null;
  this.styles_ = opt_options.styles || [];
  this.title_ = opt_options.title || "";
  this.zoomOnClick_ = true;
  if (opt_options.zoomOnClick !== undefined) {
    this.zoomOnClick_ = opt_options.zoomOnClick;
  }
  this.averageCenter_ = false;
  if (opt_options.averageCenter !== undefined) {
    this.averageCenter_ = opt_options.averageCenter;
  }
  this.ignoreHidden_ = false;
  if (opt_options.ignoreHidden !== undefined) {
    this.ignoreHidden_ = opt_options.ignoreHidden;
  }
  this.enableRetinaIcons_ = false;
  if (opt_options.enableRetinaIcons !== undefined) {
    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
  }
  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
  this.clusterClass_ = opt_options.clusterClass || "cluster";

  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
    // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
  }

  this.setupStyles_();

  this.addMarkers(opt_markers, true);
  this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
  var cMarkerClusterer = this;

  this.activeMap_ = this.getMap();
  this.ready_ = true;

  this.repaint();

  // Add the map event listeners
  this.listeners_ = [
    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
      cMarkerClusterer.resetViewport_(false);
      // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.
      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
        google.maps.event.trigger(this, "idle");
      }
    }),
    google.maps.event.addListener(this.getMap(), "idle", function () {
      cMarkerClusterer.redraw_();
    })
  ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function () {
  var i;

  // Put all the managed markers back on the map:
  for (i = 0; i < this.markers_.length; i++) {
    if (this.markers_[i].getMap() !== this.activeMap_) {
      this.markers_[i].setMap(this.activeMap_);
    }
  }

  // Remove all clusters:
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Remove map event listeners:
  for (i = 0; i < this.listeners_.length; i++) {
    google.maps.event.removeListener(this.listeners_[i]);
  }
  this.listeners_ = [];

  this.activeMap_ = null;
  this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function () {
  var i, size;
  if (this.styles_.length > 0) {
    return;
  }

  for (i = 0; i < this.imageSizes_.length; i++) {
    size = this.imageSizes_[i];
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
      height: size,
      width: size
    });
  }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
  var i;
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }

  this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
  return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (gridSize) {
  this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function () {
  return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
  this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
  return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function () {
  return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
  this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function () {
  return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function (title) {
  this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function () {
  return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
  this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function () {
  return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
  this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function () {
  return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
  this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function () {
  return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
  this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function () {
  return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
  this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function () {
  return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function (imagePath) {
  this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function () {
  return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
  this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function () {
  return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
  this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function () {
  return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
  this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function () {
  return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
  this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
  return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function () {
  return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
  return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
  var key;
  for (key in markers) {
    if (markers.hasOwnProperty(key)) {
      this.pushMarkerTo_(markers[key]);
    }
  }  
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
  // If the marker is draggable add a listener so we can update the clusters on the dragend:
  if (marker.getDraggable()) {
    var cMarkerClusterer = this;
    google.maps.event.addListener(marker, "dragend", function () {
      if (cMarkerClusterer.ready_) {
        this.isAdded = false;
        cMarkerClusterer.repaint();
      }
    });
  }
  marker.isAdded = false;
  this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
  var i, r;
  var removed = false;

  for (i = 0; i < markers.length; i++) {
    r = this.removeMarker_(markers[i]);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
  var i;
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        index = i;
        break;
      }
    }
  }

  if (index === -1) {
    // Marker is not in our list of markers, so do nothing:
    return false;
  }

  marker.setMap(null);
  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
  return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
  this.resetViewport_(true);
  this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function () {
  var oldClusters = this.clusters_.slice();
  this.clusters_ = [];
  this.resetViewport_(false);
  this.redraw_();

  // Remove the old clusters.
  // Do it in a timeout to prevent blinking effect.
  setTimeout(function () {
    var i;
    for (i = 0; i < oldClusters.length; i++) {
      oldClusters[i].remove();
    }
  }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function () {
  this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
  var i, marker;
  // Remove all the clusters
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Reset the markers to not be added and to be removed from the map.
  for (i = 0; i < this.markers_.length; i++) {
    marker = this.markers_[i];
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
  var i, d, cluster, center;
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  for (i = 0; i < this.clusters_.length; i++) {
    cluster = this.clusters_[i];
    center = cluster.getCenter();
    if (center) {
      d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function (iFirst) {
  var i, marker;
  var mapBounds;
  var cMarkerClusterer = this;
  if (!this.ready_) {
    return;
  }

  // Cancel previous batch processing if we're working on the first batch:
  if (iFirst === 0) {
    /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringbegin", this);

    if (typeof this.timerRefStatic !== "undefined") {
      clearTimeout(this.timerRefStatic);
      delete this.timerRefStatic;
    }
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  //
  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
  if (this.getMap().getZoom() > 3) {
    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
      this.getMap().getBounds().getNorthEast());
  } else {
    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
  }
  var bounds = this.getExtendedBounds(mapBounds);

  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

  for (i = iFirst; i < iLast; i++) {
    marker = this.markers_[i];
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
        this.addToClosestCluster_(marker);
      }
    }
  }

  if (iLast < this.markers_.length) {
    this.timerRefStatic = setTimeout(function () {
      cMarkerClusterer.createClusters_(iLast);
    }, 0);
  } else {
    delete this.timerRefStatic;

    /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringend", this);
  }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
  return (function (object) {
    var property;
    for (property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function (markers, numStyles) {
  var index = 0;
  var title = "";
  var count = markers.length.toString();

  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

module.exports = MarkerClusterer


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("baf5d1f0", content, true, {});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mw_map_info_content geowerft",class:[
    _vm.win_vermarktungsart &&
    _vm.win_vermarktungsart.toLowerCase() ===
      this.geoWerftData.texts.blur_hp_status_name.toLowerCase() &&
    this.geoWerftData.checkboxes.display_marketing_method === true
      ? 'mw-display-fremdobjekt'
      : '',
    _vm.win_homepage_status.replace(/\s+/g, '-').toLowerCase() ],attrs:{"data-id":_vm.win_id}},[(
      (true === this.geoWerftData.checkboxes.allow_prop_offline_detection &&
        ((true ===
          this.geoWerftData.checkboxes
            .allow_prop_offline_detection_only_logged_in &&
          this.geoWerftData.user.logged_in) ||
          false ===
            this.geoWerftData.checkboxes
              .allow_prop_offline_detection_only_logged_in) &&
        _vm.win_homepage_status &&
        _vm.win_homepage_status.toLowerCase() ===
          this.geoWerftData.texts.prop_offline_hp_status.toLowerCase()) ||
      (_vm.win_vermarktungsart &&
        _vm.win_vermarktungsart.toLowerCase() ===
          this.geoWerftData.texts.prop_offline_hp_status.toLowerCase())
    )?_c('div',{staticClass:"mw-geo-set-prop-offline-map",on:{"click":function($event){return _vm.set_selected_prop_offline($event.target, _vm.win_id)}}},[_c('div',{staticClass:"mw-set-prop-offline-content",attrs:{"title":"Dieses Angebot ist nicht mehr verfügbar?"}},[_c('img',{attrs:{"alt":"","src":this.geoWerftData.texts.prop_offline_picture}})])]):_vm._e(),_vm._v(" "),(
      ('ja' === (_vm.win_tour || '') || '1' === (_vm.win_tour || '')) &&
      this.geoWerftData.checkboxes.display_tour_icon
    )?_c('div',{staticClass:"mw-list-tour-icon-wrapper"},[_c('div',{staticClass:"tour-ico-wrapper"},[('' !== this.geoWerftData.customimages.tour_icon_src)?_c('img',{attrs:{"alt":"","src":this.geoWerftData.customimages.tour_icon_src}}):_vm._e()])]):_vm._e(),_vm._v(" "),_c('h3',[(
        ((_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
        _vm.win_link_extern === '' &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_objekttitel)}}):(
        ((_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('a',{attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_objekttitel)}})]):(
        true === this.geoWerftData.show_extern_link &&
        _vm.win_link_extern_url !== '' &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('a',{attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_objekttitel)}})]):_c('a',{attrs:{"href":_vm.permalink,"target":"_blank"}},[(this.geoWerftData.checkboxes.other_info_window)?_c('span',{domProps:{"innerHTML":_vm._s(
          _vm.win_plz +
          ' ' +
          _vm.win_ort +
          ' | ' +
          _vm.capitalizeFirstLetter(_vm.win_objektart_raw)
        )}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_objekttitel)}})])]),_vm._v(" "),_c('div',{staticClass:"mw-obj-box-content-place"},[(
        true === this.geoWerftData.geowerft_gtb_active &&
        true === this.geoWerftData.geowerft_gtb_watchlist_active
      )?_c('span',{staticClass:"mw-gtb-watchlist-window-wrapper"},[(this.geoWerftData.user.logged_in)?_c('span',{staticClass:"mw-gtb-like-wrapper",attrs:{"data-current-id":_vm.win_id}},[(
            '' !== this.geoWerftData.geowerft_setting_watchlist_icon_custom
          )?_c('span',{staticClass:"mw-watchlist-info-custom-icon-wrapper",attrs:{"data-current-id":_vm.win_id,"id":'mw-gtb-like-in-window-' + _vm.win_id},domProps:{"innerHTML":_vm._s(this.geoWerftData.geowerft_setting_watchlist_icon_custom)},on:{"click":function($event){return _vm.mw_add_to_watchlist($event)}}}):_c('svg',{attrs:{"id":'mw-gtb-like-in-window-' + _vm.win_id,"fill":"#d8d8d8","width":"23","height":"19.67","viewBox":"0 0 23 19.67"},on:{"click":function($event){return _vm.mw_add_to_watchlist($event)}}},[_c('path',{attrs:{"d":"M2.138,53.753l8.117,7.579a1.826,1.826,0,0,0,2.489,0l8.117-7.579A6.721,6.721,0,0,0,23,48.833v-.261a6.421,6.421,0,0,0-10.961-4.542l-.539.539-.539-.539A6.421,6.421,0,0,0,0,48.573v.261a6.721,6.721,0,0,0,2.138,4.919Z","transform":"translate(0 -42.151)"}})])]):_vm._e(),_vm._v(" "),(false === this.geoWerftData.user.logged_in)?_c('span',{staticClass:"mw-gtb-like-wrapper",attrs:{"data-current-id":_vm.win_id},on:{"click":function($event){return _vm.mw_gtb_open_login_or_register()}}},[_c('svg',{attrs:{"width":"23","height":"19.67","viewBox":"0 0 23 19.67","fill":"#d8d8d8"}},[_c('path',{attrs:{"d":"M2.138,53.753l8.117,7.579a1.826,1.826,0,0,0,2.489,0l8.117-7.579A6.721,6.721,0,0,0,23,48.833v-.261a6.421,6.421,0,0,0-10.961-4.542l-.539.539-.539-.539A6.421,6.421,0,0,0,0,48.573v.261a6.721,6.721,0,0,0,2.138,4.919Z","transform":"translate(0 -42.151)"}})])]):_vm._e(),_vm._v(" "),(this.geoWerftData.user.logged_in)?_c('span',{staticClass:"mw-gtb-list-wrapper",attrs:{"data-current-id":_vm.win_id},on:{"click":function($event){return _vm.mw_open_watchlist()}}},[_c('svg',{attrs:{"fill":"#5e5e5e","width":"21","height":"21","viewBox":"0 0 24 24","xml:space":"preserve"}},[_c('g',{attrs:{"id":"sort"}},[_c('g',[_c('rect',{attrs:{"x":"7","y":"2","width":"16","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"8","width":"14","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"1","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"14","width":"12","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"13","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"20","width":"10","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"19","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"7","width":"4","height":"4"}})])])])]):_vm._e(),_vm._v(" "),(false === this.geoWerftData.user.logged_in)?_c('span',{staticClass:"mw-gtb-list-wrapper",attrs:{"data-current-id":_vm.win_id},on:{"click":function($event){return _vm.mw_gtb_open_login_or_register()}}},[_c('svg',{attrs:{"fill":"#5e5e5e","width":"21","height":"21","viewBox":"0 0 24 24","xml:space":"preserve"}},[_c('g',{attrs:{"id":"sort"}},[_c('g',[_c('rect',{attrs:{"x":"7","y":"2","width":"16","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"8","width":"14","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"1","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"14","width":"12","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"13","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"7","y":"20","width":"10","height":"2"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"19","width":"4","height":"4"}})]),_vm._v(" "),_c('g',[_c('rect',{attrs:{"x":"1","y":"7","width":"4","height":"4"}})])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(this.geoWerftData.checkboxes.other_info_window)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_kennung)}}):(_vm.win_homepage_status.toLowerCase() === 'bieterverfahren')?_c('span',[_c('img',{staticClass:"auction-pin-infowindow",attrs:{"src":_vm.geoWerftData.texts.auction_popup_picture,"alt":""}}),_vm._v(" "),_c('span',{staticClass:"info-window-auction-label"},[_vm._v("Angebot")]),_vm._v(" "),(false === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_plz)}}):_vm._e(),_vm._v(" "),(false === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_ort)}}):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_geolocation)}}):_vm._e(),_vm._v("\n      | "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.capitalizeFirstLetter(_vm.win_objektart_raw))}})]):_c('span',[_c('em',{staticClass:"fa fa-map-marker"}),_vm._v(" "),(false === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_plz)}}):_vm._e(),_vm._v(" "),(false === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_ort)}}):_vm._e(),_vm._v(" "),(
          true === _vm.geoWerftData.checkboxes.set_geolocation &&
          _vm.win_vermarktungsart &&
          _vm.win_vermarktungsart.toLowerCase() === 'zukunftsmarktradar'
        )?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_plz + ' | ')}}):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.checkboxes.set_geolocation)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_geolocation)}}):_vm._e(),_vm._v("\n      | "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.capitalizeFirstLetter(_vm.win_objektart_raw))}})])]),_vm._v(" "),_c('div',{staticClass:"mw_map_inner_left",on:{"click":function($event){return _vm.map_trigger_ajax_request('', {
        kennung: _vm.win_kennung,
        link: _vm.win_link_extern,
      })}}},[(
        isNaN(
          _vm.geowerft_map_get_banner(
            _vm.win_homepage_status.toLowerCase(),
            _vm.win_erwerbsart.toLowerCase(),
            _vm.win_res_begin,
            _vm.win_res_ende,
            _vm.win_price,
            _vm.win_price_rent,
            _vm.win_display_badge_new
          )
        )
      )?_c('div',{staticClass:"geowerft-banner-small-info-window-wrapper"},[_c('div',{class:'geowerft-banner-small-info-window ' +
          _vm.geowerft_map_get_banner(
            _vm.win_homepage_status.toLowerCase(),
            _vm.win_erwerbsart.toLowerCase(),
            _vm.win_res_begin,
            _vm.win_res_ende,
            _vm.win_price,
            _vm.win_price_rent,
            _vm.win_display_badge_new
          ),domProps:{"innerHTML":_vm._s(
          _vm.geowerft_map_get_banner(
            _vm.win_homepage_status.toLowerCase(),
            _vm.win_erwerbsart.toLowerCase(),
            _vm.win_res_begin,
            _vm.win_res_ende,
            _vm.win_price,
            _vm.win_price_rent,
            _vm.win_display_badge_new
          )
        )}})]):_vm._e(),_vm._v(" "),(
        ((_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
        _vm.win_link_extern === '' &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('span',[(_vm.image_url)?_c('img',{staticStyle:{"max-width":"150px","max-height":"100px"},attrs:{"src":_vm.image_url,"loading":"lazy"}}):_vm._e()]):(
        ((_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('a',{staticClass:"mw-filter-presentation-image-link",attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[(_vm.image_url)?_c('img',{staticStyle:{"max-width":"150px","max-height":"100px"},attrs:{"src":_vm.image_url,"loading":"lazy"}}):_vm._e()]):(
        true === this.geoWerftData.show_extern_link &&
        _vm.win_link_extern_url !== '' &&
        false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
      )?_c('a',{staticClass:"mw-filter-presentation-image-link",attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[(_vm.image_url)?_c('img',{staticStyle:{"max-width":"150px","max-height":"100px"},attrs:{"src":_vm.image_url,"loading":"lazy"}}):_vm._e()]):_c('a',{staticClass:"mw-filter-presentation-image-link",attrs:{"href":_vm.permalink,"target":"_blank"}},[(_vm.image_url)?_c('img',{staticStyle:{"max-width":"150px","max-height":"100px"},attrs:{"src":_vm.image_url,"loading":"lazy"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"mw_map_inner_right",on:{"click":function($event){return _vm.map_trigger_ajax_request('', {
        kennung: _vm.win_kennung,
        link: _vm.win_link_extern,
      })}}},[(
        (_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
        (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')
      )?_c('span',{staticClass:"span-wrapper-price buy"},[(
          false === isNaN(_vm.win_price) &&
          ('kauf' === _vm.win_erwerbsart.toLowerCase() ||
            'buy' === _vm.win_erwerbsart.toLowerCase())
        )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in kaufpreis'
            : 'logged_out kaufpreis'},[_vm._v("Kaufpreis: "+_vm._s(_vm.get_format_price(_vm.win_price) || _vm.format - _vm.price)+"\n        "+_vm._s(_vm.geoWerftData.texts.currency_suffix)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(
        (_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
        (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')
      )?_c('span',{staticClass:"span-wrapper-price rent"},[(
          false === isNaN(_vm.win_price_rent) &&
          ('miete' === _vm.win_erwerbsart.toLowerCase() ||
            'rent' === _vm.win_erwerbsart.toLowerCase())
        )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in mietpreis'
            : 'logged_out mietpreis'},[_vm._v("Mietpreis:\n        "+_vm._s(_vm.get_format_price(_vm.win_price_rent) || _vm.format - _vm.price)+"\n        "+_vm._s(_vm.geoWerftData.texts.currency_suffix)),_c('br')]):_vm._e()]):_vm._e(),_vm._v(" "),(false === this.geoWerftData.checkboxes.other_info_window)?_c('span',{staticClass:"span-prop-kennung"},[_c('span',{domProps:{"innerHTML":_vm._s(
          this.geoWerftData.texts.info_window_obj_nr + ' ' + _vm.win_kennung
        )}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_price_qm)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in mietpreis'
          : 'logged_out mietpreis'},[_vm._v(_vm._s(this.geoWerftData.texts.mietpreis_pro_qm_pre)+_vm._s(_vm.get_format_price(_vm.win_price_qm))+_vm._s(this.geoWerftData.texts.mietpreis_pro_qm_post)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_bueroflaeche)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in buerofleache'
          : 'logged_out bueroflaeche'},[_vm._v("Bürofläche: "+_vm._s(_vm.win_bueroflaeche)+" m²"),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_teilbarkeit)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in teilbarab'
          : 'logged_out teilbarab'},[_vm._v("Teilbarkeit ab: "+_vm._s(_vm.win_teilbarkeit)+" m²"),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_bezug)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in bezug'
          : 'logged_out bezug'},[_vm._v(_vm._s(this.geoWerftData.texts.label_bezug_ab_map_view)+_vm._s(_vm.win_bezug)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_zimmer)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in zimmer'
          : 'logged_out zimmer'},[_vm._v("Zimmer: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_zimmer.replace('.', ','))}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_count_adults)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in anzahl_erwachsene'
          : 'logged_out anzahl_erwachsene'},[_vm._v("Anzahl Erwachsene: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_count_adults)}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_count_childs)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in anzahl_kinder'
          : 'logged_out anzahl_kinder'},[_vm._v("Anzahl Kinder: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_count_childs)}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_barrierefrei)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in barrierefrei'
          : 'logged_out barrierefrei'},[_vm._v("Barrierefrei:\n      "),_vm._m(0),_c('br')]):_vm._e(),_vm._v(" "),(_vm.win_haustiere)?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in haustiere'
          : 'logged_out haustiere'},[_vm._v("Haustiere:\n      "),_vm._m(1),_c('br')]):_vm._e(),_vm._v(" "),(
        _vm.win_wohnflaeche &&
        -1 === _vm.win_objektart_raw.toLowerCase().indexOf('invest')
      )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in wohnflaeche'
          : 'logged_out wohnflaeche'},[_vm._v("Wohnfläche: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_wohnflaeche)}}),_vm._v(" m²"),_c('br')]):_vm._e(),_vm._v(" "),(
        _vm.win_vermietbare_flaeche &&
        -1 !== _vm.win_objektart_raw.toLowerCase().indexOf('invest')
      )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in vermietbareflaeche'
          : 'logged_out vermietbareflaeche'},[_vm._v("Vermietbare Fläche:\n      "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_vermietbare_flaeche)}}),_vm._v(" m²"),_c('br')]):_vm._e(),_vm._v(" "),(
        _vm.win_grundstuecksflaeche &&
        !(
          (_vm.win_homepage_status &&
            _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')
        )
      )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in grundflaeche'
          : 'logged_out grundflaeche'},[_vm._v("Grundstücksfläche:\n      "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_grundstuecksflaeche)}}),_vm._v(" m²")]):_vm._e(),_vm._v(" "),(
        _vm.win_gesamtflaeche && this.geoWerftData.checkboxes.display_ges_flaeche
      )?_c('span',{class:this.geoWerftData.user.user_fully_logged_in
          ? 'logged_in gesamtflaeche'
          : 'logged_out gesamtflaeche'},[_vm._v("Gesamtfläche: "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_gesamtflaeche)}}),_vm._v(" m²")]):_vm._e(),_vm._v(" "),(
        (((_vm.win_homepage_status &&
          _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
          (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
          false ===
            this.geoWerftData.checkboxes.custom_marketwatch_temp_active) ||
        (this.geoWerftData.checkboxes.display_sorce_in_market_watch &&
          _vm.win_vermarktungsart &&
          _vm.win_vermarktungsart.toLowerCase() ===
            this.geoWerftData.texts.market_watch_name.toLowerCase())
      )?_c('span',{staticClass:"span-desination-wrapper"},[_vm._v("\n      Quelle:\n      "),(_vm.win_link_extern !== '')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_link_extern)}}):_c('span',{domProps:{"innerHTML":_vm._s(_vm.win_kennung)}}),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(
        true ===
        this.geoWerftData.checkboxes.show_price_in_paginated_info_window
      )?_c('div',{staticClass:"infowindow-whole-price-wrapper"},[_c('div',{staticClass:"infowindow-price-wrapper"},[_c('div',{staticClass:"label-wrapper",domProps:{"innerHTML":_vm._s(
            _vm.get_price_label(
              _vm.win_homepage_status,
              _vm.win_vermarktungsart,
              _vm.win_price_rent,
              _vm.win_price,
              _vm.win_erwerbsart
            )
          )}}),_vm._v(" "),_c('div',{staticClass:"price-wrapper",domProps:{"innerHTML":_vm._s(
            _vm.get_price(
              _vm.win_homepage_status,
              _vm.win_vermarktungsart,
              _vm.win_price_rent,
              _vm.win_price,
              _vm.win_erwerbsart
            )
          )}})])]):_vm._e(),_vm._v(" "),(
        'true' === this.geoWerftData.texts.diff_extern_link &&
        (_vm.win_homepage_status === 'Aktive Marktbeobachtung' ||
          _vm.win_homepage_status === 'Fremdobjekt' ||
          this.geoWerftData.marketwatch_extern_links_hp.includes(
            _vm.win_homepage_status
          ))
      )?_c('span',{staticClass:"span-destination-wrapper-new"},[_c('span',{staticClass:"mw-extern-view-wrapper"},[_c('span',{staticClass:"single-button-wrapper wrapper-left"},[_c('a',{staticClass:"single-extern-btn important",attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[_vm._v("\n            Zum Angebot\n          ")])]),_vm._v(" "),_c('span',{staticClass:"single-button-wrapper wrapper-right"},[_c('a',{staticClass:"single-extern-btn not-important",attrs:{"href":_vm.permalink,"target":"_blank"}},[_vm._v("\n            Zum Vergleich\n          ")])])])]):_c('span',{staticClass:"span-destination-wrapper-old"},[(
          ((_vm.win_homepage_status &&
            _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
            (_vm.win_vermarktungsart && _vm.win_vermarktungsart === 'Fremdobjekt')) &&
          _vm.win_link_extern === '' &&
          false === _vm.geoWerftData.checkboxes.custom_marketwatch_temp_active
        )?_c('span'):_c('span',[_c('div',{staticClass:"mw-obj-box-content-details"},[(
              ((_vm.win_homepage_status &&
                _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
                (_vm.win_vermarktungsart &&
                  _vm.win_vermarktungsart === 'Fremdobjekt')) &&
              _vm.win_link_extern_url !== '' &&
              false ===
                this.geoWerftData.checkboxes.custom_marketwatch_temp_active
            )?_c('a',{staticClass:"btn-details",attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[_vm._v("\n            "+_vm._s(this.geoWerftData.texts.label_details)+"\n          ")]):(
              ((_vm.win_homepage_status &&
                _vm.win_homepage_status === 'Aktive Marktbeobachtung') ||
                (_vm.win_vermarktungsart &&
                  _vm.win_vermarktungsart === 'Fremdobjekt')) &&
              true === this.geoWerftData.checkboxes.logged_in_market_watch &&
              false === this.geoWerftData.user.logged_in
            )?_c('a',{staticClass:"btn-details",attrs:{"href":this.geoWerftData.texts.market_watch_alt_link,"target":"_blank"}},[_vm._v("\n            "+_vm._s(this.geoWerftData.texts.label_details)+"\n          ")]):(
              true === this.geoWerftData.show_extern_link &&
              _vm.win_link_extern_url !== '' &&
              false ===
                this.geoWerftData.checkboxes.custom_marketwatch_temp_active
            )?_c('a',{staticClass:"btn-details",attrs:{"href":_vm.win_link_extern_url,"target":"_blank"}},[_vm._v("\n            "+_vm._s(this.geoWerftData.texts.label_details)+"\n          ")]):(
              false === this.geoWerftData.user.logged_in &&
              true === this.geoWerftData.user.link_for_logged_in_only
            )?_c('a',{staticClass:"btn-details",attrs:{"href":this.geoWerftData.user.link_for_logged_in_only_url}},[_vm._v("\n            "+_vm._s(this.geoWerftData.user.link_for_logged_in_only_label)+"\n          ")]):_c('a',{staticClass:"btn-details",attrs:{"href":_vm.permalink,"target":"_blank"}},[_vm._v("\n            "+_vm._s(this.geoWerftData.texts.label_details)+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"geowerft-cb-check"},[_c('em',{staticClass:"fa fa-check-square",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"geowerft-cb-check"},[_c('em',{staticClass:"fa fa-check-square",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindowPaginator_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c31b9c44_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindowPaginator_vue__ = __webpack_require__(79);
function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c31b9c44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWindowPaginator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c31b9c44_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWindowPaginator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(78);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1fc2af6c", content, true, {});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".paginator_area[data-v-c31b9c44]{width:100%;height:auto;min-height:1px;overflow:hidden;margin-top:16px;padding:4px}.info-area[data-v-c31b9c44]{width:30%}.info-area[data-v-c31b9c44],.left-icon[data-v-c31b9c44]{text-align:center;height:auto;min-height:1px;overflow:hidden;float:left}.left-icon[data-v-c31b9c44]{font-size:xx-large;width:35%}.right-icon[data-v-c31b9c44]{float:right;text-align:center;font-size:xx-large;width:35%;height:auto;min-height:1px;overflow:hidden}.fa[data-v-c31b9c44]{position:unset}", ""]);

// exports


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((this.estates.slice(_vm.itemNumber, _vm.itemNumber + 1)),function(item){return _c('div',{},[_c('InfoWindow',{attrs:{"geoWerftData":_vm.geoWerftData,"image_url":item.image_url,"win_objekttitel":item.win_objekttitel,"win_plz":item.win_plz,"win_ort":item.win_ort,"win_geolocation":item.win_geolocation,"win_objektart_raw":item.win_objektart_raw,"win_kennung":item.win_kennung,"win_res_begin":item.win_res_begin,"win_res_ende":item.win_res_ende,"win_price":item.win_price,"win_price_rent":item.win_price_rent,"win_display_badge_new":item.win_display_badge_new,"win_erwerbsart":item.win_erwerbsart,"win_homepage_status":item.win_homepage_status,"win_count_adults":item.win_count_adults,"win_count_childs":item.win_count_childs,"win_barrierefrei":item.win_barrierefrei,"win_haustiere":item.win_haustiere,"win_price_qm":item.win_price_qm,"win_teilbarkeit":item.win_teilbarkeit,"win_bueroflaeche":item.win_bueroflaeche,"win_bezug":item.win_bezug,"win_zimmer":item.win_zimmer,"win_wohnflaeche":item.win_wohnflaeche,"win_vermietbare_flaeche":item.win_vermietbare_flaeche,"win_grundstuecksflaeche":item.win_grundstuecksflaeche,"win_link_extern":item.win_link_extern,"win_link_extern_url":item.win_link_extern_url,"permalink":item.permalink}})],1)}),_vm._v(" "),_c('div',{staticClass:"paginator_area"},[_c('div',{staticClass:"left-icon"},[(_vm.itemNumber > 0)?_c('i',{staticClass:"fa fa-chevron-circle-left",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.prev()}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"info-area"},[_vm._v("\n      Angebot "),_c('br'),_vm._v("\n      "+_vm._s(_vm.itemNumber + 1)+" von "+_vm._s(this.estates.length)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"right-icon"},[(_vm.itemNumber < this.estates.length - 1)?_c('i',{staticClass:"fa fa-chevron-circle-right",attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.next()}}}):_vm._e()])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"object-map",attrs:{"id":"geowerft-map-wrapper"}},[(
      ('empty' === _vm.geowerft_get_cookie_by_name('geowerft_tutorial') &&
        true === _vm.geoWerftData.checkboxes.enable_tutorial) ||
      ('empty' === _vm.geowerft_get_cookie_by_name('prop_offline_tutorial') &&
        true === _vm.geoWerftData.checkboxes.prop_offline_single_overlay &&
        true === _vm.geoWerftData.user.logged_in)
    )?_c('div',{staticClass:"mw-geowerft-tut-arrow-wrapper"},[(
        true === _vm.geoWerftData.checkboxes.prop_offline_single_overlay &&
        false === _vm.geoWerftData.checkboxes.prop_offline_include_overlay &&
        true === _vm.geoWerftData.user.logged_in &&
        'empty' === _vm.geowerft_get_cookie_by_name('prop_offline_tutorial')
      )?_c('div'):(true === _vm.geoWerftData.checkboxes.enable_tutorial)?_c('div',[_c('div',{staticClass:"mw-geo-arrow-one-wrapper"},[(_vm.geoWerftData.customimages.tutorial_picture_one)?_c('div',{staticClass:"mw-geo-arrow-one"},[_c('img',{staticClass:"tutorial-picture-one",attrs:{"alt":"","src":_vm.geoWerftData.customimages.tutorial_picture_one}})]):_c('div',{staticClass:"mw-geo-arrow-one"},[_c('em',{staticClass:"fa fa-arrow-up fa-4x tutorial-arrow blinking-arrow",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"mw-geo-arrow-two-wrapper"},[(_vm.geoWerftData.customimages.tutorial_picture_two)?_c('div',{staticClass:"mw-geo-arrow-two"},[_c('img',{staticClass:"tutorial-picture-two",attrs:{"alt":"","src":_vm.geoWerftData.customimages.tutorial_picture_two}})]):_c('div',{staticClass:"mw-geo-arrow-two"},[_c('em',{staticClass:"fa fa-arrow-up fa-4x tutorial-arrow-two blinking-arrow",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"mw-geo-arrow-three-wrapper"},[(_vm.geoWerftData.customimages.tutorial_picture_three)?_c('div',{staticClass:"mw-geo-arrow-three"},[_c('img',{staticClass:"tutorial-picture-three",attrs:{"alt":"","src":_vm.geoWerftData.customimages.tutorial_picture_three}})]):_c('div',{staticClass:"mw-geo-arrow-three"},[_c('em',{staticClass:"fa fa-arrows fa-4x tutorial-move-arrow blinking-arrow",attrs:{"aria-hidden":"true"}})])])]):_vm._e()]):_vm._e(),_vm._v(" "),(
      ('empty' === _vm.geowerft_get_cookie_by_name('geowerft_tutorial') &&
        true === _vm.geoWerftData.checkboxes.enable_tutorial) ||
      ('empty' === _vm.geowerft_get_cookie_by_name('prop_offline_tutorial') &&
        true === _vm.geoWerftData.checkboxes.prop_offline_single_overlay &&
        true === _vm.geoWerftData.user.logged_in)
    )?_c('div',{staticClass:"geowerft-tutorial-wrapper"},[(
        'empty' === _vm.geowerft_get_cookie_by_name('prop_offline_tutorial') &&
        true === _vm.geoWerftData.checkboxes.prop_offline_single_overlay &&
        false === _vm.geoWerftData.checkboxes.prop_offline_include_overlay &&
        true === _vm.geoWerftData.user.logged_in
      )?_c('div',{on:{"click":function($event){return _vm.mw_set_geowerft_cookie('prop_offline_tutorial', '1', { days: 30 })}}},[_c('div',{staticClass:"geowerft-prop-offline-explain-text",domProps:{"innerHTML":_vm._s(
          _vm.geoWerftData.texts.prop_offline_tutorial_text.replace(
            '##LINK##',
            _vm.geoWerftData.texts.prop_offline_picture
          )
        )}}),_vm._v(" "),_c('div',{staticClass:"prop-offline-finish-btn-single",attrs:{"onclick":"jQuery( this ).parent().parent().hide();"}},[_vm._v("\n        Fertig\n      ")])]):(true === _vm.geoWerftData.checkboxes.enable_tutorial)?_c('div',[_c('div',{staticClass:"geowerft-tutorialbox-one-wrapper"},[_c('div',{staticClass:"geowerft-tutorial-explain-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.tutorial_text_one)}}),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorial-button-wrapper"},[_c('div',{staticClass:"geowerft-tutorial-btn-left"},[_c('button',{attrs:{"data-geo-tutorial":"skip"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n              Intro überspringen\n            ")])]),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorial-btn-right"},[_c('button',{attrs:{"data-geo-tutorial":"box-2","data-geo-box":"geowerft-tutorialbox-one-wrapper","data-geo-box-next":"geowerft-tutorialbox-two-wrapper"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n              weiter\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorialbox-two-wrapper"},[_c('div',{staticClass:"geowerft-tutorial-explain-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.tutorial_text_two)}}),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorial-btn-left"},[_c('button',{attrs:{"data-geo-tutorial":"skip"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n            Intro überspringen\n          ")])]),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorial-btn-right"},[_c('button',{attrs:{"data-geo-tutorial":"box-3","data-geo-box":"geowerft-tutorialbox-two-wrapper","data-geo-box-next":"geowerft-tutorialbox-three-wrapper"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n            weiter\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"geowerft-tutorialbox-three-wrapper"},[_c('div',{staticClass:"geowerft-tutorial-explain-text",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.texts.tutorial_text_three)}}),_vm._v(" "),(true === _vm.geoWerftData.checkboxes.prop_offline_include_overlay)?_c('div',{staticClass:"geowerft-tutorial-btn-left"},[_c('button',{attrs:{"data-geo-tutorial":"skip"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n            Intro überspringen\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{class:true === _vm.geoWerftData.checkboxes.prop_offline_include_overlay &&
            true === _vm.geoWerftData.user.logged_in
              ? 'geowerft-tutorial-btn-right'
              : 'geowerft-tutorial-btn-finish'},[_c('button',{attrs:{"data-geo-tutorial":"skip"},domProps:{"innerHTML":_vm._s(
              true === _vm.geoWerftData.checkboxes.prop_offline_include_overlay &&
              true === _vm.geoWerftData.user.logged_in
                ? 'weiter'
                : 'Fertig'
            )},on:{"click":function($event){return _vm.render_next_tutorial_step($event, 'three')}}},[_vm._v("\n            Fertig\n          ")])])]),_vm._v(" "),(
          true === _vm.geoWerftData.checkboxes.prop_offline_include_overlay &&
          true === _vm.geoWerftData.user.logged_in
        )?_c('div',{staticClass:"geowerft-tutorialbox-four-wrapper",staticStyle:{"display":"none"},attrs:{"id":"prop-offline-explain"}},[_c('div',{staticClass:"geowerft-tutorial-explain-text",domProps:{"innerHTML":_vm._s(
            _vm.geoWerftData.texts.prop_offline_tutorial_text.replace(
              '##LINK##',
              _vm.geoWerftData.texts.prop_offline_picture
            )
          )}}),_vm._v(" "),_c('div',{staticClass:"prop-offline-finish-btn"},[_c('button',{attrs:{"data-geo-tutorial":"skip"},on:{"click":function($event){return _vm.render_next_tutorial_step($event)}}},[_vm._v("\n            Fertig\n          ")])])]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.geoWerftData.checkboxes.enable_filialen_mode)?_c('div',{staticClass:"geowerft-lasche"},[_c('i',{staticClass:"fa fa-chevron-right",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(true === this.geoWerftData.checkboxes.display_google_search)?_c('div',{staticClass:"autocomplete-location-picker"},[_c('gmap-autocomplete',{attrs:{"placeholder":this.geoWerftData.texts.autocomplete_placeholder,"options":{
        componentRestrictions: { country: ['de'] },
        fields: ['geometry'],
      }},on:{"place_changed":_vm.setPlace}})],1):_vm._e(),_vm._v(" "),('' !== _vm.geoWerftData.enable_ai_quick_chat_custom)?_c('div',{staticClass:"geomap-wrapped-custom-ai",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.enable_ai_quick_chat_custom)}}):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.enable_ai_quick_chat)?_c('div',{staticClass:"mw-quick-ai-map-wrapper"},[_c('div',{staticClass:"mw-quick-ai-icon-or-pic"}),_vm._v(" "),_c('div',{staticClass:"mw-quick-ai-input-wrapper"},[_c('label',{attrs:{"for":"mw-quick-ai-map-search-input"}},[_vm._v(_vm._s(_vm.geoWerftData.ai_quick_label))]),_vm._v(" "),_c('input',{attrs:{"placeholder":_vm.geoWerftData.ai_quick_placeholder,"type":"text","value":"","name":"mw_quick_ai_map_search","id":"mw-quick-ai-map-search-input"}}),_vm._v(" "),_c('button',{staticClass:"mw-quick-ai-record-btn-wrapper",attrs:{"type":"button","title":"Aufnahme starten"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.geoWerftData.ai_quick_svg)}})])]),_vm._v(" "),_c('dialog',{staticClass:"mw-custom-gif-loader-ai-assistant mw-block-modal mw-backdrop-close chrome"},[_c('div',{staticClass:"mw-assistant-loader-center"},[_c('div',{staticClass:"ai-search-wrapper"},[(_vm.geoWerftData.ai_load_img_pre)?_c('div',{staticClass:"ai-search-mascot-asset1"},[_c('div',{staticClass:"ai-search-mascot-cloud1"},[_c('img',{attrs:{"src":_vm.geoWerftData.ai_load_img_pre,"alt":"Cloud Asset"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ai-search-mascot-wrapper"},[_c('div',{staticClass:"ai-search-mascot"},[_c('img',{attrs:{"src":_vm.geoWerftData.ai_load_img,"width":"200px","alt":"KI Suche läuft"}})])]),_vm._v(" "),(_vm.geoWerftData.ai_load_img_after)?_c('div',{staticClass:"ai-search-mascot-asset2"},[_c('div',{staticClass:"ai-search-mascot-cloud2"},[_c('img',{attrs:{"src":_vm.geoWerftData.ai_load_img_after,"alt":"Cloud Asset"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ai-search-mascot-infotext"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.geoWerftData.ai_load_text)}})])])])])]):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.reset_bounds)?_c('div',{staticClass:"reset-map-bounds-wrapper"},[_c('button',{staticClass:"mw-reset-map-bounds-btn",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.reset_bounds_label)},on:{"click":function($event){return _vm.mw_restore_init_bounds()}}})]):_vm._e(),_vm._v(" "),(_vm.geoWerftData.checkboxes.enable_filialen_mode)?_c('div',{staticClass:"mw-geo-makler-search-holder"}):_vm._e(),_vm._v(" "),(
      _vm.loadingStatus === 0 &&
      _vm.found_props > 0 &&
      this.geoWerftData.checkboxes.next_pin_active
    )?_c('div',{staticClass:"mw-geo-to-next-marker-wrapper"},[(
        false === this.geoWerftData.checkboxes.enable_filialen_mode &&
        _vm.filteredObjects > 0
      )?_c('div',{staticClass:"mw-geo-to-next-marker-text-prop",domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_next_pin_prop)}}):_vm._e(),_vm._v(" "),(
        false === this.geoWerftData.checkboxes.enable_filialen_mode &&
        _vm.filteredObjects === 0
      )?_c('div',{staticClass:"mw-geo-to-next-marker-text-prop no-immo-found-filter",domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_filter_next_pin_prop)}}):_vm._e(),_vm._v(" "),(true === this.geoWerftData.checkboxes.enable_filialen_mode)?_c('div',{staticClass:"mw-geo-to-next-marker-text-ppl",domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_next_pin_ppl)}}):_vm._e(),_vm._v(" "),(
        false === this.geoWerftData.checkboxes.enable_filialen_mode &&
        _vm.filteredObjects > 0
      )?_c('div',{staticClass:"mw-geo-to-next-marker-button-prop mw-go-to-next-button",domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_button_next_pin_prop)},on:{"click":function($event){return _vm.get_the_closest_marker()}}}):_vm._e(),_vm._v(" "),(true === this.geoWerftData.checkboxes.enable_filialen_mode)?_c('div',{staticClass:"mw-geo-to-next-marker-button-ppl mw-go-to-next-button",domProps:{"innerHTML":_vm._s(this.geoWerftData.texts.text_button_next_pin_ppl)},on:{"click":function($event){return _vm.get_the_closest_marker()}}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('gmap-map',{ref:"main_gmap_obj",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":this.geoWerftData.map.center,"zoom":this.geoWerftData.map.zoom,"options":{
      styles: this.geoWerftData.custom_map_style,
      minZoom: 3,
      maxZoom: this.geoWerftData.map.maxZoom,
      zoomControl: this.geoWerftData.map.map_zoom_control,
      mapTypeControl: this.geoWerftData.checkboxes.show_map_satellite_switch,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      mapTypeId: this.geoWerftData.map.map_type_id,
      scrollwheel: true,
      gestureHandling: this.geoWerftData.map.map_touch_mode,
    }},on:{"dragend":function($event){return _vm.update_current_map_center($event)},"&bounds_changed":function($event){return _vm.searchLocation($event)},"&zoom_changed":function($event){return _vm.get_current_zoom($event)}}},[(this.geoWerftData.checkboxes.enable_filialen_mode)?[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen = false}}},[_c('div',{staticClass:"mw-geo-filialien-infowin-wrapper",attrs:{"id":'pin-id-' + _vm.win_filialen_id}},[_c('div',{staticClass:"infowindow-real-estate-agent-left"},[(_vm.win_img_src)?_c('div',{staticClass:"infowindow-real-estate-img"},[_c('img',{attrs:{"src":_vm.win_img_src}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"infowindow-real-estate-agent-headline",domProps:{"innerHTML":_vm._s(_vm.win_headline)}}),_vm._v(" "),_c('div',{staticClass:"infowindow-real-estate-agent-street",domProps:{"innerHTML":_vm._s(_vm.win_strasse)}}),_vm._v(" "),_c('div',{staticClass:"infowindow-real-estate-agent-plz",domProps:{"innerHTML":_vm._s(_vm.win_plz)}})]),_vm._v(" "),_c('div',{staticClass:"infowindow-real-estate-agent-right"},[(_vm.win_name)?_c('div',{staticClass:"infowindow-real-estate-agent-title"},[_vm._v("\n              "+_vm._s(_vm.win_name)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.win_tel)?_c('div',{staticClass:"infowindow-real-estate-agent-phone"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.win_tel)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.win_tel_zwei)?_c('div',{staticClass:"infowindow-real-estate-agent-phone"},[_c('i',{staticClass:"fa fa-phone",attrs:{"aria-hidden":"true"}}),_vm._v("\n              "+_vm._s(_vm.win_tel_zwei)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.win_fax)?_c('div',{staticClass:"infowindow-real-estate-agent-fax"},[_c('i',{staticClass:"fa fa-print",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.win_fax)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"infowindow-real-estate-agent-bottom"},[(_vm.win_tel)?_c('div',{staticClass:"single-real-estate-agent-url"},[_c('a',{attrs:{"href":_vm.win_link_extern_url,"target":"_blank"},domProps:{"innerHTML":_vm._s(this.geoWerftData.filialen_landingpage_label)}})]):_vm._e()])])]),_vm._v(" "),_c('gmap-cluster',{attrs:{"styles":_vm.clusterStyles,"maxZoom":this.geoWerftData.cluster_break_zoom,"zoomOnClick":true}},_vm._l((this.geoWerftData.map.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"icon":marker.url,"title":marker.title,"label":marker.label,"animation":marker.animation},on:{"click":function($event){return _vm.toggle_filialen_window(marker, index)}}})}),1)]:[(this.markerInfo)?_c('div',[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen = false}}},[_c('InfoWindow',{attrs:{"infoContent":_vm.infoContent,"image_url":_vm.image_url,"infoWindowPos":_vm.infoWindowPos,"win_objekttitel":_vm.win_objekttitel,"win_plz":_vm.win_plz,"win_ort":_vm.win_ort,"win_id":_vm.win_id,"win_gesamtflaeche":_vm.win_gesamtflaeche,"win_tour":_vm.win_tour,"win_geolocation":_vm.win_geolocation,"win_objektart_raw":_vm.win_objektart_raw,"win_kennung":_vm.win_kennung,"win_res_begin":_vm.win_res_begin,"win_res_ende":_vm.win_res_ende,"win_price":_vm.win_price,"win_price_rent":_vm.win_price_rent,"win_display_badge_new":_vm.win_display_badge_new,"win_erwerbsart":_vm.win_erwerbsart,"win_homepage_status":_vm.win_homepage_status,"geoWerftData":this.geoWerftData,"win_count_adults":_vm.win_count_adults,"win_count_childs":_vm.win_count_childs,"win_barrierefrei":_vm.win_barrierefrei,"win_haustiere":_vm.win_haustiere,"win_price_qm":_vm.win_price_qm,"win_teilbarkeit":_vm.win_teilbarkeit,"win_bueroflaeche":_vm.win_bueroflaeche,"win_bezug":_vm.win_bezug,"win_zimmer":_vm.win_zimmer,"win_wohnflaeche":_vm.win_wohnflaeche,"win_vermietbare_flaeche":_vm.win_vermietbare_flaeche,"win_grundstuecksflaeche":_vm.win_grundstuecksflaeche,"win_link_extern":_vm.win_link_extern,"win_link_extern_url":_vm.win_link_extern_url,"permalink":_vm.permalink}})],1)],1):(!this.markerInfo)?_c('div',[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen = false}}},[_c('InfoWindowPaginator',{attrs:{"estates":this.estates,"geoWerftData":this.geoWerftData}})],1)],1):_vm._e(),_vm._v(" "),(
          this.geoWerftData.show_cluster &&
          this.geoWerftData.show_cluster_no_pictures
        )?_c('span',[_c('gmap-cluster',{key:_vm.index,attrs:{"maxClusterZoom":this.geoWerftData.cluster_break_zoom,"zoomOnClick":true},on:{"click":function($event){return _vm.toggleClusterMarker($event)}}},_vm._l((this.geoWerftData.map.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"icon":marker.url,"title":marker.title,"label":marker.label,"animation":marker.animation},on:{"click":function($event){return _vm.toggleInfoWindow(marker, index)}}})}),1)],1):(
          this.geoWerftData.show_cluster &&
          !this.geoWerftData.show_cluster_no_pictures
        )?_c('span',[_c('gmap-cluster',{attrs:{"styles":_vm.clusterStyles,"maxClusterZoom":this.geoWerftData.cluster_break_zoom,"zoomOnClick":true},on:{"click":function($event){return _vm.toggleClusterMarker($event)}}},_vm._l((this.geoWerftData.map.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"icon":marker.url,"title":marker.title,"label":marker.label,"animation":marker.animation},on:{"click":function($event){return _vm.toggleInfoWindow(marker, index)}}})}),1),_vm._v(" "),_vm._l((this.geoWerftData.map.no_cluster_markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"icon":marker.url,"title":marker.title,"label":marker.label,"animation":marker.animation},on:{"click":function($event){return _vm.toggleInfoWindow(marker, index)}}})})],2):(false === this.geoWerftData.show_cluster)?_c('span',_vm._l((this.geoWerftData.map.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"clickable":true,"icon":marker.url,"title":marker.title,"label":marker.label,"animation":marker.animation},on:{"click":function($event){return _vm.toggleInfoWindow(marker, index)}}})}),1):_vm._e()]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectFilter_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050a9d59_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectFilter_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objectFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_050a9d59_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objectFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7271db33", content, true, {});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true === _vm.geoWerftData.interactive_filter_active)?_c('div',{class:_vm.mw_get_main_filter_class(_vm.geoWerftData)},[_vm._l((_vm.geoWerftData.filter),function(filter,filterIndex,count){return _c('div',{staticClass:"interactive-filter-wrapper",class:_vm.handle_field_visibility(filter, filterIndex, count, _vm.geoWerftData)},[(
        ('epass_wertklasse' !== filterIndex &&
          filter.options &&
          filter.type === 'checkbox') ||
        filter.type === 'radio'
      )?_vm._l((filter.options),function(arr_label_value,index){return _c('div',{staticClass:"single-interactive-input-wrapper",class:_vm.interactive_filter_cb_status_class(filter, arr_label_value.value)},[((filter.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + arr_label_value.value,"name":filterIndex,"type":"checkbox"},domProps:{"value":arr_label_value.value,"checked":_vm.interactive_filter_set_selected(
              filter,
              arr_label_value.value,
              'checkbox'
            ),"checked":Array.isArray(filter.value)?_vm._i(filter.value,arr_label_value.value)>-1:(filter.value)},on:{"change":[function($event){var $$a=filter.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=arr_label_value.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "value", $$c)}},function($event){return _vm.remove_filters_not_set()}]}}):((filter.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + arr_label_value.value,"name":filterIndex,"type":"radio"},domProps:{"value":arr_label_value.value,"checked":_vm.interactive_filter_set_selected(
              filter,
              arr_label_value.value,
              'checkbox'
            ),"checked":_vm._q(filter.value,arr_label_value.value)},on:{"change":[function($event){return _vm.$set(filter, "value", arr_label_value.value)},function($event){return _vm.remove_filters_not_set()}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + arr_label_value.value,"name":filterIndex,"type":filter.type},domProps:{"value":arr_label_value.value,"checked":_vm.interactive_filter_set_selected(
              filter,
              arr_label_value.value,
              'checkbox'
            ),"value":(filter.value)},on:{"change":function($event){return _vm.remove_filters_not_set()},"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":'single-interactive-option-' + arr_label_value.value},domProps:{"innerHTML":_vm._s(arr_label_value.label)}})])}):_vm._e(),_vm._v(" "),('select' === filter.type)?[_c('div',{staticClass:"single-interactive-input-wrapper",class:filterIndex + '-select'},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + filterIndex,"name":filterIndex},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""},domProps:{"innerHTML":_vm._s(filter.label)}}),_vm._v(" "),_vm._l((filter.options),function(arr_label_value,index){return _c('option',{domProps:{"value":arr_label_value.value,"selected":_vm.interactive_filter_set_selected(filter, arr_label_value.value),"innerHTML":_vm._s(arr_label_value.label)},on:{"change":function($event){return _vm.remove_filters_not_set()}}})})],2)])]:_vm._e(),_vm._v(" "),('text' === filter.type)?[_c('div',{staticClass:"single-interactive-input-wrapper",class:filterIndex + '-select'},[_c('label',{attrs:{"for":'single-interactive-option-' + filterIndex.value},domProps:{"innerHTML":_vm._s(filter.label)}}),_vm._v(" "),((filter.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + filterIndex,"name":filterIndex,"inputmode":_vm.interactive_filter_input_mode(filter),"placeholder":filter.placeholder,"type":"checkbox"},domProps:{"value":filter.value,"checked":Array.isArray(filter.value)?_vm._i(filter.value,filter.value)>-1:(filter.value)},on:{"change":[function($event){var $$a=filter.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=filter.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "value", $$c)}},function($event){return _vm.interactive_filter_format_value(filter)}],"focus":function($event){return $event.target.select()}}}):((filter.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + filterIndex,"name":filterIndex,"inputmode":_vm.interactive_filter_input_mode(filter),"placeholder":filter.placeholder,"type":"radio"},domProps:{"value":filter.value,"checked":_vm._q(filter.value,filter.value)},on:{"change":[function($event){return _vm.$set(filter, "value", filter.value)},function($event){return _vm.interactive_filter_format_value(filter)}],"focus":function($event){return $event.target.select()}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' + filterIndex,"name":filterIndex,"inputmode":_vm.interactive_filter_input_mode(filter),"placeholder":filter.placeholder,"type":filter.type},domProps:{"value":filter.value,"value":(filter.value)},on:{"change":function($event){return _vm.interactive_filter_format_value(filter)},"focus":function($event){return $event.target.select()},"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),('epass_wertklasse' === filterIndex)?_vm._l((filter.options),function(arr_label_value,index){return _c('div',{staticClass:"single-interactive-input-wrapper",class:_vm.interactive_filter_cb_status_class(filter, arr_label_value.value)},[_c('div',{staticClass:"single-epass-pair",class:arr_label_value.value.replace('a+', 'a-plus')},[((filter.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' +
              arr_label_value.value.replace('a+', 'a-plus'),"name":filterIndex,"type":"checkbox"},domProps:{"value":arr_label_value.value,"checked":Array.isArray(filter.value)?_vm._i(filter.value,arr_label_value.value)>-1:(filter.value)},on:{"change":[function($event){var $$a=filter.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=arr_label_value.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "value", $$c)}},function($event){return _vm.handleCheckboxChange(filter, $event)}]}}):((filter.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' +
              arr_label_value.value.replace('a+', 'a-plus'),"name":filterIndex,"type":"radio"},domProps:{"value":arr_label_value.value,"checked":_vm._q(filter.value,arr_label_value.value)},on:{"change":[function($event){return _vm.$set(filter, "value", arr_label_value.value)},function($event){return _vm.handleCheckboxChange(filter, $event)}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":'single-interactive-option-' +
              arr_label_value.value.replace('a+', 'a-plus'),"name":filterIndex,"type":filter.type},domProps:{"value":arr_label_value.value,"value":(filter.value)},on:{"change":function($event){return _vm.handleCheckboxChange(filter, $event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":'single-interactive-option-' +
              arr_label_value.value.replace('a+', 'a-plus')},domProps:{"innerHTML":_vm._s(arr_label_value.label)}})])])}):_vm._e()],2)}),_vm._v(" "),(_vm.geoWerftData.show_more_filter)?_c('div',{staticClass:"interactive-filter-show-more-button inactive",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.show_more_filter.label.inactive)},on:{"click":function($event){return _vm.trigger_show_more_filter_actions(_vm.geoWerftData.show_more_filter, $event)}}}):_vm._e(),_vm._v(" "),(_vm.geoWerftData.show_dialog_filter)?_c('div',{staticClass:"interactive-filter-open-dialog no-filters-set",domProps:{"innerHTML":_vm._s(_vm.geoWerftData.show_dialog_filter.label)},on:{"click":function($event){return _vm.show_dialog_filter()}}}):_vm._e(),_vm._v(" "),(_vm.geoWerftData.show_dialog_filter)?_c('dialog',{staticClass:"mw-block-modal mw-show-map-app-filter",attrs:{"tabindex":"-1","id":"mw-interactive-show-all-filter-dialog-wrapper"}},[_c('div',{attrs:{"id":"mw-interactive-show-all-filter-dialog"}},[_c('div',{staticClass:"ben-modal-close-wrapper",attrs:{"onclick":"this.closest( 'dialog' ).close();"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.show_dialog_filter.icon)}})]),_vm._v(" "),_c('button',{staticClass:"mw_interactive_filter_close_btn",attrs:{"onclick":"this.closest( 'dialog' ).close();"},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.show_more_filter_close_btn_label)}})]):_vm._e(),_vm._v(" "),(true === _vm.geoWerftData.display_map_list_switch)?_c('div',{staticClass:"mw-geo-advanced-filter-map-list-switch-wrapper"},[_c('div',{staticClass:"geowerft-switcher-buttons-wrapper"},[_c('div',{staticClass:"geowerft-switcher-buttons-inner"},[_c('button',{staticClass:"geowerft-switcher-tablinks geowerft-switcher-left",on:{"click":function($event){return _vm.handle_listen_click(1, true, _vm.geoWerftData.filter, 'list')}}},[_vm._v("\n          Listenansicht\n        ")]),_vm._v(" "),_c('button',{staticClass:"geowerft-switcher-tablinks geowerft-switcher-right active",on:{"click":function($event){return _vm.handle_listen_click(_vm.init_zoom, false, _vm.geoWerftData.filter, 'map')}}},[_vm._v("\n          Kartenansicht\n        ")])])])]):_vm._e()],2):_c('div',{staticClass:"object-filter-wrapper"},[_c('ul',{staticClass:"object-filter",class:(_vm.geoWerftData.checkboxes.display_marketing_method &&
        _vm.geoWerftData.extra_class) ||
      (_vm.geoWerftData.checkboxes.list_map_switcher &&
        _vm.display_filter &&
        'geolagen-select')},[_vm._l((_vm.geoWerftData.filter),function(filter,filterIndex){return _c('li',{staticClass:"go-filters-art",class:filterIndex},[(filter.options)?[_c('label',{attrs:{"for":filterIndex}},[_vm._v(_vm._s(filter.label))]),_vm._v(" "),(filterIndex === 'regio')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],class:false === _vm.display_filter ? 'mw-hide' : 'show',attrs:{"id":filterIndex,"name":filterIndex},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.handel_option_click(filter.value)}]}},[(filter.label !== '')?_c('option',{attrs:{"value":"","selected":"selected"}},[_vm._v("\n            "+_vm._s(filter.label)+" wählen\n          ")]):_vm._e(),_vm._v(" "),_vm._l((filter.options),function(option,optionIndex){return _c('option',{domProps:{"value":optionIndex}},[_vm._v("\n            "+_vm._s(option)+"\n          ")])})],2):_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":filterIndex,"name":filterIndex},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.handel_option_click(filterIndex, filter.value)}]}},[(filter.label !== '')?_c('option',{attrs:{"value":"","selected":"selected"}},[_vm._v("\n            "+_vm._s(filter.label)+" "+_vm._s(filter.extension)+"\n          ")]):_vm._e(),_vm._v(" "),_vm._l((filter.options),function(option,optionIndex){return _c('option',{domProps:{"value":optionIndex}},[_vm._v("\n            "+_vm._s(option)+"\n          ")])})],2)]:(filter.type && filter.type === 'checkbox')?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],attrs:{"id":filter.id,"type":"checkbox","name":filter.label.toLowerCase()},domProps:{"value":filter.option,"checked":Array.isArray(filter.value)?_vm._i(filter.value,filter.option)>-1:(filter.value)},on:{"change":function($event){var $$a=filter.value,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=filter.option,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(filter, "value", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(filter, "value", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(filter, "value", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":filter.id,"title":filter.label},domProps:{"innerHTML":_vm._s(filter.label)}},[_vm._v(_vm._s(filter.label))])]:(filter.input === 'kennung')?[_c('label',{attrs:{"for":filterIndex}},[_vm._v(_vm._s(filter.label))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],staticClass:"mw-geowerft-id-filter",attrs:{"id":filterIndex,"name":filterIndex,"placeholder":_vm.geoWerftData.kennung_filter_placeholder},domProps:{"value":(filter.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "value", $event.target.value)}}})]:(filter.input === 'energie')?[_c('label',{attrs:{"for":filterIndex}},[_vm._v(_vm._s(filter.label))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(filter.value),expression:"filter.value"}],staticClass:"mw-geowerft-energie-filter",attrs:{"id":filterIndex,"name":filterIndex},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(filter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"selected","value":""},domProps:{"innerHTML":_vm._s(_vm.geoWerftData.energie_filter_placeholder)}}),_vm._v(" "),_c('option',{attrs:{"value":"A+"}},[_vm._v("bis A+")]),_vm._v(" "),_c('option',{attrs:{"value":"A"}},[_vm._v("bis A")]),_vm._v(" "),_c('option',{attrs:{"value":"B"}},[_vm._v("bis B")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("bis C")]),_vm._v(" "),_c('option',{attrs:{"value":"D"}},[_vm._v("bis D")]),_vm._v(" "),_c('option',{attrs:{"value":"E"}},[_vm._v("bis E")]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v("bis F")]),_vm._v(" "),_c('option',{attrs:{"value":"G"}},[_vm._v("bis G")]),_vm._v(" "),_c('option',{attrs:{"value":"H"}},[_vm._v("bis H")])])]:[_c('ul',{staticClass:"geo-filters",class:_vm.geoWerftData.checkboxes.display_marketing_method &&
            _vm.geoWerftData.extra_class_nums},[_c('li',[_c('label',{attrs:{"for":filterIndex + '-min'}},[_vm._v(_vm._s(filter.label)+"\n              "),_c('span',{staticClass:"hidden",attrs:{"aria-readonly":"true"}},[_vm._v(" von")])]),_vm._v(" "),(
                [
                  _vm.geoWerftData.texts.filter_label_price,
                  _vm.geoWerftData.texts.filter_label_price_buy,
                  _vm.geoWerftData.texts.filter_label_price_rent,
                  _vm.geoWerftData.texts.filter_adults_label,
                  _vm.geoWerftData.texts.filter_children_label ].includes(filter.label)
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.min),expression:"filter.value.min",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-min',"name":filterIndex + '-min',"placeholder":_vm.get_pre_filter_labels(filter.label, 'von') +
                filter.price_min_extension,"title":_vm.get_pre_filter_labels(filter.label, 'von') +
                filter.price_min_extension,"min":"0"},domProps:{"value":(filter.value.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "min", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e(),_vm._v(" "),(
                filter.label.toLowerCase() ===
                _vm.geoWerftData.texts.filter_label_rooms.toLowerCase()
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.min),expression:"filter.value.min",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-min',"name":filterIndex + '-min',"placeholder":_vm.get_pre_filter_labels(filter.label, 'von') +
                filter.rooms_min_extension,"min":"0"},domProps:{"value":(filter.value.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "min", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e(),_vm._v(" "),(
                [
                  _vm.geoWerftData.texts.filter_label_space,
                  _vm.geoWerftData.texts.filter_space_label_house,
                  _vm.geoWerftData.texts.filter_space_label_grundstueck,
                  _vm.geoWerftData.texts.filter_space_label_gewerbe,
                  _vm.geoWerftData.texts.filter_space_label_invest ].includes(filter.label)
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.min),expression:"filter.value.min",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-min',"name":filterIndex + '-min',"placeholder":_vm.get_pre_filter_labels(filter.label, 'von') +
                filter.space_min_extension,"min":"0"},domProps:{"value":(filter.value.min)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "min", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e()]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":filterIndex + '-max'}},[_c('span',{staticClass:"hidden",attrs:{"aria-readonly":"true"}},[_vm._v(" bis")])]),_vm._v(" "),(
                [
                  _vm.geoWerftData.texts.filter_label_price,
                  _vm.geoWerftData.texts.filter_label_price_buy,
                  _vm.geoWerftData.texts.filter_label_price_rent,
                  _vm.geoWerftData.texts.filter_adults_label,
                  _vm.geoWerftData.texts.filter_children_label ].includes(filter.label)
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.max),expression:"filter.value.max",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-max',"name":filterIndex + '-max',"placeholder":filter.pre_max ? filter.pre_max : filter.price_max_extension,"title":filter.pre_max ? filter.pre_max : filter.price_max_extension,"min":"0"},domProps:{"value":(filter.value.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "max", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e(),_vm._v(" "),(
                filter.label.toLowerCase() ===
                _vm.geoWerftData.texts.filter_label_rooms.toLowerCase()
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.max),expression:"filter.value.max",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-max',"name":filterIndex + '-max',"placeholder":_vm.get_pre_filter_labels('', 'bis') + filter.rooms_max_extension,"min":"0"},domProps:{"value":(filter.value.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "max", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e(),_vm._v(" "),(
                [
                  _vm.geoWerftData.texts.filter_label_space,
                  _vm.geoWerftData.texts.filter_space_label_house,
                  _vm.geoWerftData.texts.filter_space_label_grundstueck,
                  _vm.geoWerftData.texts.filter_space_label_gewerbe,
                  _vm.geoWerftData.texts.filter_space_label_invest ].includes(filter.label)
              )?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(filter.value.max),expression:"filter.value.max",modifiers:{"number":true}}],attrs:{"type":"number","value":"","step":_vm.get_correct_step(filter.label),"id":filterIndex + '-max',"name":filterIndex + '-max',"placeholder":_vm.get_pre_filter_labels('', 'bis') + filter.space_max_extension,"min":"0"},domProps:{"value":(filter.value.max)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter.value, "max", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.geoWerftData.filter[filterIndex].max))])])])]],2)}),_vm._v(" "),(_vm.geoWerftData.checkboxes.list_map_switcher)?_c('li',{staticClass:"list-map-switcher mw-geo-remove-scroll-bar"},[_c('div',{staticClass:"geowerft-switcher-buttons-wrapper"},[_c('div',{staticClass:"geowerft-switcher-buttons-inner"},[_c('button',{staticClass:"geowerft-switcher-tablinks geowerft-switcher-left",on:{"click":function($event){return _vm.handle_listen_click(1, true, _vm.geoWerftData.filter, 'list')}}},[_vm._v("\n            Listenansicht\n          ")]),_vm._v(" "),_c('button',{staticClass:"geowerft-switcher-tablinks geowerft-switcher-right active",on:{"click":function($event){return _vm.handle_listen_click(
                _vm.init_zoom,
                false,
                _vm.geoWerftData.filter,
                'map'
              )}}},[_vm._v("\n            Kartenansicht\n          ")])])])]):_vm._e(),_vm._v(" "),_c('li',[_c('button',{staticStyle:{"float":"right"},on:{"click":function($event){return _vm.geolocate()}}},[_vm._v("Mein Standort")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = can_use_ccm_with_map;
function can_use_ccm_with_map() {
  var can_use_ccm = false;
  if (window.CCM) {
    window.CCM.acceptedEmbeddings.forEach(function (item) {
      if ("Google Maps" === item.name) {
        can_use_ccm = true;
      }
    });
  }

  return can_use_ccm;
}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = ["Gewerbe", "Büro / Praxis / Ausstellungsräume", "Büro/Praxen", "Atelier", "Loft", "Büro", "Büroetage", "Bürozentrum", "Bürohaus", "Büro& Lagergebäude", "Büro- u. Geschäftsgebäude", "Büro- und Geschäftsgebäude", "Büro- und Praxisflächen", "Praxis", "Praxisetage", "Praxishaus", "Wohn- u. Geschäftsgebäude", "Bürofläche", "Gewerbeflächen"];

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = ["Gewerbe", "Läden/SB-Märkte", "Ausstellungsfläche", "SB-Markt", "Einkaufszentrum", "Kaufhaus", "Verkaufshalle", "Factory Outlet", "Kiosk", "Laden", "Verkaufsfläche", "Büro / Praxis / Ausstellungsräume", "Büro/Praxen", "Büro/Praxis", "Atelier", "Loft", "Büro", "Büroetage", "Bürozentrum", "Bürohaus", "Büro& Lagergebäude", "Büro- u. Geschäftsgebäude", "Büro- und Geschäftsgebäude", "Büro- und Praxisflächen", "Ladenflächen", "Gewerbezentrum", "Praxis", "Praxisetage", "Praxishaus", "Wohn- u. Geschäftsgebäude", "Prod./ Lager / Gewerbehallen", "Ausstellungsfläche (Produktion)", "Halle", "Industriehalle", "Industriehalle mit Freifläche", "Lagerfläche", "Lager mit Freifläche", "Lagerhalle", "Hochregallager", "Kühlhaus", "Kühlregallager", "Speditionslager", "Servicefläche", "Werkstatt", "Gastronomie / Beherbergungen", "Bar", "Cafe", "Diskothek", "Ferienbungalows", "Gaststätte", "Gästehaus", "Hotel", "Hotelanwesen", "Hotel garni", "Pension", "Restaurant", "Land- / Forstwirtschaft", "Anwesen", "Bauernhof", "Reiterhof", "Weingut", "Sonstige Objekte", "Freizeitanlage", "Gewerbefläche", "Gewerbeeinheit", "Gewerbepark", "Gewerbezentrum", "Spezialobjekt", "Werkstatt", "Werkstatt (Produktion)", "Gastgewerbe", "Laden/Einzelhandel", "Hallen/Lager/Produktion", "Land/Forstwirtschaft", "Bürofläche", "Gewerbeflächen", "Produktions- und Lagerflächen"];

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = ["Läden/SB-Märkte", "Ausstellungsfläche", "SB-Markt", "Einkaufszentrum", "Kaufhaus", "Verkaufshalle", "Factory Outlet", "Kiosk", "Laden", "Verkaufsfläche", "Ladenflächen", "Gewerbezentrum", "Servicefläche", "Gastronomie / Beherbergungen", "Bar", "Cafe", "Diskothek", "Laden/Einzelhandel"];

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = ["Wohnungen", "Dachgeschosswohnung", "Etagenwohnung", "Erdgeschosswohnung", "Hochparterre", "Hochpaterre", "Loftwohnung", "Maisonettewohnung", "Penthouse", "Souterrain", "Terrassenwohnung", "sonstiger Wohnungstyp", "Appartment", "Apartment", "Wohnung", "Zimmer", "WG-Zimmer", "Dachgeschoss", "Erdgeschoss", "Loft", "Maisonette", "Penthouse", "Sonstige", "Souterrain", "Terrassenwohnung", "Zwangsversteigerung", "Eigentumswohnung"];

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = ["Häuser", "Bungalow", "Burg/Schloss", "Doppelhaushälfte", "Zweifamilienhaus", "Einfamilienhaus mit Einliegerwohnung", "Einfamilienhaus", "Bauernhaus", "Mehrfamilienhaus", "Reihenhaus", "Reiheneckhaus", "Reihenendhaus", "Reihenmittelhaus", "sonstige Häuser", "Villa", "besondere Immobilie", "Haus", "Ein/Mehrfamilienhaus", "Typenhäuser", "Blockhaus", "Doppelhaus", "EinfamilienhausMitEinliegerwohnung", "Fachwerkhaus", "Holzhaus", "Landhaus", "Mehrfamilienhaus", "Stadtvilla", "Finca", "Zweifamilienhaus"];

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = ["Investments", "Investment", "Anlage-/Investmentobjekte", "Bürogebäude (Invest.)", "Betreutes Wohnen (Invest)", "Laden/Verkaufsfläche (Invest.)", "Geschäftshaus (Invest.)", "Supermarkt (Invest.)", "Einkaufszentrum (Invest.)", "Gaststätte (Invest.)", "Hotel (Invest.)", "Halle/Lager (Invest.)", "Gewerbeanwesen (Invest.)", "Gewerbeeinheit (Invest.)", "Industrieanwesen (Invest.)", "Freizeitanlage (Invest.)", "Pflegeheim (Invest)", "Servicecenter (Invest.)", "Seniorenheim (Invest)", "Eigentumswohnung (Invest.)", "Einfamilienhaus (Invest.)", "Mehrfamilienhaus (Invest.)", "Wohnanlage (Invest.)", "Wohn-/Geschäftshaus (Invest.)", "Sonstiges (Invest.)", "Gewerbe/Anlage", "Zins und Renditeobjekt", "Zins und Renditehäuser", "Sonstige", "Anlageobjekt"];

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = ["Prod./ Lager / Gewerbehallen", "Ausstellungsfläche (Produktion)", "Halle", "Industriehalle", "Industriehalle mit Freifläche", "Lagerfläche", "Lager mit Freifläche", "Lagerhalle", "Hochregallager", "Kühlhaus", "Kühlregallager", "Speditionslager", "Werkstatt", "Gewerbefläche", "Gewerbeeinheit", "Gewerbepark", "Gewerbezentrum", "Spezialobjekt", "Werkstatt", "Werkstatt (Produktion)", "Hallen/Lager/Produktion", "Produktions- und Lagerflächen"];

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = ["Garage Stellplatz", "Carport", "Duplex", "Garage", "Parkhausstellplatz", "Stellplatz", "Tiefgaragenstellplatz", "Garage/Sonstige", "Parken"];

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = ["Grundstücke", "Baugrund für Ein- / Zweifamilienhäuser", "Baugrund für Freizeit", "Baugrund für Gewerbe", "Grundstück Land und Forstwirtschaft", "Grundstück"];

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = ["Resthöfe", "Resthof", "Rest"];

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = ["Villa"];

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mw_set_main_geo_class(),attrs:{"id":"geowerft-full-wrapper"}},[(_vm.geoWerftData.hasError)?_c('div',{staticClass:"message",staticStyle:{"color":"red","font-weight":"bold","font-size":"300%"}},[_vm._v("\n    "+_vm._s(_vm.geoWerftData.hasError)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.geoWerftData.texts.map_h1)?_c('div',{staticClass:"geowerft-h1-wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.geoWerftData.texts.map_h1))])]):_vm._e(),_vm._v(" "),_c('object-filter',{attrs:{"geoWerftData":_vm.geoWerftData}}),_vm._v(" "),(true === _vm.geoWerftData.map_enabled)?_c('object-map',{attrs:{"geoWerftData":_vm.geoWerftData}}):_vm._e(),_vm._v(" "),(false === _vm.geoWerftData.map_enabled)?_c('div',{staticClass:"geowerft-consent-wrapper",attrs:{"data-nosnippet":"true"}},[_c('div',{staticClass:"mw-disable-google-maps-wrapper"},[_c('div',{staticClass:"mw-disable-google-maps"},[_c('p',{staticClass:"mw-consent-management-info-text"},[_vm._v("\n          "+_vm._s(_vm.geoWerftData.texts.consent_text_normal)+"\n        ")]),_vm._v(" "),_c('div',{class:_vm.get_consent_reset_class(),on:{"click":function($event){return _vm.do_cookie_consent()}}},[_vm._v("\n          "+_vm._s(_vm.geoWerftData.texts.consent_button_label)+"\n        ")])])])]):_vm._e(),_vm._v(" "),_c('object-list',{attrs:{"geoWerftData":_vm.geoWerftData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js